var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "550 0 1575 2050",
    width: 675,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9756,
    y1: 1754.3684,
    x2: 2401.0764,
    y2: 154.4974,
    gradientTransform: "matrix(0.9992 -0.0395 0.038 0.9617 -130.119 135.0828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2274.877,725.075c-58.766-81.803-178.058-122.168-186.1-247.909 c-3.045-47.617,28.651-87.223,11.862-133.366c-112.638-309.542-577.761-75.988-779.695-1.654 c-84.085,30.952-184.771,65.706-276.513,65.293c-105.613-0.475-205.708-50.891-310.472-56.958 c-32.274-1.869-62.208,2.009-89.991,10.925c-104.151,33.424-192.792,146.992-222.984,270.468 c-24.474,100.094,15.646,196.366-25.093,295.045c-43.422,105.179-134.133,180.625-152.992,300.819 c-22.635,144.259,90.354,264.472,206.599,263.781c73.992-0.439,210.457-18.655,271.28-70.599 c74.06-63.248,149.029-70.176,238.23-71.387c169.757-2.304,340.969,32.402,509.53,55.27 c144.435,19.595,287.289,51.418,432.847,50.428c106.897-0.727,197.56-2.736,250.361-130.821 C2214.857,1171.318,2398.147,896.671,2274.877,725.075z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#BDD0FB"
    },
    d: "M2000.253,1482.907c80.023,15.376,316.345,25.016,403.455-367.177 c2.473-11.136-11.386-18.354-19.038-9.894c-35.842,39.628-99.596,106.999-153.765,127.73 c-167.824,64.229-228.578,167.553-248.624,215.946C1976.344,1463.844,1985.018,1479.979,2000.253,1482.907z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076582116436098484200000016185523122116433554_",
    gradientUnits: "userSpaceOnUse",
    x1: 1988.0382,
    y1: 1344.0928,
    x2: 2337.605,
    y2: 1344.0928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "url(#SVGID_00000076582116436098484200000016185523122116433554_)"
    },
    d: "M1992.513,1472.904 c-1.939,0-3.726-1.272-4.295-3.228c-0.691-2.373,0.674-4.858,3.047-5.549c116.789-33.961,202.524-99.291,253.882-148.117 c55.622-52.878,83.896-98.157,84.176-98.607c1.299-2.105,4.059-2.751,6.161-1.453c2.102,1.3,2.751,4.06,1.451,6.161 c-0.285,0.461-29.171,46.721-85.619,100.388c-52.078,49.508-139.035,115.76-257.551,150.226 C1993.348,1472.845,1992.927,1472.904,1992.513,1472.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#91B3FA"
    },
    d: "M2182.82,814.561c9.104,73.226,54.638,524.76-185.512,668.842 c-7.271,4.362-16.6-0.495-17.212-8.951c-3.897-53.818-6.33-224.841,92.444-426.685c71.266-145.631,97.388-211.282,105.623-233.74 C2179.035,811.649,2182.507,812.048,2182.82,814.561z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#BDD0FB"
    },
    d: "M1980.091,1478.927c-0.722,0-1.454-0.175-2.134-0.544c-2.171-1.18-2.974-3.899-1.793-6.071 c121.093-222.619,171.847-486.173,172.038-499.235c-0.31-2.137,0.967-4.244,3.094-4.911c2.358-0.728,4.87,0.575,5.608,2.935 c2.928,9.358-52.294,283.806-172.877,505.489C1983.215,1478.081,1981.679,1478.927,1980.091,1478.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#BDD0FB"
    },
    d: "M558.842,1068.098c0,0,75.14-121.589,37.672-187.849 c-37.468-66.26-133.37-150.127-33.735-329.554c58.33-105.044,82.305-151.866,92.158-172.635 c3.843-8.101,14.337-10.312,21.102-4.427C723.893,415.264,874.205,559.294,841,700.011 C801.635,866.833,558.842,1068.098,558.842,1068.098z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136388369458923427100000013782692203627034512_",
    gradientUnits: "userSpaceOnUse",
    x1: 584.5373,
    y1: 740.3935,
    x2: 720.9924,
    y2: 740.3935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "url(#SVGID_00000136388369458923427100000013782692203627034512_)"
    },
    d: "M688.933,447.233 c0,0,0.764,2.28,2.095,6.645c1.294,4.34,3.207,10.702,5.265,18.886c2.082,8.179,4.498,18.141,6.917,29.644 c1.226,5.749,2.523,11.871,3.696,18.359c0.59,3.245,1.196,6.573,1.816,9.98c0.549,3.419,1.111,6.917,1.685,10.489 c0.567,3.574,1.146,7.224,1.737,10.943c0.501,3.732,1.011,7.533,1.53,11.4c0.496,3.871,1,7.808,1.512,11.807 c0.416,4.009,0.838,8.078,1.266,12.205c0.414,4.128,0.893,8.309,1.27,12.55c0.325,4.246,0.654,8.545,0.987,12.889 c0.294,4.348,0.666,8.74,0.901,13.182c0.19,4.445,0.381,8.933,0.575,13.458c0.174,4.526,0.429,9.089,0.541,13.689 c0.055,4.603,0.111,9.237,0.168,13.9c0.054,4.664,0.12,9.357,0.097,14.074c-0.121,4.715-0.242,9.455-0.364,14.214 c-0.123,4.759-0.246,9.537-0.369,14.33c-0.286,4.786-0.572,9.587-0.859,14.397c-0.291,4.81-0.583,9.631-0.875,14.455 l-0.11,1.811l-0.09,1.036l-0.091,0.894l-0.363,3.576l-0.727,7.155c-2.191,19.482-5.669,38.722-10.158,57.357 c-4.54,18.638-10.148,36.67-16.358,53.807c-6.187,17.151-13.187,33.329-20.308,48.41c-7.116,15.09-14.592,28.978-21.833,41.584 c-7.22,12.622-14.406,23.849-20.975,33.656c-6.578,9.804-12.59,18.159-17.678,24.944c-5.07,6.799-9.325,11.944-12.234,15.461 c-1.483,1.746-2.62,3.085-3.386,3.987c-0.804,0.917-1.22,1.389-1.22,1.389c-1.758,2.003-4.807,2.202-6.81,0.443 c-1.933-1.697-2.185-4.597-0.618-6.598l0.09-0.115c0,0,0.352-0.448,1.035-1.316c0.69-0.907,1.714-2.253,3.05-4.008 c2.666-3.536,6.445-8.851,11.188-15.666c4.724-6.83,10.302-15.244,16.378-25.095c6.084-9.846,12.615-21.157,19.427-33.652 c6.79-12.508,13.657-26.313,20.416-41.128c6.753-14.818,13.156-30.753,19.108-47.452c5.932-16.707,11.195-34.264,15.528-52.327 c4.391-18.062,7.779-36.633,9.922-55.264l0.742-7.154l0.371-3.575l0.162-1.648l0.128-1.775 c0.343-4.735,0.685-9.465,1.027-14.185c0.339-4.722,0.677-9.433,1.015-14.132c0.177-4.708,0.353-9.404,0.528-14.079 c0.176-4.677,0.352-9.335,0.526-13.97c0.041-4.639,0.082-9.255,0.123-13.842c0.047-4.589,0.093-9.151,0.139-13.68 c-0.01-4.529-0.163-9.025-0.235-13.485c-0.091-4.461-0.182-8.885-0.271-13.266c-0.134-4.381-0.408-8.714-0.6-13.005 c-0.19-4.292-0.377-8.538-0.562-12.733c-0.237-4.193-0.577-8.326-0.854-12.41c-0.291-4.085-0.578-8.112-0.861-12.08 c-0.378-3.959-0.751-7.859-1.117-11.693c-0.355-3.838-0.703-7.611-1.046-11.314c-0.428-3.694-0.848-7.319-1.26-10.869 c-0.418-3.551-0.827-7.029-1.227-10.428c-0.47-3.39-0.928-6.701-1.376-9.929c-0.801-6.474-1.745-12.586-2.64-18.331 c-1.756-11.496-3.595-21.469-5.201-29.66c-1.634-8.186-2.97-14.607-3.957-18.963c-0.983-4.324-1.576-6.642-1.576-6.642 c-0.375-1.465,0.508-2.957,1.974-3.333c1.398-0.357,2.819,0.429,3.274,1.773L688.933,447.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#91B3FA"
    },
    d: "M593.024,1276.503c9.261,7.137-70.87-150.172-61.339-369.696 c4.492-103.445,29.827-229.044-17.416-289.042c-39.318-49.935-206.16-57.4-261.024-58.499c-6.856-0.137-10.78,7.76-6.513,13.128 c21.034,26.465,65.077,87.757,68.914,141.278c5.057,70.545,59.884,125.915,114.363,148.964 c54.479,23.049,83.816,40.63,93.012,137.123C532.217,1096.251,566.709,1256.224,593.024,1276.503z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#BDD0FB"
    },
    d: "M321.922,602.581c0,0,1.63,0.344,4.588,1.113c2.963,0.785,7.305,1.948,12.726,3.755 c5.424,1.795,11.958,4.141,19.315,7.199c7.347,3.07,15.572,6.754,24.201,11.462c8.644,4.671,17.783,10.196,27.007,16.725 c9.208,6.539,18.557,14.035,27.378,22.737c8.815,8.696,17.18,18.499,24.533,29.301c7.316,10.82,13.57,22.637,18.428,35.012 l1.763,4.664c0.61,1.547,1.169,3.111,1.628,4.708c0.973,3.171,1.984,6.342,2.867,9.518c1.655,6.235,3.304,12.446,4.94,18.609 c1.586,6.195,3.159,12.341,4.713,18.413c1.467,6.09,2.916,12.105,4.341,18.021c2.803,11.844,5.404,23.318,7.698,34.236 c2.322,10.913,4.408,21.253,6.199,30.825c0.882,4.788,1.727,9.377,2.531,13.742c0.734,4.377,1.431,8.53,2.086,12.432 c1.259,7.813,2.315,14.63,3.128,20.255c0.84,5.62,1.367,10.057,1.733,13.085c0.348,3.038,0.534,4.658,0.534,4.658 c0.119,1.033-0.623,1.966-1.656,2.085c-0.986,0.112-1.881-0.557-2.064-1.517l-0.009-0.049c0,0-0.297-1.582-0.854-4.549 c-0.589-2.971-1.452-7.329-2.551-12.875c-2.175-11.1-5.661-26.887-9.912-45.806c-2.204-9.442-4.592-19.671-7.118-30.488 c-2.653-10.788-5.451-22.163-8.345-33.931c-3.033-11.726-6.167-23.844-9.352-36.156c-1.66-6.155-3.333-12.359-5.012-18.589 c-0.855-3.035-1.843-6.015-2.73-9.041c-0.421-1.519-0.942-3.006-1.513-4.475l-1.642-4.434 c-9.03-23.578-23.584-44.824-40.255-61.781c-8.323-8.504-17.04-16.112-25.8-22.707c-8.75-6.612-17.486-12.275-25.788-17.102 c-8.322-4.792-16.123-8.925-23.201-12.264c-7.069-3.36-13.378-5.988-18.622-8.019c-5.248-2.019-9.407-3.524-12.266-4.46 c-2.866-0.951-4.382-1.377-4.382-1.377c-0.804-0.226-1.272-1.061-1.046-1.865c0.217-0.77,0.992-1.233,1.764-1.072 L321.922,602.581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "#BDD0FB"
    },
    d: "M587.845,1272.501c6.646,3.065-40.156-68.467-46.899-133.32 c-6.744-64.853-27.307-175.061-86.91-238.475c-59.602-63.414-121.333-66.21-195.507-1.746 c-61.812,53.721-100.686,81.239-124.025,87.211c-5.779,1.479-8.41,8.231-5.289,13.314 c16.609,27.059,62.783,88.786,134.365,80.467c91.308-10.612,199.173-76.063,235.651-28.178 c36.478,47.885,33.609,75.914,35.899,99.403C537.419,1174.669,543.862,1252.215,587.845,1272.501z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136374324864885473280000013696163526002075530_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.3056,
    y1: 998.2628,
    x2: 528.4302,
    y2: 998.2628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animated-path",
    style: {
      fill: "url(#SVGID_00000136374324864885473280000013696163526002075530_)"
    },
    d: "M288.788,977.319 c0,0,0.907-0.95,2.608-2.732c1.712-1.756,4.262-4.284,7.651-7.348c6.758-6.139,16.84-14.515,30.195-22.94 c6.69-4.18,14.221-8.328,22.605-11.965c8.393-3.58,17.644-6.705,27.674-8.366c2.49-0.482,5.064-0.659,7.632-0.961 c1.297-0.066,2.599-0.132,3.905-0.198c1.305-0.085,2.619-0.108,3.943-0.054c1.322,0.034,2.648,0.068,3.977,0.101l3.998,0.367 c1.34,0.085,2.668,0.339,4.001,0.562c1.375,0.264,2.578,0.367,4.102,0.771c9.687,2.177,20.386,5.654,30.037,10.005 c9.688,4.622,18.769,10.458,26.931,17.154c1.942,1.78,3.876,3.552,5.8,5.317c0.945,0.898,1.949,1.734,2.835,2.678l2.618,2.855 c1.719,1.913,3.511,3.748,5.131,5.694c1.541,2.008,3.071,4.001,4.589,5.978c0.753,0.99,1.503,1.977,2.25,2.959 c0.673,1.029,1.343,2.055,2.01,3.076c1.331,2.041,2.649,4.063,3.953,6.062c2.463,4.077,4.629,8.198,6.841,12.144 c1.917,4.086,3.781,8.059,5.585,11.903c1.652,3.9,3.106,7.721,4.575,11.356c0.755,1.811,1.408,3.615,1.971,5.401 c0.592,1.777,1.17,3.512,1.733,5.204c1.101,3.39,2.268,6.565,3.061,9.638c0.847,3.055,1.64,5.915,2.373,8.558 c0.746,2.639,1.403,5.067,1.879,7.291c1.998,8.858,3.14,13.921,3.14,13.921c0.204,0.904-0.364,1.802-1.268,2.005 c-0.86,0.195-1.716-0.31-1.972-1.139l-0.021-0.068c0,0-1.506-4.919-4.141-13.529c-1.222-4.328-3.195-9.424-5.16-15.352 c-0.937-2.982-2.249-6.036-3.502-9.301c-1.332-3.231-2.493-6.73-4.152-10.18c-1.58-3.483-3.148-7.147-4.906-10.866 c-1.896-3.642-3.856-7.407-5.871-11.278c-2.278-3.705-4.448-7.617-6.923-11.435c-1.298-1.865-2.61-3.751-3.935-5.654 c-0.661-0.952-1.325-1.908-1.992-2.868c-0.734-0.905-1.472-1.814-2.213-2.727c-1.484-1.82-2.981-3.656-4.489-5.506 c-1.559-1.798-3.269-3.478-4.908-5.241l-2.492-2.628c-0.842-0.869-1.795-1.623-2.689-2.443 c-1.817-1.609-3.643-3.225-5.476-4.847c-7.701-6.045-16.158-11.28-25.13-15.552c-9.239-4.027-18.239-6.975-28.405-9.226 c-4.415-0.897-9.234-1.66-13.879-1.629c-1.167-0.063-2.335-0.051-3.502,0.017c-1.166,0.049-2.329,0.097-3.487,0.145 c-2.314,0.262-4.622,0.386-6.893,0.812c-9.122,1.318-17.821,3.945-25.82,7.131c-8.046,3.091-15.414,6.764-22.049,10.471 c-6.671,3.656-12.575,7.428-17.755,10.862c-5.176,3.444-9.557,6.659-13.145,9.336c-3.567,2.703-6.326,4.893-8.187,6.402 c-1.828,1.531-2.803,2.347-2.803,2.347l-0.056,0.047c-0.738,0.618-1.839,0.521-2.457-0.218 C288.136,978.955,288.182,977.953,288.788,977.319z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137096112813058285730000002888676050821302965_",
    gradientUnits: "userSpaceOnUse",
    x1: 1965.983,
    y1: 55.6113,
    x2: 969.9829,
    y2: 1363.6119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137096112813058285730000002888676050821302965_)"
    },
    d: "M1533.356,695.19 c-0.269,18.47-23.976,38.153-51.368,38.153s-48.101-14.436-49.596-32.847c-3.566-43.917,22.205-43.459,49.596-43.459 S1534.021,649.541,1533.356,695.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005984825994636437210000007363083681499599005_",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.0392,
    y1: 50.323,
    x2: 963.0397,
    y2: 1358.3226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005984825994636437210000007363083681499599005_)"
    },
    d: "M1553.49,668.231 c0.805,9.992-29.531,20.59-67.758,23.672c-38.227,3.082-69.87-2.519-70.675-12.511c-0.806-9.992,29.531-20.59,67.758-23.673 C1521.042,652.637,1552.684,658.239,1553.49,668.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041261891431212125720000006120036286656569743_",
    gradientUnits: "userSpaceOnUse",
    x1: 1950.5717,
    y1: 43.876,
    x2: 954.5743,
    y2: 1351.8729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041261891431212125720000006120036286656569743_)"
    },
    d: "M1553.49,650.664 c0.805,9.991-29.531,20.59-67.758,23.672c-38.227,3.082-69.87-2.519-70.675-12.511c-0.806-9.992,29.531-20.59,67.758-23.672 C1521.042,635.071,1552.684,640.672,1553.49,650.664z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015341780805421653930000016616827649742012325_",
    gradientUnits: "userSpaceOnUse",
    x1: 1942.1045,
    y1: 37.4287,
    x2: 946.1062,
    y2: 1345.4269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015341780805421653930000016616827649742012325_)"
    },
    d: "M1553.49,633.097 c0.805,9.992-29.531,20.59-67.758,23.672c-38.227,3.082-69.87-2.519-70.675-12.511c-0.806-9.992,29.531-20.59,67.758-23.672 C1521.042,617.504,1552.684,623.105,1553.49,633.097z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101101430727678793630000012755026306512591512_",
    gradientUnits: "userSpaceOnUse",
    x1: 1933.6377,
    y1: 30.9809,
    x2: 937.6389,
    y2: 1338.9797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101101430727678793630000012755026306512591512_)"
    },
    d: "M1553.49,615.53 c0.805,9.992-29.531,20.59-67.758,23.672c-38.227,3.082-69.87-2.519-70.675-12.511c-0.806-9.992,29.531-20.59,67.758-23.672 C1521.042,599.937,1552.684,605.538,1553.49,615.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1465.126,693.675c-11.353,0-21.741-0.835-30.324-2.479c-0.498-0.095-0.824-0.576-0.729-1.074 c0.095-0.498,0.574-0.824,1.074-0.729c13.43,2.572,31.369,3.138,50.511,1.595c15.664-1.263,30.312-3.789,42.362-7.306 c0.488-0.142,0.997,0.137,1.139,0.624c0.142,0.487-0.137,0.997-0.624,1.139c-12.168,3.551-26.943,6.101-42.728,7.374 C1478.695,693.391,1471.747,693.675,1465.126,693.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1465.316,676.093c-14.751,0-27.933-1.388-37.231-4.035c-0.488-0.139-0.77-0.647-0.632-1.135 c0.14-0.488,0.645-0.77,1.135-0.632c13.249,3.773,34.583,4.942,57.069,3.13c22.243-1.794,42.986-6.307,55.49-12.074 c0.461-0.211,1.006-0.011,1.218,0.449c0.212,0.46,0.011,1.006-0.449,1.219c-12.689,5.852-33.666,10.427-56.111,12.236 C1478.801,675.816,1471.902,676.093,1465.316,676.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1465.127,658.539c-15.926,0-29.864-1.63-39.244-4.723c-0.482-0.159-0.743-0.678-0.585-1.159 c0.159-0.482,0.676-0.744,1.159-0.585c13.054,4.305,35.185,5.717,59.2,3.782c22.241-1.793,42.985-6.307,55.49-12.074 c0.461-0.211,1.006-0.011,1.218,0.449c0.212,0.46,0.011,1.006-0.449,1.218c-12.691,5.852-33.667,10.427-56.111,12.237 C1478.693,658.258,1471.739,658.539,1465.127,658.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1465.251,640.964c-12.634,0-24.125-1.021-33.058-3.006c-0.495-0.11-0.807-0.6-0.697-1.095 c0.11-0.495,0.602-0.808,1.095-0.697c13.433,2.985,32.775,3.758,53.066,2.122c22.043-1.777,42.681-6.242,55.207-11.944 c0.461-0.211,1.006-0.006,1.216,0.455c0.21,0.461,0.006,1.006-0.456,1.216c-12.708,5.785-33.576,10.31-55.819,12.103 C1478.777,640.684,1471.857,640.964,1465.251,640.964z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016767186178520212930000010907493908431503491_",
    gradientUnits: "userSpaceOnUse",
    x1: 1486.6769,
    y1: 281.5507,
    x2: 1468.3148,
    y2: 781.0007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "GroupBulb",
    style: {
      fill: "url(#SVGID_00000016767186178520212930000010907493908431503491_)"
    },
    d: "M1389.399,544.422 c-4.643-16.444-12.529-31.813-23.15-45.198c-22.757-28.681-59.882-87.01-64.452-166.619 c-6.647-115.795,96.05-173.768,189.762-165.898c93.712,7.87,186.182,77.646,176.059,185.37 c-6.229,66.283-43.328,116.56-70.951,145.433c-17.54,18.335-30.052,40.792-36.825,65.245 c-8.29,29.93-28.017,67.228-74.907,69.502C1424.26,635.199,1399.061,578.643,1389.399,544.422z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039095121712789562910000003268380521899257242_",
    gradientUnits: "userSpaceOnUse",
    x1: 1519.0646,
    y1: 457.0418,
    x2: 1532.53,
    y2: 884.8775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039095121712789562910000003268380521899257242_)"
    },
    d: "M1500.434,609.165l32.79-213.268 c0.677-4.406,2.846-7.365,4.843-6.609c1.997,0.756,3.067,4.94,2.39,9.346c-0.018,0.117-0.042,0.263-0.063,0.378l-37.35,211.286 c-0.281,1.589-1.088,2.592-1.802,2.241C1500.549,612.199,1500.198,610.703,1500.434,609.165z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145769489284950815570000004004915954547277458_",
    gradientUnits: "userSpaceOnUse",
    x1: 1444.8892,
    y1: 459.3764,
    x2: 1458.3547,
    y2: 887.2135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145769489284950815570000004004915954547277458_)"
    },
    d: "M1466.397,610.858l-32.79-213.268 c-0.677-4.406-2.846-7.365-4.843-6.609c-1.997,0.756-3.067,4.941-2.39,9.347c0.018,0.118,0.042,0.263,0.063,0.378l37.35,211.286 c0.281,1.589,1.088,2.592,1.802,2.241C1466.282,613.893,1466.632,612.397,1466.397,610.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182528881454476840570000002909862452067307932_",
    gradientUnits: "userSpaceOnUse",
    x1: 1436.7748,
    y1: 377.961,
    x2: 1533.3694,
    y2: 377.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182528881454476840570000002909862452067307932_)"
    },
    d: "M1532.988,377.586 c-0.833-1.339-2.76-1.84-4.305-1.118l-18.258,8.531l-6.338-18.058c-0.336-0.942-1.112-1.777-2.22-2.234 c-2.1-0.866-4.612-0.092-5.61,1.729l-0.032,0.059l-15.015,27.378l-13.933-38.973l-0.023-0.064 c-0.341-0.951-1.06-1.806-2.109-2.378c-2.337-1.276-5.423-0.667-6.894,1.358l-20.991,28.898c-0.854,1.184-0.56,2.771,0.74,3.647 c1.387,0.935,3.386,0.717,4.464-0.485l18.483-20.617l16.641,37.075l0.012,0.028c0.267,0.593,0.769,1.111,1.466,1.437 c1.562,0.731,3.511,0.227,4.355-1.127l16.059-25.77l6.044,13.034l0.053,0.116c0.044,0.094,0.094,0.186,0.15,0.277 c0.832,1.338,2.757,1.838,4.301,1.117l21.672-10.126C1533.244,380.596,1533.821,378.925,1532.988,377.586z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117666594235488754840000000843714834459262861_",
    gradientUnits: "userSpaceOnUse",
    x1: 1594.0256,
    y1: 454.1031,
    x2: 1616.2137,
    y2: 454.1031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117666594235488754840000000843714834459262861_)"
    },
    d: "M1597.38,469.212 c-0.696,0-1.398-0.214-1.999-0.662c-1.488-1.104-1.8-3.208-0.695-4.696c5.596-7.535,10.73-15.335,15.263-23.18 c0.928-1.604,2.981-2.155,4.586-1.228c1.605,0.927,2.155,2.981,1.227,4.585c-4.66,8.069-9.938,16.085-15.685,23.827 C1599.419,468.744,1598.406,469.212,1597.38,469.212z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116229091366264267650000010060010055578954636_",
    gradientUnits: "userSpaceOnUse",
    x1: 1621,
    y1: 344.1457,
    x2: 1644.7301,
    y2: 344.1457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116229091366264267650000010060010055578954636_)"
    },
    d: "M1624.356,422.918 c-0.446,0-0.899-0.09-1.335-0.277c-1.7-0.739-2.48-2.716-1.742-4.417c34.79-80.123,4.762-147.426,4.454-148.097 c-0.773-1.685-0.033-3.678,1.653-4.449c1.69-0.769,3.679-0.033,4.451,1.652c0.319,0.697,31.57,70.728-4.399,153.569 C1626.887,422.165,1625.653,422.918,1624.356,422.918z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179646243808442878100000016016640709516572051_",
    gradientUnits: "userSpaceOnUse",
    x1: 1480.6576,
    y1: 618.9685,
    x2: 1488.1571,
    y2: 110.4944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179646243808442878100000016016640709516572051_)"
    },
    d: "M1389.399,544.422 c-4.643-16.444-12.529-31.813-23.15-45.198c-22.757-28.681-59.882-87.01-64.452-166.619 c-6.647-115.795,96.05-173.768,189.762-165.898c93.712,7.87,186.182,77.646,176.059,185.37 c-6.229,66.283-43.328,116.56-70.951,145.433c-17.54,18.335-30.052,40.792-36.825,65.245 c-8.29,29.93-28.017,67.228-74.907,69.502C1424.26,635.199,1399.061,578.643,1389.399,544.422z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000012473192782031857730000015106398679030574777_",
    d: "M1480.422,623.548 c-22.475,0-41.537-9.483-56.655-28.187c-13.748-17.008-21.663-38.391-25.882-53.335c-4.979-17.633-13.299-33.878-24.729-48.283 c-21.449-27.034-58.099-83.981-62.557-161.644c-2.392-41.681,10.248-78.439,36.557-106.3 c30.143-31.923,77.793-50.981,127.467-50.981c5.404,0,10.853,0.228,16.197,0.676c53.093,4.459,103.363,29.32,134.47,66.503 c25.769,30.803,37.37,68.582,33.548,109.254c-5.901,62.797-40.531,110.882-68.543,140.162 c-18.271,19.099-31.741,42.954-38.951,68.987c-4.769,17.218-11.861,31.224-21.08,41.627 c-11.797,13.313-27.191,20.52-45.756,21.42C1483.139,623.515,1481.764,623.548,1480.422,623.548z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009587338242108629560000017153416075518088071_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012473192782031857730000015106398679030574777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009587338242108629560000017153416075518088071_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096778987993547198640000000783928997766301583_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.169,
    y1: 1434.5145,
    x2: -1045.1686,
    y2: 2742.5144,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096778987993547198640000000783928997766301583_)"
    },
    d: "M1647.273,355.527 c2.293,3.661,4.71,8.911,4.127,14.16c-1.061,9.544-15.699,13.786-28.529,8.484c-9.164-3.787-5.237-16.231-2.244-23.033 c0.942-2.14-0.656-4.539-2.994-4.539h-33.043v-37.219c0-3.25,3.44-5.34,6.321-3.836c3.452,1.802,7.991,3.714,12.768,4.468 c10.074,1.591,20.149-9.544,19.089-20.149c-1.061-10.605-11.135-18.558-21.74-18.028c-3.668,0.184-6.72,1.717-9.144,3.645 c-2.791,2.22-6.92,0.107-6.92-3.459V243.49h34.955c1.927,0,2.993-2.256,1.752-3.729 c-16.869-20.021,17.001-39.474,25.488-26.494c6.504,9.947,1.772,21.273-1.368,26.811c-0.866,1.526,0.224,3.412,1.979,3.412 h33.854v33.65c0,3.568-4.124,5.667-6.926,3.457c-2.919-2.303-6.676-4.341-11.103-4.763 c-11.135-1.061-17.498,9.544-19.681,18.028c-2.183,8.484,7.486,20.679,17.56,19.089c5.433-0.858,11.02-2.441,15.015-3.719 c2.798-0.895,5.646,1.215,5.627,4.152l-0.229,37.214h-31.833C1647.524,350.599,1645.93,353.383,1647.273,355.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036232012333977349760000012128381587927671429_",
    gradientUnits: "userSpaceOnUse",
    x1: 1580.1136,
    y1: 294.773,
    x2: 1686.5914,
    y2: 294.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036232012333977349760000012128381587927671429_)"
    },
    d: "M1634.417,384.952 c-4.399,0-8.98-0.876-13.257-2.644c-3.457-1.429-5.993-3.947-7.333-7.28c-2.455-6.108-0.461-13.932,1.969-19.955h-31.207 c-2.472,0-4.476-2.004-4.476-4.476V313.38c0-3.108,1.584-5.922,4.24-7.531c2.651-1.608,5.877-1.709,8.627-0.275 c3.983,2.08,7.923,3.468,11.396,4.017c2.958,0.476,6.243-0.776,9.026-3.405c3.438-3.245,5.319-7.798,4.912-11.878 c-0.801-8.014-8.635-14.406-17.062-14.004c-2.278,0.116-4.492,1.016-6.58,2.677c-2.623,2.085-6.133,2.467-9.17,1.003 c-3.092-1.493-5.013-4.543-5.013-7.964v-32.532c0-2.472,2.004-4.476,4.476-4.476h30.682 c-3.462-5.798-4.052-12.081-1.613-18.058c3.473-8.51,12.9-15.352,22.417-16.266c6.251-0.599,11.517,1.635,14.455,6.126 c6.623,10.129,3.791,21.072,0.468,28.198h30.252c2.472,0,4.476,2.004,4.476,4.476v33.651c0,3.411-1.913,6.458-4.992,7.95 c-3.033,1.473-6.552,1.095-9.181-0.979c-2.856-2.253-5.802-3.538-8.756-3.82c-10.559-1.001-14.508,13.077-14.922,14.686 c-0.687,2.671,0.7,6.497,3.452,9.526c2.72,2.987,6.12,4.511,9.075,4.028c5.236-0.828,10.694-2.393,14.351-3.562 c2.668-0.85,5.611-0.371,7.872,1.287c2.267,1.668,3.61,4.342,3.593,7.157l-0.229,37.213c-0.015,2.461-2.015,4.447-4.476,4.447 h-29.69c2.225,4.036,4.278,9.465,3.652,15.108c-0.518,4.659-3.294,8.698-7.818,11.373 C1644.21,383.811,1639.432,384.952,1634.417,384.952z M1589.065,346.122h28.568c2.626,0,5.052,1.313,6.487,3.516 c1.427,2.188,1.653,4.917,0.603,7.301c-2.786,6.338-3.756,11.851-2.591,14.749c0.446,1.106,1.201,1.829,2.448,2.345 c7.553,3.121,14.933,2.157,18.894-0.186c2.102-1.243,3.273-2.81,3.478-4.655c0.448-4.034-1.641-8.366-3.472-11.29 c-1.477-2.358-1.554-5.339-0.201-7.782c1.365-2.467,3.961-3.999,6.775-3.999h27.384l0.201-32.558 c-3.954,1.257-9.775,2.909-15.467,3.809c-5.951,0.948-12.341-1.619-17.094-6.849c-4.843-5.328-6.95-12.138-5.498-17.776 c2.747-10.671,10.795-22.689,24.441-21.369c4.596,0.439,9.029,2.286,13.18,5.494l-0.046-28.908h-29.386 c-2.432,0-4.614-1.252-5.837-3.352c-1.206-2.072-1.219-4.655-0.035-6.744c2.774-4.893,6.662-14.281,1.516-22.153 c-1.375-2.102-4.088-2.308-6.107-2.115c-5.425,0.52-12.514,4.681-14.985,10.739c-1.687,4.132-0.754,8.352,2.772,12.537 c1.706,2.024,2.071,4.775,0.953,7.177c-1.121,2.413-3.469,3.912-6.128,3.912h-30.479v27.746 c3.488-2.681,7.31-4.143,11.364-4.344c13.322-0.667,25.134,9.227,26.418,22.05c0.677,6.781-2.263,14.168-7.673,19.277 c-4.817,4.552-10.856,6.643-16.568,5.739c-4.414-0.697-9.094-2.312-13.915-4.806V346.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139990364967587114640000002605854902628466062_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.1484,
    y1: 1394.1799,
    x2: -1098.1504,
    y2: 2702.1829,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139990364967587114640000002605854902628466062_)"
    },
    d: "M1645.79,240.078 c3.14-5.538,7.872-16.865,1.368-26.811c-8.487-12.98-42.357,6.473-25.488,26.494c1.241,1.473,0.175,3.729-1.752,3.729h-34.955 v-37.648c0-3.185-3.318-5.277-6.191-3.902c-4.042,1.934-9.625,4.139-15.392,4.964c-11.135,1.591-17.748-11.135-16.297-21.74 c1.45-10.605,14.176-16.968,20.539-15.908c2.954,0.493,6.882,3.075,10.243,5.701c2.846,2.224,7,0.214,7-3.399V134.79h33.77 c2.771,0,4.336-3.171,2.657-5.375c-7.062-9.277-3.949-20.803,5.717-24.318c11.665-4.242,22.27-1.061,23.861,11.135 c1.591,12.195-7.267,18.558-7.267,18.558s21.215,0,37.042,0l-1.335,36.931c-0.127,3.517,3.755,5.691,6.701,3.766 c3.763-2.46,8.737-4.96,14.171-5.701c11.665-1.591,22.27,7.954,22.27,18.029c0,10.074-9.014,22.27-23.33,19.619 c-5.198-0.963-8.928-2.115-11.571-3.192c-2.835-1.155-5.927,0.955-5.927,4.017v35.231h-33.854 C1646.014,243.49,1644.924,241.604,1645.79,240.078z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085247917985003634480000011778826058309644182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.405,
    y1: 173.3986,
    x2: 1726.927,
    y2: 173.3986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085247917985003634480000011778826058309644182_)"
    },
    d: "M1681.624,247.965h-33.855 c-2.432,0-4.614-1.252-5.837-3.352c-1.205-2.069-1.219-4.655-0.035-6.742l0,0c2.775-4.895,6.662-14.284,1.516-22.156 c-1.375-2.102-4.088-2.308-6.107-2.115c-5.425,0.52-12.514,4.681-14.985,10.739c-1.687,4.132-0.754,8.352,2.772,12.537 c1.706,2.024,2.071,4.775,0.953,7.177c-1.121,2.413-3.469,3.912-6.128,3.912h-34.954c-2.472,0-4.476-2.004-4.476-4.476 v-37.407c-4.046,1.919-10.115,4.345-16.474,5.251c-5.39,0.769-10.542-0.977-14.506-4.915 c-5.268-5.236-7.959-13.818-6.859-21.863c0.768-5.619,4.079-10.842,9.324-14.705c5.206-3.831,11.637-5.791,16.385-5.009 c3.226,0.538,7.163,2.633,12.031,6.41V134.79c0-2.472,2.004-4.476,4.476-4.476h31.607c-3.379-5.348-4.375-11.471-2.723-17.096 c1.686-5.737,5.962-10.23,11.732-12.328c8.156-2.966,15.735-2.719,21.343,0.688c3.294,2.002,7.441,6.069,8.486,14.074 c0.793,6.089-0.558,10.988-2.444,14.662h27.781c1.215,0,2.378,0.494,3.221,1.368c0.844,0.874,1.295,2.054,1.251,3.269 l-1.323,36.638c5.326-3.44,10.631-5.536,15.784-6.237c6.891-0.935,13.948,1.237,19.37,5.97 c5.071,4.425,7.979,10.437,7.979,16.491c0,7.116-3.501,14.448-9.138,19.135c-5.387,4.48-12.308,6.202-19.483,4.884 c-4.734-0.876-8.839-2.004-12.207-3.35v35.006C1686.099,245.961,1684.095,247.965,1681.624,247.965z M1651.371,239.014h25.777 v-30.755c0-2.942,1.457-5.678,3.896-7.317c2.426-1.63,5.49-1.945,8.194-0.844c2.849,1.16,6.447,2.146,10.696,2.933 c5.787,1.075,9.792-1.021,12.13-2.966c3.59-2.985,5.91-7.795,5.91-12.251c0-3.418-1.837-7.061-4.914-9.747 c-3.476-3.036-7.954-4.436-12.274-3.846c-3.851,0.524-8.113,2.257-12.329,5.013c-2.773,1.812-6.284,1.928-9.162,0.302 c-2.869-1.622-4.578-4.679-4.458-7.977l1.166-32.294h-32.402c-1.944,0-3.665-1.254-4.26-3.103 c-0.596-1.851,0.071-3.875,1.65-5.007c0.24-0.181,6.647-5.085,5.44-14.345c-0.469-3.599-1.902-6.152-4.258-7.583 c-3.193-1.941-8.162-1.914-13.635,0.076c-3.112,1.13-5.315,3.416-6.202,6.436c-1.031,3.512-0.115,7.509,2.515,10.962 c1.815,2.386,2.117,5.536,0.787,8.219c-1.328,2.679-4.012,4.344-7.005,4.344h-29.294v32.294c0,3.392-1.893,6.421-4.938,7.907 c-3.053,1.49-6.614,1.11-9.293-0.981c-5.195-4.063-7.606-4.712-8.221-4.814c-1.978-0.31-6.017,0.743-9.605,3.387 c-1.899,1.401-5.174,4.393-5.765,8.711c-0.71,5.197,1.058,11.078,4.301,14.301c1.979,1.967,4.306,2.78,6.93,2.404 c5.353-0.765,10.618-2.909,14.092-4.57c2.742-1.318,5.915-1.132,8.488,0.487c2.574,1.622,4.111,4.406,4.111,7.45v33.172 h26.206c-3.462-5.798-4.052-12.081-1.613-18.058c3.473-8.51,12.9-15.352,22.417-16.268c6.243-0.599,11.516,1.635,14.455,6.128 C1657.527,220.945,1654.694,231.887,1651.371,239.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078757013927559163840000016607943049054406813_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.3092,
    y1: 1473.7128,
    x2: -993.6895,
    y2: 2781.7114,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078757013927559163840000016607943049054406813_)"
    },
    d: "M1650.025,445.116 c3.245-5.787,3.775-14.083-11.351-21.344c-21.827-10.477-26.262,9.235-20.696,21.855c1.41,3.196-0.96,6.778-4.453,6.778 h-28.935v-31.169c0-3.086-3.144-5.238-5.985-4.032c-3.149,1.337-7.445,2.618-12.657,2.857 c-11.582,0.53-20.399-9.014-18.641-22.27c1.757-13.256,13.032-16.438,18.53-14.847c2.87,0.831,7.855,4.015,11.964,6.869 c2.869,1.993,6.79-0.063,6.79-3.556v-35.658h33.043c2.338,0,3.936,2.399,2.994,4.539c-2.992,6.802-6.92,19.246,2.244,23.033 c12.83,5.303,27.468,1.061,28.529-8.484c0.583-5.25-1.834-10.499-4.127-14.16c-1.343-2.144,0.252-4.928,2.781-4.928h31.833 l-0.2,32.391c-0.023,3.893-4.364,6.102-7.597,3.933c-3.008-2.018-6.666-3.766-10.495-3.979 c-9.545-0.53-19.089,6.893-19.65,16.438s6.394,21.74,16.998,21.21c5.012-0.251,10.143-2.871,14.161-5.564 c3.223-2.161,7.541,0.158,7.518,4.039l-0.2,33.339h-28.198C1650.483,452.405,1648.195,448.38,1650.025,445.116z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124153852832451408330000002257817347979771820_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.6039,
    y1: 401.5006,
    x2: 1687.0985,
    y2: 401.5006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124153852832451408330000002257817347979771820_)"
    },
    d: "M1682.424,456.879h-28.198 c-3.343,0-6.344-1.718-8.029-4.594c-1.702-2.907-1.731-6.405-0.075-9.358v-0.002c1.266-2.255,1.595-4.259,1.006-6.124 c-0.977-3.09-4.57-6.202-10.39-8.997c-3.651-1.751-10.299-4.187-13.771-0.831c-3.215,3.114-3.616,10.671-0.893,16.847 c1.27,2.88,1,6.176-0.721,8.818c-1.732,2.655-4.657,4.24-7.827,4.24h-28.936c-2.472,0-4.476-2.004-4.476-4.476v-30.98 c-4.417,1.84-9.113,2.885-13.962,3.108c-6.815,0.326-13.034-2.177-17.476-7.017c-4.789-5.221-6.851-12.435-5.807-20.313 c1.167-8.801,5.754-13.484,9.397-15.864c4.499-2.937,10.312-4.001,14.814-2.692c1.045,0.302,4.207,1.217,13.034,7.326v-35.373 c0-2.472,2.004-4.476,4.476-4.476h33.043c2.626,0,5.052,1.313,6.487,3.516c1.427,2.188,1.653,4.917,0.603,7.301 c-2.786,6.338-3.756,11.851-2.591,14.747c0.446,1.108,1.201,1.831,2.448,2.347c7.553,3.121,14.933,2.157,18.894-0.186 c2.102-1.243,3.273-2.81,3.478-4.655c0.448-4.034-1.641-8.366-3.472-11.29c-1.477-2.358-1.554-5.339-0.201-7.782 c1.365-2.467,3.961-3.999,6.775-3.999h31.832c1.192,0,2.334,0.476,3.174,1.32c0.84,0.846,1.309,1.991,1.301,3.184 l-0.199,32.392c-0.021,3.422-1.909,6.543-4.925,8.141c-3.06,1.617-6.752,1.418-9.641-0.518 c-2.986-2.004-5.762-3.09-8.249-3.228c-7.413-0.363-14.535,5.418-14.935,12.229c-0.274,4.677,1.75,10.048,5.038,13.366 c2.179,2.198,4.652,3.254,7.269,3.114c3.332-0.168,7.444-1.831,11.893-4.812c2.87-1.928,6.545-2.109,9.588-0.472 c3.041,1.637,4.918,4.799,4.896,8.256l-0.199,33.336C1686.884,454.893,1684.886,456.879,1682.424,456.879z M1653.929,447.303 c-0.037,0.068-0.135,0.243-0.01,0.459c0.091,0.153,0.197,0.166,0.306,0.166h23.749l0.173-28.889 c0.001-0.087,0.001-0.216-0.184-0.317c-0.185-0.096-0.297-0.022-0.366,0.022c-5.88,3.94-11.407,6.064-16.43,6.316 c-5.208,0.273-10.084-1.726-14.073-5.752c-5.048-5.092-8.038-13.018-7.617-20.191c0.687-11.681,12.048-21.31,24.367-20.643 c4.114,0.227,8.401,1.82,12.74,4.733c0.064,0.044,0.237,0.155,0.464,0.039c0.15-0.081,0.162-0.173,0.163-0.286l0.172-27.888 h-25.187c2.225,4.036,4.278,9.467,3.652,15.108c-0.518,4.659-3.294,8.698-7.818,11.373c-7.173,4.237-17.717,4.537-26.87,0.754 c-3.457-1.429-5.993-3.947-7.333-7.28c-2.455-6.108-0.461-13.932,1.969-19.955h-26.732v31.183 c0,3.289-1.811,6.279-4.725,7.802c-2.909,1.525-6.396,1.305-9.094-0.57c-7.239-5.029-9.985-6.051-10.654-6.246 c-1.393-0.4-4.519-0.31-7.431,1.591c-2.974,1.943-4.847,5.243-5.419,9.544c-0.69,5.206,0.564,9.852,3.531,13.086 c2.616,2.85,6.344,4.31,10.469,4.126c3.872-0.177,7.612-1.021,11.116-2.507c2.696-1.143,5.776-0.861,8.234,0.769 c2.488,1.646,3.973,4.406,3.973,7.384v26.692h24.46c0.058,0,0.212,0,0.328-0.177c0.102-0.155,0.055-0.262,0.03-0.319 c-3.704-8.398-3.912-20.333,2.857-26.887c3.162-3.066,10.472-7.245,23.871-0.809c8.223,3.947,13.286,8.781,15.052,14.369 C1656.999,438.334,1656.4,442.9,1653.929,447.303L1653.929,447.303z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056391462713429488990000012515041562679230878_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.1416,
    y1: 1565.7272,
    x2: -872.8581,
    y2: 2873.7273,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056391462713429488990000012515041562679230878_)"
    },
    d: "M1430.515,342.866 c-4.515-6.556-8.93-18.21,7.463-27.117c8.541-4.641,19.089,2.637,20.282,15.362c0.59,6.301-0.836,10.944-2.428,14.027 c-1.1,2.131,0.511,4.664,2.91,4.664h31.434v34.663c0,3.44,3.73,5.584,6.708,3.863c20.6-11.905,29.341,7.302,28.981,12.111 c-0.396,5.303-3.315,21.74-15.511,21.74c-5.525,0-10.199-1.633-13.659-3.418c-3.006-1.551-6.586,0.556-6.586,3.939v29.867 h-30.052c-3.396,0-5.76,3.395-4.546,6.567c1.732,4.526,3.442,10.921,2.88,17.66c-1.061,12.726-18.89,15.907-28.003,8.484 c-6.729-5.482-1.868-15.632,1.94-23.326c1.583-3.198-0.809-6.936-4.377-6.936h-36.37v-37.341c0-3.138-3.432-5.065-6.104-3.421 c-3.322,2.044-7.623,4.263-11.924,5.275c-9.014,2.121-15.422-9.544-15.93-19.089c-0.508-9.544,6.385-16.437,17.52-16.967 c4.202-0.2,7.573,1.185,10.142,2.988c2.654,1.862,6.295-0.045,6.295-3.287v-35.257h36.247 C1430.428,347.917,1431.989,345.007,1430.515,342.866z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168814933507126656390000006958638275666149310_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.1213,
    y1: 401.7813,
    x2: 1530.351,
    y2: 401.7813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168814933507126656390000006958638275666149310_)"
    },
    d: "M1442.348,493.692 c-5.422,0-10.811-1.707-14.785-4.943c-9.614-7.83-3.123-20.945,0.755-28.779c0.026-0.055,0.067-0.138-0.024-0.282 c-0.12-0.195-0.287-0.195-0.342-0.195h-36.369c-2.472,0-4.476-2.004-4.476-4.476V418.5c-4.451,2.666-8.662,4.476-12.528,5.387 c-4.078,0.951-8.095,0.066-11.62-2.577c-6.264-4.694-9.439-13.744-9.805-20.63c-0.296-5.57,1.402-10.566,4.909-14.445 c3.917-4.331,9.907-6.899,16.869-7.231c4.359-0.192,8.463,0.896,12.174,3.289v-34.374c0-2.472,2.004-4.476,4.476-4.476h33.988 c-3.322-5.59-4.425-11.213-3.19-16.375c1.45-6.054,5.978-11.185,13.46-15.25c4.815-2.618,10.429-2.594,15.403,0.057 c6.399,3.411,10.688,10.446,11.472,18.821c0.492,5.254-0.211,10.269-2.038,14.633h29.5c2.472,0,4.476,2.004,4.476,4.476 v34.662c11.805-6.84,20.22-4.543,25.201-1.418c7.258,4.556,10.801,13.375,10.477,17.728 c-0.72,9.611-5.736,25.879-19.974,25.879c-5.386,0-10.671-1.316-15.71-3.914l-0.061,29.826c0,2.472-2.004,4.476-4.476,4.476 h-30.052c-0.057,0-0.207,0-0.325,0.171c-0.105,0.153-0.062,0.267-0.042,0.321c1.797,4.692,3.805,11.908,3.161,19.631 c-0.546,6.563-4.564,11.902-11.022,14.649C1448.858,493.078,1445.596,493.692,1442.348,493.692z M1396.058,450.542h31.894 c3.256,0,6.227,1.652,7.947,4.423c1.701,2.738,1.866,6.093,0.443,8.973c-3.644,7.363-6.887,14.806-3.125,17.87 c3.829,3.119,10.183,3.866,15.112,1.768c2.368-1.005,5.263-3.064,5.603-7.153c0.504-6.04-1.135-11.864-2.599-15.689 c-1.094-2.856-0.71-6.069,1.026-8.593c1.744-2.535,4.622-4.05,7.699-4.05h25.577v-25.39c0-3.14,1.596-5.988,4.271-7.616 c2.708-1.648,6.012-1.757,8.844-0.299c3.756,1.936,7.661,2.917,11.607,2.917c9.62,0,11.034-17.42,11.047-17.597 c0.015-1.362-1.943-6.932-6.613-9.662c-4.16-2.437-9.433-1.842-15.665,1.759c-2.805,1.621-6.151,1.619-8.953,0.002 c-2.8-1.617-4.47-4.511-4.47-7.741V354.28h-26.959c-2.723,0-5.196-1.39-6.614-3.719c-1.401-2.301-1.504-5.094-0.273-7.476 c1.17-2.264,2.458-6.108,1.948-11.554c-0.496-5.289-3.091-9.795-6.771-11.757c-1.63-0.868-4.156-1.591-6.918-0.09 c-5.156,2.802-8.194,5.988-9.028,9.469c-0.977,4.08,1.155,8.329,3.114,11.174c0.001,0.002,0.001,0.002,0.001,0.002 c1.622,2.358,1.801,5.398,0.468,7.933c-1.341,2.548-3.962,4.133-6.84,4.133h-31.771v30.781c0,3.18-1.752,6.067-4.572,7.533 c-2.812,1.458-6.175,1.239-8.77-0.583c-2.242-1.571-4.73-2.332-7.357-2.179c-4.565,0.216-8.348,1.74-10.655,4.292 c-1.875,2.074-2.778,4.827-2.612,7.966c0.298,5.597,2.92,11.46,6.235,13.945c1.834,1.372,3.276,1.246,4.2,1.023 c3.094-0.725,6.76-2.362,10.602-4.729c2.616-1.608,5.904-1.676,8.581-0.179c2.682,1.497,4.347,4.338,4.347,7.413V450.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137101840799617735850000004747860425047661715_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.243,
    y1: 1479.7627,
    x2: -985.7608,
    y2: 2787.7681,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137101840799617735850000004747860425047661715_)"
    },
    d: "M1551.428,345.636 c2.304-3.635,4.219-9.291,2.142-17.043c-3.977-14.847-17.498-14.052-24.126-11.135c-5.583,2.456-12.106,16.952-4.676,27.165 c1.57,2.158,0.082,5.179-2.587,5.179h-32.004v-37.526c0-3.311-3.472-5.492-6.434-4.013c-3.231,1.614-7.643,3.167-13.155,3.627 c-12.726,1.06-18.758-10.075-18.128-21.21c0.546-9.657,14.579-21.708,29.71-11.245c2.948,2.039,6.976-0.108,6.976-3.693 v-33.127h39.238c-12.195,10.262-9.014,25.265,3.181,31.097c12.196,5.832,23.331,1.06,24.391-12.196 c0.546-6.825-1.876-11.402-4.354-14.236c-1.298-1.484-0.273-3.793,1.699-3.793h31.661v32.531c0,3.566,4.13,5.679,6.92,3.459 c2.424-1.928,5.476-3.462,9.144-3.645c10.605-0.53,20.679,7.424,21.74,18.028c1.06,10.605-9.014,21.74-19.089,20.149 c-4.777-0.754-9.316-2.666-12.768-4.468c-2.881-1.504-6.321,0.586-6.321,3.836v37.219h-30.422 C1551.615,350.599,1550.062,347.792,1551.428,345.636z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182497931366612877940000011717047674557190545_",
    gradientUnits: "userSpaceOnUse",
    x1: 1447.9377,
    y1: 296.6074,
    x2: 1627.3169,
    y2: 296.6074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182497931366612877940000011717047674557190545_)"
    },
    d: "M1584.589,355.073h-30.422 c-2.817,0-5.409-1.532-6.765-3.997c-1.353-2.461-1.259-5.461,0.245-7.835l0,0c2.431-3.837,2.969-8.377,1.599-13.49 c-1.114-4.157-3.175-6.984-6.131-8.403c-3.766-1.805-8.677-1.2-11.869,0.208c-1.031,0.452-3.467,3.184-4.692,7.717 c-0.75,2.778-1.509,8.125,1.833,12.719c1.73,2.378,1.98,5.479,0.65,8.09c-1.318,2.59-3.945,4.198-6.857,4.198h-32.004 c-2.472,0-4.476-2.004-4.476-4.476v-37.528c-4.506,2.262-9.48,3.634-14.742,4.076c-6.248,0.511-11.751-1.342-15.901-5.383 c-4.958-4.827-7.533-12.315-7.068-20.543c0.387-6.849,5.397-13.775,12.464-17.23c7.658-3.735,16.499-2.808,24.26,2.559 l-0.045-33.139c0-2.472,2.004-4.476,4.476-4.476h39.238c1.88,0,3.56,1.176,4.205,2.942c0.645,1.768,0.116,3.748-1.323,4.959 c-4.474,3.765-6.613,8.398-6.021,13.049c0.564,4.425,3.649,8.383,8.251,10.584c4.999,2.393,9.772,2.664,13.095,0.754 c2.854-1.643,4.55-4.847,4.904-9.266c0.351-4.377-0.747-8.058-3.262-10.934c-1.749-2.002-2.171-4.854-1.075-7.264 c1.107-2.437,3.461-3.951,6.144-3.951h31.661c2.472,0,4.476,2.004,4.476,4.476v32.221c3.488-2.681,7.31-4.143,11.364-4.344 c13.322-0.667,25.134,9.227,26.418,22.05c0.677,6.781-2.263,14.168-7.673,19.277c-4.817,4.552-10.856,6.643-16.568,5.739 c-4.414-0.697-9.094-2.312-13.915-4.806v36.97C1589.065,353.069,1587.061,355.073,1584.589,355.073z M1556.299,346.122h23.814 V313.38c0-3.108,1.584-5.922,4.24-7.531c2.651-1.608,5.877-1.709,8.627-0.275c3.983,2.08,7.923,3.468,11.396,4.017 c2.958,0.476,6.243-0.776,9.026-3.405c3.438-3.245,5.319-7.798,4.912-11.878c-0.801-8.014-8.635-14.406-17.062-14.004 c-2.278,0.116-4.492,1.016-6.58,2.677c-2.623,2.085-6.133,2.467-9.17,1.003c-3.092-1.493-5.013-4.543-5.013-7.964v-28.056 h-22.939c1.896,3.337,3.348,7.926,2.87,13.91c-0.591,7.384-3.915,13.176-9.361,16.312c-5.916,3.403-13.724,3.243-21.422-0.435 c-7.359-3.521-12.319-10.075-13.269-17.531c-0.574-4.506,0.343-9.017,2.579-13.128h-25.322v28.65 c0,3.339-1.84,6.377-4.801,7.931c-2.945,1.539-6.47,1.329-9.197-0.557c-6.53-4.513-11.889-3.508-15.238-1.877 c-4.666,2.282-7.284,6.602-7.459,9.694c-0.314,5.555,1.322,10.649,4.376,13.622c2.272,2.212,5.267,3.195,8.912,2.876 c4.123-0.345,8.002-1.412,11.528-3.171c2.778-1.388,6.017-1.241,8.662,0.396c2.66,1.643,4.247,4.493,4.247,7.62v33.052h25.242 c-3.064-5.313-3.774-11.753-1.983-18.388c1.731-6.41,5.55-11.74,9.729-13.58c4.925-2.163,12.588-3.326,19.346-0.081 c3.724,1.785,8.639,5.693,10.906,14.155C1560.081,335.606,1558.466,341.884,1556.299,346.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025415357277203914640000006084177920297629351_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.3968,
    y1: 1603.9989,
    x2: -822.6047,
    y2: 2912.0012,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025415357277203914640000006084177920297629351_)"
    },
    d: "M1432.329,461.953 c-3.807,7.695-8.669,17.845-1.94,23.326c9.114,7.423,26.943,4.242,28.003-8.484c0.561-6.739-1.148-13.134-2.88-17.66 c-1.214-3.172,1.15-6.567,4.546-6.567h30.052v36.881c0,3.433,3.694,5.558,6.687,3.875 c13.832-7.779,30.748-6.609,28.936,17.406c-1.528,20.252-18.753,15.721-28.257,11.609c-2.936-1.27-6.208,0.921-6.208,4.12 v34.393h-31.245c-3.162,0-5.176-3.364-3.683-6.152c2.475-4.624,4.895-11.054,3.114-16.398 c-3.181-9.544-22.071-9.544-29.064-3.181c-4.5,4.094-1.274,13.581,1.599,19.823c1.275,2.772-0.747,5.923-3.798,5.923h-36.608 v-33.63c0-3.111-3.361-5.003-6.057-3.45c-3.255,1.876-7.701,3.668-13.032,3.91c-11.665,0.531-14.891-16.967-14.869-24.391 c0.02-6.684,9.48-21.536,27.621-8.945c2.677,1.858,6.337-0.007,6.337-3.265v-36.081h36.37 C1431.519,455.017,1433.911,458.755,1432.329,461.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141448395307211171590000015839250109698631603_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.1488,
    y1: 506.7184,
    x2: 1530.3402,
    y2: 506.7184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141448395307211171590000015839250109698631603_)"
    },
    d: "M1428.19,565.345h-36.607 c-2.472,0-4.476-2.004-4.476-4.476v-32.835c-4.578,2.518-9.423,3.91-14.411,4.137c-4.13,0.21-7.947-1.27-11.018-4.211 c-6.787-6.506-8.547-18.978-8.53-24.664c0.015-5.247,3.699-12.737,10.493-16.279c4.812-2.504,12.754-3.942,23.464,3.202v-35.2 c0-2.472,2.004-4.476,4.476-4.476h36.369c3.256,0,6.227,1.652,7.947,4.423c1.701,2.738,1.866,6.093,0.443,8.973 c-0.001,0-0.001,0-0.001,0c-3.643,7.363-6.886,14.806-3.124,17.87c3.829,3.119,10.183,3.866,15.112,1.768 c2.368-1.005,5.263-3.064,5.603-7.153c0.504-6.04-1.135-11.864-2.599-15.689c-1.094-2.856-0.71-6.069,1.026-8.593 c1.744-2.535,4.622-4.05,7.699-4.05h30.052c2.472,0,4.476,2.004,4.476,4.476v36.883c10.048-5.671,20.121-6.445,26.957-2.089 c4.546,2.893,9.737,9.356,8.653,23.707c-0.608,8.055-3.512,13.707-8.631,16.801c-7.782,4.707-18.359,1.825-25.865-1.42 l0.044,34.405c0,2.472-2.004,4.476-4.476,4.476h-31.245c-3.073,0-5.848-1.571-7.426-4.207 c-1.578-2.633-1.653-5.824-0.203-8.534c2.822-5.273,3.822-9.845,2.814-12.872c-0.792-2.373-3.807-3.486-5.534-3.936 c-5.626-1.466-13.077-0.256-16.27,2.653c-1.388,1.261-1.149,6.381,2.652,14.64c1.239,2.695,1.025,5.794-0.574,8.287 C1433.882,563.854,1431.156,565.345,1428.19,565.345z M1396.058,556.393h31.672c-5.301-11.703-5.42-19.972-0.352-24.581 c5.405-4.919,15.962-6.936,24.555-4.692c6.01,1.569,10.189,5.037,11.766,9.766c1.784,5.359,0.683,12.09-3.184,19.492h26.276 V526.46c0-3.029,1.512-5.831,4.046-7.494c2.518-1.652,5.663-1.927,8.417-0.732c7.759,3.352,14.201,4.076,17.68,1.973 c2.499-1.51,3.958-4.812,4.336-9.812c0.413-5.483-0.037-12.621-4.535-15.483c-3.943-2.513-10.743-1.621-17.744,2.314 c-2.817,1.582-6.158,1.556-8.94-0.07c-2.766-1.617-4.417-4.497-4.417-7.706v-32.407h-25.577c-0.057,0-0.207,0-0.325,0.171 c-0.105,0.153-0.062,0.267-0.042,0.321c1.797,4.692,3.805,11.908,3.161,19.631c-0.546,6.563-4.564,11.902-11.022,14.649 c-7.933,3.37-17.913,2.109-24.268-3.066c-9.612-7.828-3.124-20.943,0.754-28.779l0,0c0.027-0.055,0.069-0.138-0.022-0.282 c-0.12-0.195-0.288-0.195-0.343-0.195h-31.894v31.605c0,3.162-1.738,6.038-4.536,7.5c-2.824,1.479-6.204,1.261-8.829-0.557 c-4.077-2.83-9.975-5.669-14.913-3.088c-3.953,2.061-5.674,6.539-5.68,8.368c-0.016,5.234,1.764,14.334,5.772,18.176 c1.314,1.257,2.731,1.82,4.418,1.731c3.779-0.173,7.479-1.287,10.999-3.317c2.686-1.545,5.879-1.545,8.547-0.004 c2.643,1.53,4.222,4.27,4.222,7.332V556.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065041506737728697810000014928621411436352443_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.8298,
    y1: 1611.9298,
    x2: -812.1727,
    y2: 2919.9333,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065041506737728697810000014928621411436352443_)"
    },
    d: "M1334.472,352.891 c-3.608,5.719-7.588,15.188-0.288,21.966c11.135,10.34,27.44,4.375,29.428-7.556c1.006-6.035-1.041-10.924-3.309-14.282 c-1.47-2.176,0.026-5.102,2.651-5.102h28.628v35.257c0,3.242-3.641,5.15-6.295,3.287c-2.569-1.802-5.941-3.188-10.142-2.988 c-11.135,0.53-18.028,7.423-17.52,16.967c0.508,9.544,6.916,21.21,15.93,19.089c4.301-1.012,8.602-3.231,11.924-5.275 c2.672-1.644,6.104,0.283,6.104,3.421v37.341h-27.042c-3.749,0-6.098-4.07-4.193-7.299c2.057-3.487,3.296-8.26,1.541-14.402 c-4.242-14.847-21.21-12.726-29.694-3.182c-4.697,5.285-2.397,12.345,0.592,17.594c1.852,3.253-0.459,7.288-4.202,7.288 h-31.114v-37.024c0-2.555,2.677-4.235,4.966-3.099c4.117,2.042,10.356,4.559,17.032,5.166 c11.665,1.06,13.811-13.786,14.329-23.331c0.468-8.623-13.769-22.008-30.796-9.258c-2.283,1.709-5.537,0.11-5.537-2.742 v-36.812h34.27C1334.293,347.917,1335.837,350.728,1334.472,352.891z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111905660356604881760000012026435344423267733_",
    gradientUnits: "userSpaceOnUse",
    x1: 1292.9895,
    y1: 401.4679,
    x2: 1396.0579,
    y2: 401.4679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111905660356604881760000012026435344423267733_)"
    },
    d: "M1391.582,459.493h-27.042 c-3.396,0-6.428-1.761-8.112-4.71c-1.677-2.939-1.653-6.432,0.066-9.34c1.906-3.232,2.263-6.797,1.092-10.896 c-1.148-4.021-3.459-6.453-6.87-7.231c-4.834-1.106-11.214,1.335-15.177,5.793c-2.396,2.697-2.014,6.871,1.138,12.406 c1.673,2.937,1.66,6.432-0.035,9.347c-1.686,2.9-4.698,4.631-8.058,4.631h-31.113c-2.472,0-4.476-2.004-4.476-4.476v-37.025 c0-2.767,1.403-5.286,3.753-6.744c2.34-1.453,5.212-1.589,7.678-0.363c3.732,1.849,9.441,4.17,15.447,4.716 c1.789,0.168,3.144-0.225,4.29-1.215c2.007-1.737,4.533-6.25,5.165-17.901c0.127-2.334-2.163-6.152-6.082-8.248 c-5.193-2.784-11.43-1.779-17.563,2.815c-2.426,1.82-5.618,2.107-8.326,0.752c-2.695-1.348-4.369-4.061-4.369-7.076v-36.811 c0-2.472,2.004-4.476,4.476-4.476h34.27c2.813,0,5.401,1.528,6.757,3.988c1.356,2.461,1.266,5.468-0.235,7.848l0,0 c-4.554,7.221-4.901,12.704-1.029,16.299c4.088,3.796,9.451,5.061,14.35,3.396c4.127-1.407,6.975-4.552,7.618-8.409 c0.638-3.824-0.238-7.537-2.604-11.038c-1.619-2.402-1.786-5.468-0.435-8.007c1.336-2.515,3.94-4.076,6.796-4.076h28.629 c2.472,0,4.476,2.004,4.476,4.476v35.257c0,3.18-1.752,6.067-4.572,7.533c-2.812,1.458-6.175,1.239-8.77-0.583 c-2.242-1.571-4.73-2.332-7.357-2.179c-4.565,0.216-8.348,1.74-10.655,4.292c-1.875,2.074-2.778,4.827-2.612,7.966 c0.298,5.597,2.92,11.46,6.235,13.945c1.834,1.372,3.276,1.246,4.2,1.023c3.094-0.725,6.76-2.362,10.602-4.729 c2.616-1.608,5.904-1.676,8.581-0.179c2.682,1.497,4.347,4.338,4.347,7.413v37.342 C1396.058,457.489,1394.054,459.493,1391.582,459.493z M1348.239,418.098c1.519,0,3.017,0.162,4.467,0.492 c6.642,1.514,11.432,6.309,13.485,13.497c1.83,6.403,1.143,12.594-1.989,17.905c-0.039,0.068-0.103,0.175-0.001,0.354 c0.113,0.197,0.266,0.197,0.339,0.197h22.566V418.5c-4.451,2.666-8.662,4.476-12.528,5.387 c-4.078,0.951-8.095,0.066-11.62-2.577c-6.264-4.694-9.439-13.744-9.805-20.63c-0.296-5.57,1.402-10.566,4.909-14.445 c3.917-4.331,9.907-6.899,16.869-7.231c4.359-0.192,8.463,0.896,12.174,3.289v-29.898h-21.932 c2.762,4.897,3.748,10.265,2.851,15.643c-1.176,7.052-6.37,12.957-13.558,15.407c-8.067,2.749-16.789,0.767-23.33-5.306 c-6.75-6.27-7.287-15.571-1.579-25.744h-27.618v30.346c8.505-5.682,17.716-6.572,25.527-2.395 c6.695,3.58,11.136,10.418,10.799,16.626c-0.653,12.039-3.351,19.95-8.249,24.186c-2.982,2.581-6.768,3.73-10.955,3.361 c-6.593-0.601-12.733-2.861-17.117-4.895v30.919h26.638c0.081,0,0.215,0,0.319-0.179c0.118-0.201,0.032-0.354-0.005-0.417 c-6.896-12.114-2.991-19.474-0.049-22.785C1333.932,421.443,1341.299,418.098,1348.239,418.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081613856418857145500000012375878595824085161_",
    gradientUnits: "userSpaceOnUse",
    x1: 1058.5024,
    y1: 629.9104,
    x2: 1150.234,
    y2: 629.9104,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081613856418857145500000012375878595824085161_)"
    },
    d: "M1331.001,566.825 c-3.539,7.511-3.352,19.655,1.193,23.442c6.363,5.302,32.056,8.342,31.814-8.484c-0.095-6.61-1.833-11.254-3.91-14.457 c-1.807-2.788,0.174-6.458,3.497-6.458h27.986v36.185c0,3.278-3.708,5.168-6.364,3.246c-3.289-2.38-7.388-4.761-11.134-5.26 c-7.954-1.061-16.967,8.484-16.438,18.558c0.53,10.075,4.772,21.74,15.377,20.679c4.79-0.479,9.038-2.58,12.258-4.741 c2.69-1.805,6.301,0.056,6.301,3.296v35.687h-29.693c0,0,14.651,27.796-4.34,29.917c-17.305,1.933-28.479-0.7-22.727-22.866 c0.924-3.563-1.748-7.051-5.429-7.051h-29.542v-35.7c0-2.454,2.486-4.134,4.753-3.194c3.363,1.393,8.167,3.024,13.275,3.592 c9.544,1.06,15.377-6.893,15.907-19.619c0.48-11.533-12.974-18.275-28.92-10.361c-2.307,1.145-5.016-0.455-5.016-3.03v-39.338 h27.241C1330.158,560.868,1332.309,564.05,1331.001,566.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075156776873719225720000010593672281461408387_",
    gradientUnits: "userSpaceOnUse",
    x1: 1294.2559,
    y1: 629.9143,
    x2: 1397.1769,
    y2: 629.9143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075156776873719225720000010593672281461408387_)"
    },
    d: "M1349.486,704.554 c-6.884,0-13.441-1.359-17.677-6.248c-4.489-5.179-5.275-13.077-2.403-24.142l-29.556-0.05c-3.09,0-5.595-2.504-5.595-5.595 v-35.701c0-3.031,1.504-5.846,4.023-7.529c2.51-1.678,5.678-1.989,8.466-0.833c2.849,1.18,7.202,2.692,11.752,3.2 c2.148,0.24,3.866-0.232,5.267-1.434c2.568-2.203,4.184-6.891,4.432-12.859c0.11-2.642-0.991-4.793-3.186-6.217 c-3.235-2.1-9.572-2.913-17.656,1.101c-2.853,1.414-6.162,1.265-8.853-0.402c-2.659-1.65-4.245-4.504-4.245-7.64v-39.337 c0-3.09,2.505-5.595,5.595-5.595h27.241c3.409,0,6.539,1.724,8.369,4.611c1.795,2.832,2.019,6.318,0.601,9.325 c-2.969,6.305-1.992,15.337-0.285,16.758c2.697,2.251,13.325,4.377,19.281,1.534c2.394-1.141,3.398-2.828,3.359-5.638 c-0.068-4.65-1.08-8.516-3.01-11.493c-1.955-3.016-2.106-6.847-0.392-9.998c1.709-3.145,4.998-5.099,8.583-5.099h27.986 c3.09,0,5.595,2.504,5.595,5.595v36.184c0,3.628-2.005,6.906-5.232,8.554c-3.23,1.654-7.065,1.355-10.006-0.774 c-4.573-3.309-7.346-4.08-8.593-4.246c-1.647-0.214-3.76,0.695-5.664,2.45c-2.935,2.71-4.641,6.643-4.449,10.269 c0.337,6.403,2.231,11.827,4.944,14.157c1.211,1.038,2.533,1.416,4.289,1.248c3.125-0.313,6.387-1.597,9.695-3.818 c2.982-2.002,6.792-2.201,9.949-0.516c3.124,1.665,5.066,4.906,5.066,8.455v35.687c0,3.09-2.505,5.595-5.595,5.595h-21.209 c2.254,6.486,4.042,15.317,0.529,21.948c-1.673,3.158-5.24,7.098-12.731,7.935 C1355.317,704.316,1352.372,704.554,1349.486,704.554z M1305.445,662.925h23.948c3.49,0,6.718,1.584,8.855,4.347 c2.144,2.771,2.869,6.307,1.99,9.701c-1.8,6.936-1.79,11.908,0.028,14.006c2.969,3.424,13.275,2.273,16.662,1.899 c3.187-0.356,3.841-1.589,4.087-2.054c2.156-4.069-1.157-14.159-4.076-19.695c-0.915-1.735-0.854-3.82,0.158-5.498 c1.013-1.678,2.83-2.706,4.79-2.706h24.099v-27.241c-4.087,2.347-8.25,3.744-12.408,4.159 c-4.774,0.476-9.166-0.868-12.688-3.89c-7.251-6.222-8.592-17.501-8.832-22.062c-0.275-5.245,1.36-10.586,4.491-15.031 c-9.599,2.81-22.4,0.319-27.937-4.294c-6.933-5.778-6.7-19.457-3.516-28.102h-19.652v30.386 c9.446-3.794,18.854-3.503,25.658,0.914c5.533,3.593,8.549,9.448,8.274,16.067c-0.389,9.323-3.268,16.543-8.325,20.884 c-3.775,3.243-8.55,4.651-13.79,4.063c-4.387-0.487-8.533-1.661-11.816-2.832V662.925z M1372.877,589.367 c0.653,0,1.304,0.042,1.947,0.129c3.379,0.448,7.124,1.98,11.163,4.561v-27.593h-19.922c2.265,4.338,3.454,9.452,3.537,15.239 c0.046,3.171-0.597,6.038-1.873,8.514C1369.436,589.657,1371.168,589.367,1372.877,589.367z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172404878263168850430000009061754051770554009_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.1219,
    y1: 1651.7461,
    x2: -759.8785,
    y2: 2959.7471,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172404878263168850430000009061754051770554009_)"
    },
    d: "M1332.786,447.729 c-2.989-5.25-5.289-12.31-0.592-17.594c8.484-9.544,25.452-11.665,29.694,3.182c1.755,6.141,0.515,10.915-1.541,14.402 c-1.905,3.229,0.443,7.299,4.193,7.299h27.042v36.081c0,3.258-3.66,5.123-6.337,3.265 c-18.141-12.591-27.601,2.261-27.621,8.945c-0.022,7.423,3.204,24.921,14.869,24.391c5.331-0.242,9.776-2.035,13.032-3.91 c2.696-1.553,6.057,0.338,6.057,3.45v33.63h-27.986c-3.323,0-5.304,3.67-3.497,6.458c2.077,3.203,3.816,7.847,3.91,14.457 c0.241,16.826-25.451,13.786-31.814,8.484c-4.545-3.788-4.732-15.932-1.193-23.442c1.307-2.775-0.843-5.957-3.91-5.957 h-27.241v-36.801c0-2.683-2.914-4.332-5.22-2.962c-4.688,2.786-11.93,6.279-19.171,6.594 c-12.195,0.531-13.786-13.256-14.317-23.861c-0.468-9.366,16.859-20.387,30.954-11.143c2.31,1.514,5.374-0.093,5.374-2.855 v-34.823h31.114C1332.328,455.017,1334.638,450.982,1332.786,447.729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057830894249147484720000013721132092002177197_",
    gradientUnits: "userSpaceOnUse",
    x1: 1256.6577,
    y1: 508.5045,
    x2: 1396.0579,
    y2: 508.5045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057830894249147484720000013721132092002177197_)"
    },
    d: "M1347.831,598.91 c-7.537,0-15.06-2.336-18.501-5.206c-6.359-5.299-6.566-19.498-2.544-28.425l-26.935,0.066c-2.472,0-4.476-2.004-4.476-4.476 v-35.027c-5.166,2.887-12.361,6.01-19.721,6.329c-17.513,0.732-18.586-20.21-18.981-28.111 c-0.292-5.839,3.709-11.862,10.441-15.72c6.48-3.713,16.51-5.608,25.882-0.337v-32.986c0-2.472,2.004-4.476,4.476-4.476 h31.113c0.081,0,0.215,0,0.319-0.179c0.118-0.201,0.032-0.354-0.005-0.417l-0.001-0.002 c-6.895-12.112-2.99-19.472-0.048-22.781c6.197-6.971,15.784-10.413,23.858-8.573c6.642,1.514,11.432,6.309,13.485,13.497 c1.83,6.403,1.143,12.594-1.989,17.905c-0.039,0.068-0.103,0.175-0.001,0.354c0.113,0.197,0.266,0.197,0.339,0.197h27.042 c2.472,0,4.476,2.004,4.476,4.476v36.081c0,3.162-1.738,6.038-4.536,7.5c-2.824,1.479-6.204,1.261-8.829-0.557 c-4.077-2.83-9.975-5.669-14.913-3.088c-3.953,2.061-5.674,6.539-5.68,8.368c-0.016,5.234,1.764,14.334,5.772,18.176 c1.314,1.257,2.731,1.82,4.418,1.731c3.779-0.173,7.479-1.287,10.999-3.317c2.686-1.545,5.879-1.545,8.547-0.004 c2.643,1.53,4.222,4.27,4.222,7.332v33.631c0,2.472-2.004,4.476-4.476,4.476h-27.441c2.791,4.508,4.252,10.013,4.344,16.375 c0.096,6.746-3.132,12.028-9.09,14.871C1355.959,598.231,1351.892,598.91,1347.831,598.91z M1304.326,556.393h22.765 c3.025,0,5.8,1.53,7.424,4.091c1.589,2.507,1.789,5.59,0.534,8.25c-3.095,6.569-2.241,16.218,0.01,18.095 c2.957,2.461,14.06,4.755,20.479,1.683c2.81-1.34,4.042-3.396,3.995-6.665c-0.07-4.863-1.143-8.93-3.19-12.085 c-1.732-2.671-1.865-6.064-0.349-8.855c1.513-2.784,4.427-4.513,7.601-4.513h23.51v-28.36 c-4.578,2.518-9.423,3.91-14.411,4.137c-4.13,0.21-7.947-1.27-11.018-4.211c-6.787-6.506-8.547-18.978-8.53-24.664 c0.015-5.247,3.699-12.737,10.493-16.279c4.812-2.504,12.754-3.942,23.464,3.202v-30.724h-22.566 c-3.396,0-6.428-1.761-8.112-4.71c-1.677-2.939-1.653-6.432,0.066-9.34c1.906-3.232,2.263-6.797,1.092-10.896 c-1.148-4.021-3.459-6.453-6.87-7.231c-4.834-1.106-11.214,1.335-15.177,5.793c-2.396,2.697-2.014,6.871,1.136,12.404l0,0 c1.674,2.939,1.661,6.434-0.034,9.349c-1.686,2.9-4.698,4.631-8.058,4.631h-26.638v30.346c0,2.909-1.587,5.575-4.141,6.954 c-2.578,1.392-5.705,1.254-8.162-0.356c-8.068-5.295-15.876-1.591-18.08-0.33c-4.036,2.312-6.049,5.527-5.95,7.507 c0.828,16.589,4.44,19.8,9.652,19.614c6.267-0.273,12.747-3.396,17.079-5.971c2.45-1.451,5.509-1.479,7.981-0.079 c2.468,1.405,4.001,4.045,4.001,6.888V556.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016048527272077118830000015715390393453560999_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.4326,
    y1: 1597.9272,
    x2: -830.5714,
    y2: 2905.9329,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016048527272077118830000015715390393453560999_)"
    },
    d: "M1484.495,627.67 c-4.07,2.418-9.331,5.008-13.908,5.546c-9.014,1.06-17.498-10.075-15.907-23.331c1.352-11.268,16.113-21.386,29.628-11.794 c2.915,2.069,6.958-0.153,6.958-3.728v-33.511h30.895c3.494,0,5.4,3.995,3.278,6.77c-8.89,11.626-10.896,29.865,11.427,29.007 c19.969-0.768,16.267-17.111,12.706-26.067c-1.096-2.757,0.907-5.747,3.875-5.747h31.14v33.165 c0,3.481-3.898,5.542-6.766,3.569c-3.569-2.455-7.984-4.943-11.792-5.451c-7.954-1.06-18.558,5.303-18.558,15.907 c0,10.605,3.181,20.679,16.437,19.619c6.079-0.487,10.931-2.199,14.404-3.912c2.894-1.427,6.276,0.633,6.276,3.86v36.945 h-28.333c-4.02,0-6.788-4.118-5.179-7.802c1.243-2.848,2.384-6.177,2.794-9.463c1.061-8.484-11.171-14.27-21.245-13.472 c-7.932,0.629-17.16,12.613-12.917,23.141c1.467,3.64-1.332,7.595-5.257,7.595h-23.185v-37.015 C1491.267,628.027,1487.485,625.894,1484.495,627.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010274714224660788380000008899436326612953530_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.0088,
    y1: 614.6865,
    x2: 1589.0649,
    y2: 614.6865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010274714224660788380000008899436326612953530_)"
    },
    d: "M1584.589,672.995h-28.334 c-3.426,0-6.593-1.713-8.472-4.585c-1.86-2.839-2.162-6.386-0.81-9.482c1.327-3.04,2.154-5.807,2.456-8.228 c0.058-0.466,0.235-1.882-1.512-3.709c-3.004-3.143-9.42-5.19-14.939-4.745c-2.485,0.195-5.634,2.62-7.662,5.894 c-1.081,1.746-3.387,6.322-1.458,11.113c1.231,3.051,0.858,6.515-0.998,9.266c-1.893,2.802-5.036,4.476-8.411,4.476h-23.185 c-2.472,0-4.476-2.004-4.476-4.476v-37.014l-2.296-3.835l2.287,3.846c-5.986,3.56-11.259,5.627-15.672,6.145 c-4.867,0.562-9.711-1.281-13.638-5.217c-5.593-5.605-8.298-14.238-7.236-23.093c0.893-7.435,6.231-14.347,13.599-17.612 c7.539-3.335,15.943-2.352,23.065,2.703l-0.108-33.589c0-2.472,2.004-4.476,4.476-4.476h30.896 c3.311,0,6.275,1.838,7.738,4.797c1.478,2.992,1.131,6.504-0.905,9.168c-4.69,6.132-6.581,13.499-4.499,17.516 c2.002,3.864,7.745,4.46,12.199,4.301c5.059-0.197,8.412-1.504,9.962-3.888c2.028-3.116,1.575-8.967-1.244-16.054 c-1.066-2.684-0.738-5.708,0.879-8.09c1.61-2.371,4.285-3.787,7.155-3.787h31.141c2.472,0,4.476,2.004,4.476,4.476v33.165 c0,3.282-1.804,6.268-4.707,7.795c-2.897,1.523-6.375,1.318-9.071-0.54c-3.941-2.71-7.439-4.38-9.846-4.701 c-3.114-0.411-6.902,0.865-9.64,3.261c-1.757,1.539-3.852,4.211-3.852,8.211c0,6.362,1.286,10.912,3.719,13.158 c1.764,1.628,4.335,2.277,7.887,2c4.559-0.365,8.859-1.53,12.78-3.466c2.767-1.361,5.979-1.213,8.59,0.413 c2.593,1.613,4.141,4.401,4.141,7.461v36.946C1589.065,670.991,1587.061,672.995,1584.589,672.995z M1534.574,633.232 c7.615,0,15.356,2.909,19.815,7.572c3.065,3.208,4.422,7.013,3.923,11.006c-0.409,3.274-1.464,6.873-3.134,10.7 c-0.185,0.422-0.05,0.776,0.095,0.999c0.131,0.201,0.433,0.535,0.982,0.535h23.858v-32.228 c-4.899,2.386-10.227,3.822-15.847,4.272c-6.087,0.476-11.022-0.977-14.672-4.347c-4.379-4.041-6.598-10.68-6.598-19.734 c0-5.171,1.991-9.992,5.643-13.746c-3.069,1.711-6.946,2.662-11.599,2.841c-12.794,0.492-18.192-4.69-20.49-9.124 c-4.491-8.663-0.171-19.658,5.015-26.649h-25.824v29.035c0,3.377-1.871,6.44-4.883,7.996 c-2.951,1.528-6.454,1.289-9.139-0.616c-6.14-4.36-11.567-3.012-14.26-1.82c-4.47,1.98-7.82,6.198-8.336,10.494 c-0.869,7.245,1.85,12.863,4.686,15.704c1.128,1.13,3.443,2.963,6.256,2.649c3.114-0.365,7.312-2.076,12.143-4.948v-0.002 c2.809-1.668,6.178-1.702,9.017-0.09c2.829,1.611,4.517,4.515,4.517,7.773v32.538h18.709c0.569,0,0.882-0.374,0.991-0.533 c0.2-0.297,0.239-0.603,0.115-0.911c-2.436-6.045-1.652-13.031,2.149-19.172c3.596-5.807,9.178-9.679,14.566-10.105 C1533.036,633.262,1533.804,633.232,1534.574,633.232z M1564.281,591.51c0.79,0,1.572,0.05,2.342,0.153 c3.826,0.509,8.364,2.537,13.492,6.029v-28.401h-26.23c2.735,7.024,4.919,16.731,0.279,23.862 c-0.398,0.612-0.834,1.187-1.308,1.729C1556.355,592.715,1560.41,591.51,1564.281,591.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137818461379821757160000000841888865173118109_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.0812,
    y1: 1551.9716,
    x2: -890.9222,
    y2: 2859.9766,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137818461379821757160000000841888865173118109_)"
    },
    d: "M1578.314,627.714 c-3.473,1.713-8.325,3.425-14.404,3.912c-13.256,1.06-16.437-9.014-16.437-19.619c0-10.604,10.604-16.967,18.558-15.907 c3.808,0.508,8.224,2.995,11.792,5.451c2.868,1.973,6.766-0.088,6.766-3.569v-33.165h31.734c3.226,0,5.286-3.522,3.612-6.279 c-1.946-3.206-3.532-7.958-3.532-14.931c0-18.028,21.21-25.452,27.199-10.604c3.972,9.845,2.676,20.623,1.352,26.768 c-0.56,2.602,1.427,5.047,4.089,5.047h33.64v32.163c0,3.808-4.208,6.139-7.413,4.083c-3.968-2.544-8.695-5.242-11.956-6.022 c-6.643-1.591-18.808,5.832-19.338,18.558s5.833,18.029,18.559,19.089c5.302,0.442,9.684-1.049,12.992-2.939 c3.19-1.823,7.157,0.594,7.157,4.268v34.505h-30.763c-3.789,0-6.488-3.664-5.365-7.283 c2.659-8.571,3.889-21.825-13.185-23.247c-20.937-1.745-20.204,10.288-14.621,22.634c1.674,3.703-1.069,7.896-5.133,7.896 h-29.029v-36.945C1584.589,628.347,1581.208,626.287,1578.314,627.714z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112611343973627138650000003455648543599614141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.9969,
    y1: 596.7949,
    x2: 1687.1595,
    y2: 596.7949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112611343973627138650000003455648543599614141_)"
    },
    d: "M1682.684,672.995h-30.763 c-3.242,0-6.204-1.497-8.126-4.104c-1.923-2.609-2.474-5.883-1.513-8.982c1.059-3.414,2.46-9.694-0.061-13.434 c-1.545-2.29-4.647-3.645-9.22-4.025c-6.435-0.529-10.812,0.336-12.312,2.461c-1.6,2.266-0.82,7.321,2.141,13.868 c1.411,3.119,1.143,6.703-0.717,9.585c-1.871,2.9-5.046,4.631-8.494,4.631h-29.028c-2.472,0-4.476-2.004-4.476-4.476v-36.704 c-4.893,2.386-10.223,3.822-15.847,4.272c-6.087,0.476-11.022-0.977-14.672-4.347c-4.379-4.041-6.598-10.68-6.598-19.734 c0-5.739,2.453-11.045,6.907-14.946c4.662-4.082,11.063-6.15,16.718-5.398c3.826,0.509,8.364,2.537,13.492,6.029v-32.877 c0-2.472,2.004-4.476,4.476-4.476h31.214c-2.571-4.489-3.875-10.114-3.875-16.734c0-12.686,8.696-21.01,17.285-22.678 c8.078-1.576,15.358,2.515,18.54,10.398c4.191,10.387,3.241,21.443,1.656,29.013h33.275c2.472,0,4.476,2.004,4.476,4.476 v32.162c0,3.409-1.859,6.541-4.851,8.178c-2.978,1.624-6.601,1.506-9.453-0.326c-6.296-4.034-9.333-5.138-10.583-5.437 c-1.507-0.363-4.502,0.295-7.525,2.579c-3.811,2.878-6.107,7.183-6.301,11.812c-0.405,9.74,3.379,13.519,14.458,14.441 c3.627,0.299,7.124-0.494,10.4-2.365c2.868-1.637,6.298-1.622,9.176,0.048c2.885,1.674,4.677,4.782,4.677,8.106v34.505 C1687.16,670.991,1685.156,672.995,1682.684,672.995z M1629.503,633.343c1.34,0,2.752,0.061,4.24,0.186 c7.412,0.619,12.76,3.289,15.899,7.942c3.465,5.138,3.877,12.433,1.189,21.091c-0.142,0.457,0.014,0.806,0.171,1.018 c0.155,0.212,0.441,0.463,0.92,0.463h26.287v-30.029c0-0.157-0.073-0.278-0.219-0.363c-0.137-0.079-0.193-0.05-0.243-0.02 c-4.878,2.789-10.125,3.962-15.585,3.514c-15.856-1.32-23.268-9.085-22.657-23.733c0.304-7.312,3.893-14.085,9.846-18.582 c4.87-3.68,10.485-5.216,15.006-4.143c3.242,0.776,7.603,2.937,13.329,6.609c0.064,0.039,0.16,0.101,0.329,0.007 c0.193-0.105,0.193-0.247,0.193-0.323v-27.687h-29.164c-2.632,0-5.089-1.174-6.741-3.219 c-1.648-2.041-2.276-4.681-1.723-7.247c1.12-5.199,2.462-15.252-1.129-24.151c-2.151-5.334-6.264-5.393-8.532-4.959 c-4.989,0.968-10.04,6.051-10.04,13.89c0,5.216,0.969,9.458,2.881,12.607c1.624,2.675,1.673,5.907,0.131,8.645 c-1.539,2.734-4.439,4.432-7.569,4.432h-27.258v28.69c0,3.282-1.804,6.268-4.707,7.795c-2.897,1.523-6.375,1.318-9.071-0.54 c-3.941-2.71-7.439-4.38-9.846-4.701c-3.114-0.411-6.902,0.865-9.64,3.261c-1.757,1.539-3.852,4.211-3.852,8.211 c0,6.362,1.286,10.912,3.719,13.158c1.764,1.628,4.335,2.277,7.887,2c4.559-0.365,8.859-1.53,12.78-3.466l0,0 c2.769-1.361,5.979-1.213,8.59,0.413c2.593,1.613,4.141,4.401,4.141,7.461v32.471h24.553c0.546,0,0.844-0.332,0.971-0.531 c0.149-0.232,0.284-0.601,0.083-1.045c-4.554-10.072-4.978-17.505-1.297-22.719 C1616.406,635.454,1621.705,633.343,1629.503,633.343z M1580.285,631.708c0.011,0.009,0.018,0.015,0.018,0.015l-1.989-4.01 L1580.285,631.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129917383190351181980000005710410131357039007_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.2632,
    y1: 1643.4845,
    x2: -770.7362,
    y2: 2951.4841,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129917383190351181980000005710410131357039007_)"
    },
    d: "M1385.281,629.536 c-3.22,2.16-7.468,4.262-12.258,4.741c-10.605,1.061-14.847-10.604-15.377-20.679c-0.53-10.075,8.484-19.619,16.438-18.558 c3.746,0.499,7.845,2.881,11.134,5.26c2.656,1.922,6.364,0.032,6.364-3.246v-36.185h36.608c3.051,0,5.073-3.151,3.798-5.923 c-2.872-6.243-6.099-15.729-1.599-19.823c6.992-6.363,25.882-6.363,29.064,3.181c1.781,5.344-0.639,11.774-3.114,16.398 c-1.493,2.788,0.522,6.152,3.683,6.152h31.245v33.511c0,3.575-4.043,5.796-6.958,3.728 c-13.516-9.592-28.276,0.526-29.628,11.794c-1.591,13.256,6.893,24.391,15.907,23.331c4.577-0.539,9.838-3.128,13.908-5.546 c2.989-1.776,6.771,0.357,6.771,3.834v37.015h-35.987c-4.118,0-6.872-4.295-5.087-8.006c2.127-4.422,10.844-9.851,10.32-14.04 c-1.06-8.484-19.95-10.583-30.124-9.003c-7.766,1.205-3.905,13.353,0.508,23.087c1.692,3.731-1.003,7.962-5.099,7.962h-34.216 v-35.687C1391.582,629.592,1387.972,627.731,1385.281,629.536z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181054663318725205590000018005894535803436943_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.1487,
    y1: 599.6011,
    x2: 1495.7423,
    y2: 599.6011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181054663318725205590000018005894535803436943_)"
    },
    d: "M1491.267,672.995h-35.987 c-3.499,0-6.702-1.77-8.564-4.736c-1.85-2.944-2.058-6.565-0.555-9.688c1.204-2.502,3.505-4.803,5.731-7.03 c1.385-1.386,3.655-3.654,4.128-4.747c-0.15-0.47-0.569-0.968-1.253-1.484c-4.467-3.368-16.196-4.581-23.69-3.418 c-0.255,0.039-0.385,0.096-0.414,0.114l0,0c0.011,0-1.875,3.055,4.312,16.703c1.429,3.154,1.165,6.768-0.706,9.67 c-1.862,2.891-5.029,4.616-8.471,4.616h-34.216c-2.472,0-4.476-2.004-4.476-4.476v-34.826 c-4.488,2.887-9.072,4.581-13.638,5.037c-4.465,0.448-8.564-0.809-11.848-3.625c-6.923-5.942-8.212-16.856-8.443-21.27 c-0.349-6.637,2.52-13.44,7.676-18.198c4.137-3.818,9.175-5.645,13.823-5.033c3.687,0.49,7.866,2.356,12.43,5.549v-35.283 c0-2.472,2.004-4.476,4.476-4.476h36.147c-5.301-11.703-5.42-19.972-0.352-24.581c5.403-4.917,15.96-6.936,24.555-4.692 c6.01,1.569,10.189,5.037,11.766,9.766c1.784,5.359,0.683,12.09-3.184,19.492h30.752c2.472,0,4.476,2.004,4.476,4.476v33.511 c0,3.377-1.871,6.44-4.883,7.996c-2.951,1.528-6.454,1.289-9.139-0.616c-6.14-4.36-11.567-3.012-14.26-1.82 c-4.47,1.98-7.82,6.198-8.336,10.494c-0.869,7.245,1.85,12.863,4.686,15.704c1.128,1.13,3.443,2.963,6.256,2.649 c3.114-0.365,7.312-2.076,12.143-4.948c2.81-1.672,6.179-1.705,9.017-0.092c2.829,1.611,4.517,4.515,4.517,7.773v37.014 C1495.742,670.991,1493.738,672.995,1491.267,672.995z M1437.304,632.519c7.875,0,17.358,1.501,22.853,5.645 c3.493,2.636,4.537,5.671,4.797,7.754c0.581,4.64-3.137,8.357-6.733,11.954c-1.537,1.536-3.45,3.448-3.994,4.581 c-0.211,0.439-0.08,0.809,0.067,1.042c0.129,0.205,0.428,0.549,0.987,0.549h31.511v-32.538 c-5.995,3.571-11.268,5.638-15.681,6.156c-4.867,0.562-9.711-1.281-13.638-5.217c-5.593-5.605-8.298-14.238-7.236-23.093 c0.893-7.435,6.231-14.347,13.599-17.612c7.539-3.335,15.943-2.352,23.065,2.703l-0.094-29.114h-26.783 c-3.073,0-5.848-1.571-7.426-4.207c-1.578-2.633-1.653-5.824-0.203-8.534c2.822-5.273,3.822-9.845,2.814-12.872 c-0.792-2.373-3.807-3.486-5.534-3.936c-5.626-1.466-13.077-0.256-16.27,2.653c-1.388,1.261-1.149,6.381,2.652,14.64 c1.239,2.695,1.025,5.794-0.574,8.287c-1.599,2.494-4.324,3.984-7.291,3.984h-32.132v31.708c0,3.206-1.771,6.102-4.622,7.559 c-2.853,1.46-6.24,1.193-8.841-0.684c-3.537-2.561-6.768-4.141-9.101-4.452c-1.96-0.249-4.425,0.76-6.569,2.738 c-3.174,2.928-5.017,7.201-4.809,11.148c0.353,6.7,2.396,12.428,5.334,14.948c1.441,1.237,3.075,1.72,5.128,1.512 c3.311-0.33,6.745-1.676,10.208-4.002l0.001-0.002c2.639-1.77,6.009-1.943,8.797-0.457c2.759,1.473,4.474,4.334,4.474,7.47 v31.212h29.74c0.509,0,0.797-0.28,0.947-0.514c0.128-0.199,0.309-0.61,0.076-1.123c-5.398-11.908-6.676-19.741-4.022-24.651 c0.979-1.812,2.971-4.098,6.902-4.709C1431.856,632.712,1434.477,632.519,1437.304,632.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092417376927190337260000005373669197711899796_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8879,
    y1: 1509.9434,
    x2: -946.1146,
    y2: 2817.947,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092417376927190337260000005373669197711899796_)"
    },
    d: "M1644.955,559.769 c1.324-6.144,2.62-16.922-1.352-26.768c-5.989-14.847-27.199-7.424-27.199,10.604c0,6.973,1.586,11.725,3.532,14.931 c1.673,2.757-0.386,6.279-3.612,6.279h-31.734v-36.419c0-3.352-3.619-5.382-6.531-3.722c-3.264,1.86-7.484,3.555-12.027,3.555 c-10.074,0-20.149-12.196-18.558-23.331c1.591-11.135,9.908-19.089,18.475-16.968c3.923,0.971,8.162,3.753,11.605,6.485 c2.847,2.259,7.037,0.264,7.037-3.37v-38.64h28.935c3.493,0,5.862-3.582,4.453-6.778c-5.565-12.62-1.131-32.332,20.696-21.855 c15.127,7.261,14.596,15.557,11.351,21.344c-1.83,3.265,0.457,7.289,4.2,7.289h28.198l-0.212,35.379 c-0.022,3.701,3.948,6.059,7.175,4.248c4.305-2.415,10.357-4.612,17.688-4.101c15.214,1.061,21.21,11.135,21.74,22.27 c0.53,11.135-10.605,22.801-23.861,19.619c-5.925-1.422-11.003-4.115-14.807-6.659c-3.187-2.132-7.463,0.217-7.463,4.051 v37.604h-33.64C1646.382,564.816,1644.395,562.371,1644.955,559.769z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088111441342405933360000017714171341480920224_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.8341,
    y1: 492.8227,
    x2: 1733.3081,
    y2: 492.8227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088111441342405933360000017714171341480920224_)"
    },
    d: "M1682.684,569.292h-33.64 c-2.632,0-5.089-1.174-6.741-3.219c-1.648-2.041-2.276-4.681-1.723-7.245l0,0c1.12-5.201,2.462-15.254-1.129-24.153 c-2.151-5.334-6.264-5.393-8.532-4.959c-4.989,0.968-10.04,6.051-10.04,13.89c0,5.216,0.969,9.458,2.881,12.607 c1.624,2.675,1.673,5.907,0.131,8.645c-1.539,2.734-4.439,4.432-7.569,4.432h-31.734c-2.472,0-4.476-2.004-4.476-4.476 v-36.162c-4.784,2.692-9.514,4.052-14.083,4.052c-5.86,0-11.866-3.049-16.475-8.363c-5.045-5.815-7.479-13.322-6.515-20.077 c1.091-7.631,5.028-14.404,10.533-18.112c4.125-2.782,8.9-3.689,13.449-2.566c3.875,0.959,8.279,3.363,13.091,7.148v-38.332 c0-2.472,2.004-4.476,4.476-4.476h28.936c0.058,0,0.212,0,0.328-0.177c0.102-0.155,0.055-0.262,0.03-0.319 c-3.704-8.398-3.912-20.333,2.857-26.887c3.162-3.066,10.472-7.245,23.871-0.809c8.223,3.947,13.286,8.781,15.052,14.369 c1.336,4.229,0.738,8.794-1.733,13.2c-0.037,0.066-0.135,0.24-0.01,0.457c0.091,0.153,0.197,0.166,0.306,0.166h28.198 c1.192,0,2.334,0.474,3.174,1.32c0.84,0.846,1.308,1.991,1.301,3.182l-0.212,35.379c0,0.074-0.001,0.212,0.177,0.317 c0.165,0.098,0.269,0.037,0.331,0.002c6.297-3.532,13.277-5.16,20.191-4.661c15.477,1.077,25.159,10.993,25.899,26.52 c0.338,7.079-3.102,14.494-8.975,19.354c-5.79,4.792-13.223,6.563-20.401,4.83c-5.532-1.324-11-3.779-16.251-7.291 c-0.061-0.042-0.134-0.085-0.293-0.002c-0.206,0.109-0.206,0.267-0.206,0.334v37.604 C1687.16,567.288,1685.156,569.292,1682.684,569.292z M1649.409,560.34h28.799v-33.128c0-3.449,1.893-6.602,4.939-8.23 c3.019-1.608,6.656-1.436,9.487,0.457c4.367,2.922,8.864,4.95,13.364,6.027c6.038,1.46,10.489-1.27,12.605-3.02 c3.747-3.101,5.948-7.712,5.742-12.033c-0.367-7.686-3.715-17.05-17.581-18.016c-5.232-0.374-10.35,0.822-15.187,3.538 c-2.915,1.635-6.376,1.602-9.257-0.098c-2.889-1.703-4.602-4.723-4.583-8.079l0.185-30.877h-23.695 c-3.343,0-6.344-1.718-8.029-4.594c-1.702-2.907-1.731-6.405-0.075-9.358c1.266-2.258,1.595-4.262,1.006-6.126 c-0.977-3.09-4.57-6.202-10.39-8.997c-3.651-1.751-10.299-4.187-13.771-0.831c-3.215,3.114-3.616,10.671-0.893,16.847 c1.27,2.88,1,6.176-0.721,8.818c-1.732,2.655-4.657,4.24-7.827,4.24h-24.46v34.166c0,3.403-1.9,6.436-4.961,7.915 c-3.074,1.486-6.649,1.091-9.333-1.038c-3.832-3.04-7.254-4.994-9.899-5.647c-2.643-0.658-4.881,0.345-6.295,1.298 c-3.441,2.319-5.937,6.79-6.674,11.958c-0.603,4.222,1.047,9.061,4.415,12.944c2.866,3.304,6.497,5.278,9.713,5.278 c3.052,0,6.353-0.999,9.812-2.97c2.784-1.584,6.097-1.582,8.861,0.024c2.731,1.587,4.361,4.423,4.361,7.588v31.944h26.738 c-2.571-4.489-3.875-10.114-3.875-16.734c0-12.686,8.696-21.01,17.285-22.678c8.078-1.576,15.358,2.515,18.54,10.398 C1651.944,541.714,1650.995,552.77,1649.409,560.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074418961865043198700000003530428919641776817_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.8292,
    y1: 1519.0382,
    x2: -934.1712,
    y2: 2827.0391,
    gradientTransform: "matrix(-1 0 0 1 2450.0842 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074418961865043198700000003530428919641776817_)"
    },
    d: "M1551.936,445.272 c1.262-2.411,2.411-5.345,2.959-8.665c3.057-18.514-19.857-16.017-29.017-6.473c-4.663,4.859-3.105,10.585-0.451,15.036 c1.946,3.264-0.335,7.399-4.135,7.399h-31.183v-29.867c0-3.383,3.581-5.49,6.586-3.939c3.46,1.785,8.134,3.418,13.659,3.418 c12.196,0,15.115-16.437,15.511-21.74c0.359-4.809-8.381-24.016-28.981-12.111c-2.978,1.721-6.708-0.423-6.708-3.863v-34.663 h32.004c2.669,0,4.157-3.021,2.587-5.179c-7.43-10.214-0.906-24.709,4.676-27.165c6.628-2.917,20.15-3.712,24.126,11.135 c2.076,7.752,0.162,13.407-2.142,17.043c-1.366,2.156,0.187,4.962,2.74,4.962h30.422v35.658c0,3.493-3.921,5.548-6.79,3.556 c-4.109-2.854-9.093-6.038-11.964-6.869c-5.497-1.591-16.772,1.591-18.53,14.847c-1.757,13.256,7.06,22.801,18.641,22.27 c5.212-0.239,9.508-1.52,12.657-2.857c2.841-1.206,5.985,0.946,5.985,4.032v31.169h-28.365 C1552.558,452.405,1550.237,448.52,1551.936,445.272z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122684978677127244650000004872058829061109900_",
    gradientUnits: "userSpaceOnUse",
    x1: 1485.6338,
    y1: 384.1545,
    x2: 1589.0649,
    y2: 384.1545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122684978677127244650000004872058829061109900_)"
    },
    d: "M1521.293,457.043h-31.183 c-2.472,0-4.476-2.004-4.476-4.476v-29.865c0-3.14,1.596-5.988,4.271-7.616c2.707-1.648,6.012-1.759,8.844-0.299 c3.756,1.936,7.661,2.917,11.607,2.917c9.62,0,11.034-17.42,11.047-17.597c0.015-1.362-1.943-6.932-6.613-9.662 c-4.16-2.437-9.433-1.842-15.665,1.759c-2.805,1.621-6.151,1.619-8.953,0.002c-2.8-1.617-4.47-4.511-4.47-7.741v-34.662 c0-2.472,2.004-4.476,4.476-4.476h29.718c-3.064-5.313-3.774-11.753-1.983-18.388c1.731-6.41,5.55-11.74,9.729-13.58 c4.925-2.163,12.588-3.326,19.346-0.081c3.724,1.785,8.639,5.693,10.906,14.155c2.188,8.171,0.573,14.45-1.594,18.687h28.29 c2.472,0,4.476,2.004,4.476,4.476v35.659c0,3.289-1.811,6.279-4.725,7.802c-2.909,1.525-6.396,1.305-9.094-0.57 c-7.239-5.029-9.985-6.051-10.654-6.246c-1.393-0.4-4.519-0.31-7.431,1.591c-2.974,1.943-4.847,5.243-5.419,9.544 c-0.69,5.206,0.564,9.852,3.529,13.086c2.617,2.85,6.345,4.31,10.47,4.126c3.872-0.177,7.612-1.021,11.116-2.507 c2.696-1.143,5.776-0.861,8.234,0.769c2.488,1.646,3.973,4.406,3.973,7.384v31.168c0,2.472-2.004,4.476-4.476,4.476h-28.365 c-3.292,0-6.273-1.678-7.974-4.489c-1.709-2.823-1.814-6.259-0.279-9.192l0,0c1.261-2.413,2.104-4.874,2.509-7.319 c0.988-5.986-1.628-7.297-2.487-7.728c-4.689-2.345-14.216,0.216-18.885,5.081c-1.03,1.075-3.445,3.591,0.164,9.644 c1.734,2.907,1.778,6.532,0.114,9.463C1527.712,455.286,1524.688,457.043,1521.293,457.043z M1494.594,448.092h26.699 c0.09,0,0.211,0,0.309-0.173c0.123-0.219,0.021-0.391-0.019-0.457c-4.58-7.684-4.203-14.937,1.067-20.427 c6.371-6.637,19.288-11.082,28.321-7.356c-0.809-0.658-1.575-1.381-2.295-2.166c-4.789-5.221-6.851-12.435-5.807-20.313 c1.167-8.801,5.754-13.484,9.397-15.864c4.497-2.937,10.313-3.997,14.814-2.692c1.045,0.302,4.207,1.217,13.034,7.326v-30.897 h-25.946c-2.817,0-5.409-1.532-6.765-3.997c-1.353-2.463-1.259-5.464,0.246-7.837c2.43-3.835,2.968-8.374,1.598-13.488 c-1.114-4.157-3.175-6.984-6.131-8.403c-3.766-1.805-8.677-1.2-11.869,0.208c-1.031,0.452-3.467,3.184-4.692,7.717 c-0.75,2.778-1.509,8.125,1.833,12.719c1.73,2.378,1.98,5.479,0.65,8.09c-1.318,2.59-3.945,4.198-6.857,4.198h-27.528v30.187 c11.805-6.84,20.22-4.543,25.201-1.418c7.258,4.556,10.801,13.375,10.477,17.728c-0.72,9.611-5.736,25.879-19.974,25.879 c-5.386,0-10.671-1.316-15.71-3.914L1494.594,448.092z M1555.265,422.405c3.625,3.387,5.088,8.632,4.046,14.933 c-0.558,3.385-1.706,6.753-3.409,10.009l0,0c-0.033,0.066-0.112,0.214,0.005,0.409c0.105,0.173,0.242,0.173,0.317,0.173h23.89 v-26.504c-4.417,1.84-9.113,2.885-13.962,3.108C1562.252,424.713,1558.548,423.974,1555.265,422.405z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2156.667,540.515l-2.282-3.055c-0.065-0.086-0.185-0.259-0.36-0.512 c-0.621-0.895-1.914-2.76-3.864-5.24c-0.527-0.671-0.412-1.641,0.26-2.17c0.671-0.528,1.643-0.411,2.168,0.259 c0.832,1.059,1.546,2.006,2.145,2.82c0.314-0.394,0.817-0.628,1.356-0.575c0.849,0.081,1.471,0.836,1.39,1.687 c-0.188,1.948-0.324,3.004-0.324,3.004L2156.667,540.515z M2157.02,524.987c-0.139,0.033-0.282,0.046-0.431,0.039 c-0.852-0.044-1.508-0.769-1.465-1.62c0.166-3.3,0.272-6.685,0.316-10.058c0.012-0.853,0.707-1.538,1.566-1.525 c0.853,0.011,1.535,0.711,1.524,1.564c-0.045,3.414-0.153,6.836-0.321,10.172 C2158.173,524.263,2157.673,524.834,2157.02,524.987z M2145.115,524.594c-0.517,0.121-1.083-0.028-1.474-0.442 c-2.34-2.468-4.763-4.783-7.202-6.876c-0.647-0.556-0.721-1.531-0.167-2.18c0.558-0.641,1.532-0.722,2.179-0.165 c2.52,2.164,5.021,4.55,7.432,7.094c0.587,0.619,0.562,1.598-0.059,2.185C2145.618,524.406,2145.374,524.534,2145.115,524.594z  M2129.743,511.495c-0.4,0.094-0.836,0.029-1.204-0.215c-2.842-1.882-5.737-3.502-8.608-4.817 c-0.775-0.354-1.116-1.272-0.761-2.047c0.357-0.777,1.274-1.117,2.049-0.761c3.015,1.381,6.052,3.079,9.025,5.048 c0.712,0.472,0.907,1.43,0.437,2.141C2130.452,511.186,2130.113,511.408,2129.743,511.495z M2157.29,504.757 c-0.102,0.024-0.209,0.037-0.319,0.04c-0.854,0.019-1.56-0.657-1.58-1.51c-0.076-3.351-0.216-6.731-0.413-10.049 c-0.05-0.85,0.602-1.581,1.45-1.633c0.852-0.051,1.584,0.599,1.635,1.451c0.2,3.354,0.341,6.772,0.418,10.161 C2158.497,503.961,2157.986,504.594,2157.29,504.757z M2111.401,503.225c-0.229,0.054-0.474,0.054-0.717-0.004 c-2.278-0.556-4.585-0.935-6.86-1.128c-1.011-0.086-1.994-0.186-2.945-0.301c-0.847-0.102-1.451-0.871-1.349-1.718 c0.102-0.845,0.869-1.452,1.718-1.349c0.916,0.11,1.861,0.207,2.836,0.289c2.434,0.207,4.9,0.611,7.331,1.204 c0.829,0.201,1.338,1.037,1.136,1.867C2112.408,502.671,2111.95,503.096,2111.401,503.225z M2073.417,509.583l-3.009,0.645 c-0.662-2.13-2.02-3.709-4.542-5.28c-0.724-0.452-0.945-1.404-0.493-2.128c0.45-0.724,1.403-0.947,2.128-0.494 c1.996,1.244,3.451,2.56,4.477,4.083c0.634,0.132,1.141,0.656,1.221,1.334L2073.417,509.583z M2091.521,499.791 c-0.251,0.059-0.521,0.056-0.786-0.023c-3.618-1.061-6.853-2.458-9.618-4.149c-0.727-0.446-0.956-1.396-0.51-2.125 c0.444-0.729,1.395-0.956,2.124-0.512c2.532,1.551,5.517,2.835,8.873,3.82c0.819,0.24,1.289,1.1,1.049,1.918 C2092.49,499.274,2092.045,499.669,2091.521,499.791z M2156.078,484.567c-0.066,0.015-0.133,0.025-0.202,0.033 c-0.849,0.083-1.606-0.537-1.689-1.385c-0.332-3.355-0.735-6.713-1.195-9.977c-0.119-0.847,0.471-1.619,1.315-1.746 c0.844-0.119,1.626,0.469,1.746,1.313c0.466,3.308,0.872,6.707,1.208,10.104 C2157.338,483.69,2156.821,484.393,2156.078,484.567z M2070.916,499.344c-0.064,0.015-0.13,0.024-0.198,0.032 c-0.85,0.087-1.608-0.532-1.694-1.38c-0.399-3.918-0.707-7.328-0.917-10.136c-0.063-0.851,0.582-1.582,1.426-1.656 c0.851-0.063,1.593,0.574,1.656,1.426c0.207,2.78,0.513,6.164,0.909,10.052 C2072.178,498.464,2071.661,499.169,2070.916,499.344z M2057.976,500.691c-0.322,0.075-0.671,0.049-0.996-0.1 c-2.759-1.266-5.776-2.699-9.141-4.589c-0.744-0.418-1.009-1.359-0.591-2.105c0.419-0.743,1.362-1.004,2.104-0.59 c3.268,1.837,6.217,3.235,8.918,4.475c0.774,0.356,1.115,1.274,0.759,2.049 C2058.822,500.282,2058.425,500.586,2057.976,500.691z M2074.841,489.066c-0.586,0.137-1.225-0.078-1.603-0.596 c-2.214-3.038-3.251-5.939-3.871-7.674c-0.194-0.543-0.347-0.983-0.497-1.291c-0.458-0.72-0.293-1.763,0.427-2.219 c0.716-0.458,1.628-0.334,2.086,0.388c0.082,0.129,0.171,0.286,0.263,0.474c0.187,0.384,0.389,0.931,0.631,1.608 c0.6,1.678,1.507,4.216,3.459,6.896c0.502,0.69,0.35,1.656-0.34,2.158C2075.226,488.935,2075.037,489.02,2074.841,489.066z  M2153.237,464.543c-0.022,0.005-0.044,0.01-0.068,0.016c-0.838,0.158-1.646-0.396-1.803-1.233 c-0.555-2.946-1.171-5.875-1.833-8.703l-0.263-1.112c-0.198-0.829,0.313-1.663,1.143-1.861 c0.003-0.001,0.006-0.001,0.006-0.001c0.83-0.194,1.658,0.316,1.856,1.143l0.267,1.128c0.673,2.872,1.298,5.845,1.86,8.834 C2154.555,463.569,2154.038,464.356,2153.237,464.543z M2040.431,490.737c-0.419,0.098-0.877,0.023-1.253-0.248 c-2.707-1.942-5.401-4.1-8.007-6.41c-0.638-0.566-0.696-1.542-0.13-2.182c0.564-0.637,1.542-0.696,2.181-0.131 c2.527,2.242,5.138,4.332,7.758,6.212c0.693,0.497,0.852,1.463,0.354,2.156 C2041.106,490.451,2040.781,490.655,2040.431,490.737z M2025.304,477.393c-0.518,0.121-1.085-0.03-1.477-0.445 c-0.497-0.526-0.997-1.064-1.5-1.614c-1.834-2.006-3.557-4.117-5.121-6.278c-0.5-0.69-0.346-1.657,0.345-2.157 c0.698-0.498,1.658-0.344,2.157,0.347c1.495,2.065,3.143,4.085,4.898,6.004c0.491,0.538,0.98,1.062,1.467,1.579 c0.585,0.619,0.557,1.597-0.064,2.183C2025.806,477.204,2025.561,477.333,2025.304,477.393z M2148.492,444.896 c-0.788,0.185-1.594-0.274-1.83-1.06c-0.973-3.243-2.039-6.44-3.167-9.499c-0.295-0.799,0.115-1.688,0.915-1.982 c0.808-0.323,1.69,0.115,1.985,0.915c1.151,3.119,2.237,6.375,3.228,9.68c0.245,0.817-0.219,1.678-1.036,1.923 C2148.555,444.881,2148.524,444.888,2148.492,444.896z M2013.519,461.053c-0.674,0.158-1.394-0.154-1.725-0.799 c-1.569-3.046-2.921-6.25-4.018-9.522c-0.271-0.808,0.165-1.683,0.973-1.955c0.827-0.246,1.686,0.165,1.957,0.974 c1.048,3.123,2.339,6.181,3.836,9.089c0.39,0.758,0.092,1.69-0.667,2.081C2013.759,460.98,2013.64,461.024,2013.519,461.053z  M2141.473,425.949c-0.705,0.165-1.451-0.186-1.76-0.871c-1.383-3.073-2.879-6.083-4.444-8.945 c-0.409-0.748-0.135-1.688,0.615-2.097c0.747-0.402,1.687-0.135,2.096,0.615c1.603,2.93,3.135,6.013,4.551,9.159 c0.351,0.778,0.004,1.692-0.775,2.043C2141.664,425.895,2141.569,425.927,2141.473,425.949z M2007.091,441.958 c-0.026,0.006-0.052,0.012-0.079,0.017c-0.84,0.152-1.643-0.406-1.794-1.245c-0.604-3.351-0.979-6.803-1.115-10.258 c-0.034-0.854,0.633-1.578,1.483-1.605c0.853-0.034,1.571,0.63,1.605,1.482c0.131,3.314,0.49,6.622,1.068,9.831 C2008.406,440.993,2007.886,441.772,2007.091,441.958z M2131.756,408.249c-0.609,0.143-1.271-0.098-1.638-0.649 c-1.856-2.79-3.84-5.487-5.896-8.019c-0.538-0.663-0.437-1.636,0.225-2.174c0.664-0.537,1.636-0.436,2.174,0.225 c2.117,2.607,4.159,5.384,6.069,8.255c0.473,0.711,0.281,1.67-0.43,2.143C2132.102,408.136,2131.931,408.208,2131.756,408.249z  M2006.292,421.815c-0.162,0.038-0.331,0.049-0.505,0.031c-0.849-0.083-1.469-0.84-1.385-1.69 c0.226-2.276,1.072-8.551,2.201-10.49l-0.021-0.011l2.179-3.787c0.427-0.739,1.371-0.996,2.11-0.569 c0.739,0.425,0.994,1.369,0.569,2.108l-2.248,3.909c-0.286,0.718-1.208,4.038-1.714,9.147 C2007.41,421.138,2006.918,421.668,2006.292,421.815z M2119.015,392.607c-0.503,0.118-1.054-0.021-1.447-0.414 c-2.349-2.35-4.833-4.583-7.386-6.637c-0.665-0.536-0.77-1.506-0.235-2.171c0.536-0.663,1.508-0.771,2.172-0.237 c2.639,2.124,5.208,4.431,7.635,6.862c0.603,0.604,0.603,1.581-0.001,2.184 C2119.543,392.407,2119.286,392.544,2119.015,392.607z M2103.302,379.967c-0.391,0.091-0.817,0.033-1.182-0.2 c-2.764-1.762-5.674-3.401-8.65-4.87c-0.765-0.376-1.08-1.303-0.701-2.069c0.378-0.764,1.305-1.078,2.069-0.701 c3.077,1.519,6.085,3.211,8.944,5.033c0.719,0.46,0.931,1.415,0.472,2.134C2104.027,379.647,2103.68,379.878,2103.302,379.967z  M2015.494,399.378c-0.368,0.086-0.768,0.04-1.123-0.165c-0.739-0.425-0.994-1.369-0.568-2.11l5.042-8.76 c0.426-0.741,1.37-0.998,2.11-0.569c0.739,0.425,0.994,1.369,0.568,2.108l-5.042,8.762 C2016.259,399.031,2015.896,399.284,2015.494,399.378z M2085.229,371.032c-0.286,0.067-0.592,0.053-0.887-0.056 c-3.042-1.125-6.234-2.132-9.487-2.991c-0.825-0.219-1.317-1.063-1.099-1.888c0.217-0.828,1.062-1.318,1.889-1.099 c3.348,0.885,6.634,1.921,9.769,3.079c0.8,0.297,1.209,1.185,0.913,1.987C2086.138,370.567,2085.716,370.918,2085.229,371.032z  M2025.577,381.853c-0.368,0.086-0.768,0.04-1.122-0.165c-0.739-0.425-0.994-1.369-0.568-2.108l5.041-8.763 c0.426-0.741,1.37-0.996,2.11-0.569c0.739,0.425,0.994,1.369,0.568,2.108l-5.041,8.764 C2026.343,381.506,2025.98,381.759,2025.577,381.853z M2065.734,365.867c-0.195,0.046-0.402,0.053-0.611,0.017 c-3.194-0.546-6.522-0.98-9.893-1.288c-0.849-0.077-1.476-0.829-1.398-1.679c0.077-0.85,0.826-1.483,1.68-1.397 c3.45,0.314,6.859,0.759,10.131,1.318c0.842,0.144,1.407,0.942,1.263,1.783C2066.798,365.253,2066.322,365.73,2065.734,365.867 z M2045.641,364.012c-0.123,0.029-0.253,0.043-0.385,0.039c-2.965-0.06-6.029-0.035-9.117,0.078 c-0.469,0.298-1.084,0.333-1.6,0.036c-0.74-0.427-0.994-1.371-0.569-2.11l0.549-0.956l0.852-0.033 c3.368-0.135,6.715-0.171,9.949-0.104c0.853,0.017,1.53,0.723,1.513,1.577C2046.818,363.26,2046.312,363.855,2045.641,364.012z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107583611569657513550000010695722749915233214_",
    gradientUnits: "userSpaceOnUse",
    x1: 1682.8137,
    y1: 265.8727,
    x2: 1695.6611,
    y2: 139.2339,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107583611569657513550000010695722749915233214_)"
    },
    d: "M2021.186,392.322 c0,0-8.307,44.022,23.351,53.606c31.659,9.584,65.978,11.396,73.392,25.085c0,0-0.396-87.601-87.401-91.439L2021.186,392.322z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106855040366902149750000015678738296472666027_",
    gradientUnits: "userSpaceOnUse",
    x1: 1573.312,
    y1: 193.2193,
    x2: 1621.9489,
    y2: 94.1103,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106855040366902149750000015678738296472666027_)"
    },
    d: "M1927.667,379.883 c0,0-22.775,37.628-15.209,50.473c7.196,12.218,90.682,66.502,98.812,71.77c0.365,0.237,0.84,0.145,1.105-0.201l0,0 c2.19-2.861,2.885-6.584,1.866-10.041c-4.919-16.695-20.033-66.417-29.425-79.985 C1973.475,395.514,1927.667,379.883,1927.667,379.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1984.949,477.912c-0.264,0.062-0.552,0.018-0.795-0.147 c-0.456-0.307-45.663-30.827-64.612-44.724c-3.374-2.473-4.974-6.706-4.078-10.781c1.729-7.853,4.843-19.498,9.86-30.386 c0.233-0.507,0.833-0.73,1.341-0.495c0.507,0.235,0.729,0.836,0.496,1.342c-5.204,11.289-8.325,23.625-9.722,29.973 c-0.724,3.295,0.571,6.716,3.299,8.716c18.917,13.874,64.093,44.373,64.546,44.678c0.463,0.312,0.585,0.94,0.273,1.405 C1985.409,477.713,1985.189,477.856,1984.949,477.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156552440199094844250000005474495555785768607_",
    gradientUnits: "userSpaceOnUse",
    x1: 1827.3984,
    y1: 197.851,
    x2: 1751.6908,
    y2: 69.8363,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156552440199094844250000005474495555785768607_)"
    },
    d: "M1989.775,298.742 c0,0,30.375-31.81,44.751-27.862c13.673,3.756,87.874,70.169,95.083,76.642c0.324,0.291,0.359,0.773,0.094,1.119l0,0 c-2.19,2.861-5.603,4.504-9.205,4.423c-17.4-0.389-69.344-1.994-84.894-7.517 C2016.825,338.878,1989.775,298.742,1989.775,298.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M2098.582,329.457c-0.305,0.072-0.638,0.001-0.893-0.219 c-0.415-0.359-41.651-36.002-59.982-50.64c-2.643-2.113-6.285-2.471-9.275-0.909c-5.764,3.006-16.856,9.24-26.396,17.211 c-0.424,0.365-1.065,0.3-1.424-0.127c-0.358-0.427-0.3-1.065,0.128-1.423c9.685-8.093,20.922-14.408,26.757-17.453 c3.702-1.927,8.206-1.487,11.473,1.121c18.361,14.663,59.628,50.334,60.043,50.691c0.422,0.365,0.468,1.004,0.103,1.426 C2098.97,329.301,2098.781,329.41,2098.582,329.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057147797071150511190000008424141971206441395_",
    gradientUnits: "userSpaceOnUse",
    x1: 1831.5459,
    y1: 306.4744,
    x2: 1888.1622,
    y2: 876.6776,
    gradientTransform: "matrix(0.9858 -0.1677 0.1677 0.9858 54.9916 260.7967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057147797071150511190000008424141971206441395_)"
    },
    d: "M1810.705,289.642 c12.113,17.625,27.983,35.541,48.745,51.527c64.459,49.635,120.421,74.969,136.526,81.746c2.912,1.226,6.247,0.724,8.72-1.244 c19.489-15.509,34.328-34.607,44.548-57.273c1.923-4.264,1.268-9.258-1.64-12.922c-12.616-15.9-51.059-61.339-113.014-108.475 c-20.696-15.746-41.967-26.347-62.009-33.438C1839.125,234.732,1820.261,269.394,1810.705,289.642z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170964917671286830070000014341846321284775607_",
    gradientUnits: "userSpaceOnUse",
    x1: 1732.0896,
    y1: -161.3018,
    x2: 1629.3098,
    y2: -12.6386,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170964917671286830070000014341846321284775607_)"
    },
    d: "M1872.582,209.563 c-44.27-15.661-82.532-14.177-95.294-13.073c-2.494,0.215-4.255,2.515-3.812,4.98c2.259,12.563,10.769,49.672,37.23,88.172 C1820.261,269.394,1839.125,234.732,1872.582,209.563z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1917.616,256.375c16.733,12.808,19.155,37.75,5.408,55.71 c-13.746,17.96-38.456,22.136-55.189,9.327c-16.733-12.808-19.155-37.75-5.408-55.71 C1876.174,247.743,1900.883,243.567,1917.616,256.375z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137111315231596690240000002281890256422581405_",
    gradientUnits: "userSpaceOnUse",
    x1: 1662.5676,
    y1: -34.3657,
    x2: 1727.8276,
    y2: -34.3657,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137111315231596690240000002281890256422581405_)"
    },
    d: "M1912.407,261.423 c13.333,10.206,15.263,30.08,4.309,44.39c-10.953,14.31-30.642,17.638-43.975,7.432c-13.333-10.206-15.263-30.08-4.309-44.39 C1879.385,254.546,1899.074,251.218,1912.407,261.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1874.194,302.046c-0.386,0.09-0.807-0.052-1.053-0.396c-6.279-8.787-5.885-21.169,0.957-30.107 c1.727-2.254,3.771-4.198,6.077-5.777c0.461-0.315,1.09-0.198,1.405,0.263c0.316,0.46,0.198,1.089-0.263,1.404 c-2.129,1.459-4.018,3.254-5.613,5.339c-6.307,8.239-6.684,19.631-0.918,27.701c0.325,0.455,0.22,1.086-0.235,1.41 C1874.441,301.964,1874.319,302.016,1874.194,302.046z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1970.06,314.018c11.055,8.461,12.654,24.939,3.573,36.804 c-9.081,11.865-25.405,14.623-36.46,6.162c-11.055-8.461-12.654-24.939-3.573-36.804 C1942.682,308.315,1959.005,305.556,1970.06,314.018z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005952718974635122660000016533326820360772511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1673.2511,
    y1: 42.6767,
    x2: 1716.3641,
    y2: 42.6767,
    gradientTransform: "matrix(0.6078 -0.7941 0.7941 0.6078 889.5229 1654.3785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005952718974635122660000016533326820360772511_)"
    },
    d: "M1966.619,317.353 c8.809,6.743,10.083,19.872,2.847,29.326c-7.236,9.454-20.243,11.652-29.052,4.91s-10.083-19.871-2.847-29.325 C1944.803,312.809,1957.81,310.611,1966.619,317.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1941.453,344.524c-0.387,0.091-0.807-0.053-1.053-0.396 c-4.235-5.926-3.974-14.274,0.638-20.299c1.162-1.517,2.539-2.825,4.094-3.888c0.455-0.317,1.089-0.198,1.405,0.263 c0.314,0.46,0.197,1.09-0.264,1.404c-1.377,0.943-2.599,2.105-3.629,3.451c-4.076,5.324-4.323,12.683-0.599,17.892 c0.324,0.455,0.22,1.086-0.234,1.409C1941.699,344.441,1941.578,344.494,1941.453,344.524z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2161.472,562.792l1.556,10.021c0.13,0.841-0.393,1.637-1.17,1.779 c-0.776,0.141-1.512-0.426-1.642-1.267l-0.007-0.042l-1.538-9.902l-0.012-0.078c-0.131-0.841,0.393-1.638,1.17-1.779 C2160.606,561.383,2161.342,561.95,2161.472,562.792L2161.472,562.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2164.358,582.841l1.167,10.048c0.098,0.845-0.455,1.616-1.236,1.722 c-0.781,0.107-1.492-0.493-1.591-1.337l-0.003-0.024l-1.162-9.999l-0.003-0.026c-0.098-0.845,0.455-1.617,1.236-1.723 C2163.547,581.396,2164.26,581.995,2164.358,582.841L2164.358,582.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2166.548,602.954l0.889,10.08c0.075,0.846-0.499,1.599-1.281,1.679 c-0.782,0.081-1.477-0.54-1.551-1.387l-0.002-0.021l-0.887-10.037l-0.002-0.022c-0.075-0.847,0.499-1.599,1.281-1.681 C2165.778,601.486,2166.473,602.107,2166.548,602.954L2166.548,602.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2168.199,623.126l0.637,10.1c0.054,0.848-0.538,1.582-1.32,1.64 c-0.783,0.058-1.461-0.582-1.514-1.43l-0.001-0.02l-0.637-10.06l-0.001-0.02c-0.054-0.848,0.538-1.582,1.321-1.64 C2167.467,621.638,2168.145,622.278,2168.199,623.126L2168.199,623.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2169.352,643.332l0.394,10.115c0.033,0.848-0.575,1.564-1.358,1.6 c-0.783,0.036-1.445-0.623-1.478-1.47l0-0.019l-0.395-10.075l0-0.02c-0.034-0.848,0.575-1.565,1.358-1.601 C2168.656,641.825,2169.318,642.484,2169.352,643.332L2169.352,643.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2170.021,663.562l0.154,10.121c0.013,0.847-0.611,1.545-1.394,1.559 c-0.782,0.014-1.427-0.661-1.44-1.509v-0.02l-0.155-10.081l0-0.02c-0.013-0.848,0.611-1.546,1.395-1.561 C2169.362,662.038,2170.007,662.714,2170.021,663.562L2170.021,663.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2170.207,683.808l-0.089,10.125c-0.007,0.846-0.647,1.526-1.429,1.518 c-0.782-0.008-1.409-0.701-1.402-1.547v-0.02l0.087-10.085v-0.02c0.008-0.847,0.648-1.527,1.43-1.519 C2169.586,682.268,2170.214,682.961,2170.207,683.808L2170.207,683.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2169.906,704.052l-0.336,10.116c-0.028,0.845-0.683,1.505-1.463,1.475 c-0.781-0.031-1.39-0.74-1.362-1.585l0.001-0.021l0.333-10.075l0-0.02c0.028-0.846,0.684-1.506,1.464-1.476 C2169.324,702.497,2169.934,703.206,2169.906,704.052L2169.906,704.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2169.108,724.281l-0.59,10.106c-0.049,0.842-0.719,1.482-1.498,1.429 c-0.778-0.053-1.369-0.779-1.32-1.622l0.001-0.021l0.586-10.064l0.001-0.021c0.049-0.843,0.72-1.483,1.499-1.43 C2168.565,722.711,2169.157,723.438,2169.108,724.281L2169.108,724.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2167.798,744.484l-0.852,10.087c-0.071,0.84-0.757,1.458-1.533,1.381 c-0.775-0.077-1.346-0.82-1.276-1.659l0.002-0.022l0.847-10.043l0.002-0.022c0.071-0.84,0.757-1.459,1.533-1.382 C2167.297,742.901,2167.869,743.644,2167.798,744.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2165.959,764.643l-1.123,10.05c-0.093,0.836-0.795,1.432-1.567,1.33 c-0.772-0.101-1.322-0.861-1.229-1.697l0.003-0.022l1.116-10.005l0.002-0.023c0.093-0.836,0.795-1.432,1.568-1.331 C2165.502,763.046,2166.052,763.807,2165.959,764.643L2165.959,764.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2163.573,784.725l-1.404,10.011c-0.116,0.831-0.833,1.402-1.602,1.276 c-0.768-0.126-1.296-0.903-1.179-1.734l0.003-0.023l1.396-9.965l0.003-0.023c0.116-0.832,0.834-1.404,1.602-1.278 C2163.162,783.115,2163.691,783.892,2163.573,784.725L2163.573,784.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2160.62,804.722l-1.698,9.959c-0.14,0.826-0.873,1.372-1.636,1.22 c-0.763-0.153-1.267-0.946-1.127-1.772l0.004-0.024l1.688-9.911l0.004-0.024c0.141-0.827,0.874-1.373,1.637-1.221 C2160.256,803.102,2160.76,803.895,2160.62,804.722L2160.62,804.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2157.074,824.611l-2.002,9.895c-0.166,0.819-0.914,1.338-1.67,1.159 c-0.757-0.179-1.236-0.989-1.07-1.809l0.005-0.024l1.99-9.846l0.005-0.024c0.165-0.821,0.914-1.339,1.671-1.16 C2156.76,822.981,2157.24,823.791,2157.074,824.611L2157.074,824.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2152.912,844.363l-2.32,9.816c-0.192,0.811-0.955,1.301-1.705,1.093 c-0.75-0.208-1.202-1.034-1.01-1.846l0.006-0.026l2.306-9.764l0.006-0.026c0.192-0.812,0.956-1.302,1.706-1.095 C2152.651,842.724,2153.104,843.551,2152.912,844.363L2152.912,844.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2148.108,863.948l-2.65,9.719c-0.219,0.802-0.997,1.261-1.738,1.024 c-0.741-0.237-1.165-1.08-0.946-1.882l0.008-0.027l2.633-9.665l0.007-0.027c0.219-0.803,0.998-1.262,1.739-1.025 C2147.903,862.302,2148.327,863.145,2148.108,863.948L2148.108,863.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2142.639,883.33l-2.992,9.603c-0.247,0.792-1.039,1.217-1.771,0.95 c-0.731-0.267-1.124-1.125-0.877-1.917l0.009-0.027l2.973-9.548l0.009-0.028c0.246-0.792,1.04-1.218,1.772-0.951 C2142.493,881.678,2142.886,882.537,2142.639,883.33L2142.639,883.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2136.479,902.47l-3.346,9.466c-0.276,0.779-1.083,1.169-1.803,0.871 c-0.72-0.298-1.08-1.172-0.804-1.951l0.01-0.029l3.324-9.409l0.01-0.029c0.275-0.78,1.083-1.171,1.803-0.872 C2136.394,900.816,2136.755,901.69,2136.479,902.47L2136.479,902.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2129.605,921.327l-3.711,9.308c-0.305,0.765-1.125,1.117-1.832,0.787 c-0.707-0.33-1.032-1.218-0.727-1.984l0.011-0.03l3.686-9.248l0.012-0.029c0.305-0.766,1.126-1.119,1.833-0.789 C2129.585,919.672,2129.911,920.561,2129.605,921.327L2129.605,921.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2121.997,939.853l-4.085,9.123c-0.336,0.749-1.168,1.062-1.86,0.699 c-0.692-0.363-0.981-1.265-0.645-2.014l0.013-0.03l4.057-9.063l0.013-0.031c0.336-0.749,1.169-1.063,1.861-0.699 C2122.043,938.201,2122.333,939.103,2121.997,939.853L2121.997,939.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2113.636,957.997l-4.467,8.912c-0.366,0.731-1.21,1.002-1.885,0.606 c-0.675-0.396-0.925-1.31-0.559-2.041l0.015-0.031l4.435-8.851l0.015-0.031c0.366-0.731,1.211-1.002,1.886-0.605 C2113.752,956.351,2114.003,957.266,2113.636,957.997L2113.636,957.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2104.51,975.706l-4.853,8.674c-0.397,0.71-1.251,0.938-1.907,0.507 c-0.656-0.43-0.865-1.354-0.468-2.064l0.017-0.031l4.816-8.613l0.018-0.031c0.398-0.711,1.252-0.938,1.908-0.508 C2104.698,974.071,2104.908,974.996,2104.51,975.706L2104.51,975.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2094.612,992.925l-5.24,8.408c-0.428,0.687-1.291,0.869-1.925,0.405 c-0.635-0.464-0.802-1.397-0.374-2.085l0.019-0.03l5.2-8.346l0.019-0.031c0.429-0.688,1.291-0.869,1.927-0.405 C2094.873,991.303,2095.04,992.237,2094.612,992.925L2094.612,992.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2083.939,1009.595l-5.624,8.112c-0.459,0.662-1.327,0.796-1.939,0.299 c-0.612-0.497-0.735-1.437-0.276-2.099l0.021-0.03l5.58-8.052l0.021-0.03c0.459-0.663,1.328-0.797,1.94-0.3 C2084.275,1007.992,2084.399,1008.932,2083.939,1009.595L2083.939,1009.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2072.501,1025.661l-6.003,7.789c-0.49,0.635-1.362,0.72-1.948,0.19 c-0.587-0.53-0.665-1.474-0.176-2.109l0.022-0.03l5.955-7.731l0.023-0.03c0.49-0.636,1.362-0.721,1.949-0.191 C2072.911,1024.081,2072.99,1025.025,2072.501,1025.661L2072.501,1025.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2060.311,1041.068l-6.369,7.44c-0.519,0.605-1.393,0.641-1.952,0.08 c-0.559-0.561-0.593-1.508-0.074-2.114l0.024-0.029l6.319-7.384l0.024-0.028c0.519-0.607,1.394-0.643,1.954-0.081 C2060.797,1039.515,2060.83,1040.461,2060.311,1041.068L2060.311,1041.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2047.394,1055.764l-6.721,7.068c-0.547,0.575-1.42,0.561-1.951-0.031 c-0.531-0.592-0.518-1.537,0.028-2.112l0.026-0.027l6.669-7.015l0.026-0.027c0.547-0.575,1.421-0.561,1.952,0.031 C2047.954,1054.242,2047.942,1055.189,2047.394,1055.764L2047.394,1055.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2033.781,1069.707l-7.055,6.676c-0.573,0.542-1.443,0.479-1.944-0.141 c-0.501-0.62-0.442-1.563,0.131-2.105l0.027-0.025l7-6.626l0.027-0.026c0.573-0.542,1.444-0.479,1.946,0.141 C2034.413,1068.221,2034.355,1069.164,2033.781,1069.707L2033.781,1069.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2019.512,1082.857l-7.367,6.269c-0.597,0.508-1.463,0.396-1.932-0.25 c-0.469-0.647-0.366-1.584,0.232-2.092l0.028-0.024l7.31-6.223l0.028-0.024c0.598-0.509,1.464-0.396,1.934,0.25 C2020.214,1081.41,2020.11,1082.347,2019.512,1082.857L2019.512,1082.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2004.631,1095.186l-7.655,5.85c-0.62,0.474-1.478,0.314-1.915-0.357 c-0.438-0.671-0.29-1.6,0.33-2.074l0.028-0.022l7.596-5.808l0.028-0.022c0.621-0.475,1.479-0.314,1.917,0.357 C2005.4,1093.783,2005.252,1094.712,2004.631,1095.186L2004.631,1095.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1989.188,1106.676l-7.917,5.426c-0.64,0.439-1.488,0.232-1.894-0.461 c-0.405-0.693-0.215-1.612,0.425-2.05l0.028-0.02l7.858-5.388l0.029-0.02c0.641-0.439,1.489-0.233,1.896,0.46 C1990.02,1105.317,1989.829,1106.236,1989.188,1106.676L1989.188,1106.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1973.234,1117.315l-8.151,5c-0.659,0.404-1.495,0.154-1.869-0.559 c-0.373-0.713-0.142-1.619,0.517-2.023l0.028-0.018l8.093-4.967l0.029-0.017c0.659-0.405,1.496-0.154,1.87,0.559 C1974.125,1116.004,1973.894,1116.911,1973.234,1117.315L1973.234,1117.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1956.831,1127.1l-8.354,4.575c-0.675,0.37-1.498,0.077-1.839-0.654 c-0.341-0.731-0.071-1.622,0.604-1.991l0.028-0.015l8.296-4.546l0.028-0.016c0.675-0.37,1.499-0.077,1.841,0.653 C1957.777,1125.838,1957.506,1126.729,1956.831,1127.1L1956.831,1127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1940.029,1136.04l-8.537,4.159c-0.689,0.336-1.498,0.003-1.808-0.743 c-0.31-0.745-0.003-1.622,0.686-1.957l0.027-0.013l8.481-4.134l0.028-0.014c0.689-0.336,1.499-0.003,1.809,0.743 C1941.025,1134.827,1940.718,1135.704,1940.029,1136.04L1940.029,1136.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1922.872,1144.154l-8.697,3.753c-0.7,0.302-1.495-0.068-1.774-0.826 c-0.279-0.759,0.063-1.618,0.763-1.921l0.027-0.011l8.642-3.732l0.027-0.012c0.701-0.302,1.496,0.067,1.775,0.826 C1923.915,1142.991,1923.573,1143.851,1922.872,1144.154L1922.872,1144.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1905.409,1151.462l-8.832,3.359c-0.71,0.271-1.489-0.134-1.738-0.903 c-0.25-0.77,0.124-1.612,0.834-1.882l0.026-0.01l8.78-3.342l0.026-0.01c0.711-0.27,1.49,0.134,1.74,0.904 C1906.494,1150.348,1906.12,1151.192,1905.409,1151.462L1905.409,1151.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1887.684,1157.99l-8.947,2.98c-0.719,0.24-1.481-0.197-1.702-0.976 c-0.221-0.778,0.182-1.603,0.901-1.843l0.024-0.008l8.897-2.965l0.025-0.009c0.719-0.24,1.482,0.197,1.703,0.976 C1888.808,1156.925,1888.404,1157.75,1887.684,1157.99L1887.684,1157.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1869.74,1163.766l-9.043,2.616c-0.725,0.21-1.471-0.257-1.665-1.043 c-0.194-0.785,0.237-1.593,0.963-1.803l0.024-0.007l8.995-2.604l0.024-0.007c0.726-0.211,1.473,0.257,1.667,1.043 C1870.897,1162.749,1870.466,1163.556,1869.74,1163.766L1869.74,1163.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1851.611,1168.822l-9.122,2.268c-0.731,0.182-1.46-0.313-1.628-1.104 c-0.168-0.792,0.289-1.581,1.02-1.763l0.022-0.005l9.076-2.258l0.023-0.006c0.732-0.182,1.461,0.312,1.629,1.105 C1852.8,1167.851,1852.344,1168.64,1851.611,1168.822L1851.611,1168.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1833.34,1173.189l-9.181,1.935c-0.736,0.155-1.448-0.365-1.591-1.161 c-0.143-0.796,0.337-1.567,1.072-1.723l0.021-0.004l9.137-1.928l0.022-0.004c0.736-0.156,1.448,0.365,1.592,1.162 C1834.557,1172.262,1834.076,1173.034,1833.34,1173.189L1833.34,1173.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1814.951,1176.9l-9.233,1.621c-0.738,0.13-1.434-0.414-1.554-1.214 c-0.12-0.8,0.381-1.553,1.12-1.683l0.02-0.004l9.193-1.616l0.021-0.003c0.739-0.13,1.436,0.413,1.555,1.213 C1816.193,1176.016,1815.691,1176.77,1814.951,1176.9L1814.951,1176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1796.462,1179.991l-9.275,1.323c-0.741,0.106-1.42-0.459-1.518-1.261 c-0.098-0.802,0.424-1.538,1.165-1.644l0.019-0.003l9.236-1.319l0.02-0.003c0.741-0.106,1.421,0.459,1.52,1.262 C1797.725,1179.149,1797.204,1179.885,1796.462,1179.991L1796.462,1179.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1777.896,1182.493l-9.305,1.04c-0.743,0.083-1.406-0.502-1.483-1.305 c-0.077-0.804,0.463-1.523,1.205-1.606l0.018-0.002l9.269-1.037l0.019-0.002c0.743-0.083,1.407,0.502,1.484,1.306 C1779.179,1181.69,1778.64,1182.41,1777.896,1182.493L1777.896,1182.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1759.274,1184.437l-9.327,0.772c-0.743,0.062-1.392-0.54-1.449-1.345 c-0.057-0.805,0.5-1.507,1.243-1.568l0.017-0.001l9.292-0.772l0.017-0.001c0.744-0.062,1.392,0.541,1.45,1.346 C1760.575,1183.673,1760.018,1184.376,1759.274,1184.437L1759.274,1184.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1740.62,1185.853l-9.337,0.519c-0.743,0.042-1.377-0.577-1.415-1.383 c-0.038-0.805,0.534-1.491,1.277-1.532l0.016-0.001l9.304-0.519l0.016-0.001c0.744-0.041,1.378,0.578,1.417,1.383 C1741.936,1185.125,1741.363,1185.812,1740.62,1185.853L1740.62,1185.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1721.939,1186.77l-9.348,0.281c-0.743,0.022-1.362-0.612-1.383-1.417 c-0.02-0.804,0.565-1.474,1.308-1.497l0.015,0l9.318-0.281l0.016-0.001c0.743-0.022,1.363,0.612,1.384,1.417 C1723.269,1186.078,1722.683,1186.748,1721.939,1186.77L1721.939,1186.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1703.239,1187.216l-9.344,0.061c-0.742,0.005-1.348-0.643-1.352-1.446 c-0.005-0.803,0.594-1.459,1.336-1.464h0.009l9.322-0.063h0.013c0.743-0.006,1.349,0.642,1.354,1.447 C1704.581,1186.555,1703.982,1187.211,1703.239,1187.216L1703.239,1187.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1684.557,1187.267l-9.346-0.078c-0.741-0.006-1.338-0.662-1.332-1.465 c0.006-0.803,0.62-1.448,1.362-1.442l9.328,0.076c0.742,0,1.343,0.652,1.342,1.455c-0.001,0.803-0.603,1.454-1.345,1.453 H1684.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1665.866,1187.044l-9.344-0.211c-0.74-0.017-1.328-0.681-1.312-1.482 c0.015-0.802,0.637-1.438,1.376-1.421l9.327,0.209c0.741,0.011,1.333,0.671,1.322,1.473c-0.01,0.802-0.62,1.443-1.361,1.432 L1665.866,1187.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1647.179,1186.557l-9.34-0.34c-0.739-0.027-1.318-0.698-1.293-1.498 c0.025-0.8,0.652-1.426,1.391-1.399l9.324,0.337c0.74,0.021,1.323,0.688,1.303,1.49c-0.02,0.801-0.636,1.432-1.376,1.411 L1647.179,1186.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1628.501,1185.814l-9.336-0.466c-0.738-0.036-1.308-0.714-1.274-1.512 c0.034-0.798,0.667-1.416,1.405-1.379l9.319,0.463c0.739,0.031,1.313,0.705,1.284,1.505c-0.03,0.799-0.652,1.422-1.39,1.39 L1628.501,1185.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1609.833,1184.821l-9.33-0.588c-0.736-0.046-1.298-0.73-1.256-1.527 c0.043-0.797,0.682-1.405,1.418-1.359l9.314,0.584c0.737,0.042,1.303,0.723,1.265,1.52c-0.038,0.798-0.667,1.411-1.404,1.37 L1609.833,1184.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1591.177,1183.586l-9.322-0.705c-0.735-0.056-1.289-0.746-1.237-1.541 c0.051-0.796,0.696-1.395,1.43-1.339l9.307,0.703c0.735,0.051,1.294,0.737,1.247,1.533c-0.047,0.797-0.681,1.401-1.417,1.35 L1591.177,1183.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1572.537,1182.119l-9.314-0.82c-0.733-0.064-1.279-0.76-1.219-1.554 c0.06-0.794,0.709-1.384,1.442-1.319l9.3,0.817c0.734,0.06,1.284,0.753,1.228,1.547c-0.056,0.795-0.695,1.391-1.429,1.33 L1572.537,1182.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1553.913,1180.423l-9.305-0.93c-0.731-0.073-1.27-0.775-1.202-1.566 c0.068-0.792,0.722-1.374,1.453-1.301l9.291,0.927c0.732,0.069,1.275,0.767,1.211,1.56c-0.064,0.793-0.709,1.38-1.441,1.311 L1553.913,1180.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1535.317,1178.51l-9.288-1.036c-0.729-0.081-1.26-0.788-1.185-1.578 c0.075-0.79,0.734-1.364,1.464-1.282l9.274,1.032c0.73,0.077,1.265,0.781,1.194,1.572c-0.071,0.791-0.721,1.369-1.452,1.293 L1535.317,1178.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1516.745,1176.386l-9.279-1.139c-0.728-0.089-1.251-0.801-1.169-1.589 c0.083-0.788,0.746-1.354,1.473-1.264l9.267,1.135c0.729,0.085,1.255,0.794,1.177,1.583c-0.078,0.789-0.733,1.36-1.462,1.275 L1516.745,1176.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1498.19,1174.058l-9.271-1.238c-0.726-0.097-1.242-0.813-1.153-1.599 c0.09-0.786,0.757-1.344,1.483-1.247l9.259,1.235c0.727,0.093,1.247,0.807,1.161,1.594c-0.086,0.787-0.745,1.35-1.472,1.257 L1498.19,1174.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1479.652,1171.534l-9.263-1.335c-0.724-0.104-1.233-0.824-1.137-1.608 c0.096-0.784,0.768-1.334,1.492-1.23l9.251,1.33c0.725,0.1,1.238,0.819,1.145,1.604c-0.093,0.785-0.756,1.34-1.481,1.239 L1479.652,1171.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1461.131,1168.818l-9.255-1.426c-0.722-0.111-1.224-0.836-1.122-1.618 c0.103-0.782,0.777-1.325,1.499-1.214l9.243,1.423c0.723,0.108,1.229,0.83,1.13,1.613c-0.1,0.783-0.767,1.331-1.49,1.223 L1461.131,1168.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1442.627,1165.921l-9.245-1.515c-0.721-0.118-1.216-0.846-1.107-1.626 c0.109-0.78,0.787-1.316,1.507-1.198l9.234,1.511c0.721,0.114,1.22,0.841,1.114,1.622c-0.106,0.781-0.776,1.321-1.498,1.206 L1442.627,1165.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1424.141,1162.849l-9.225-1.598c-0.719-0.124-1.208-0.856-1.093-1.634 c0.115-0.778,0.796-1.307,1.514-1.182l9.215,1.594c0.72,0.121,1.212,0.851,1.1,1.63c-0.112,0.779-0.786,1.312-1.506,1.191 L1424.141,1162.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1405.697,1159.613l-9.213-1.679c-0.716-0.131-1.2-0.865-1.079-1.641 c0.12-0.776,0.804-1.298,1.521-1.167l9.203,1.674c0.717,0.127,1.204,0.86,1.086,1.637c-0.118,0.777-0.795,1.304-1.512,1.176 L1405.697,1159.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1387.277,1156.217l-9.201-1.755c-0.715-0.137-1.192-0.874-1.066-1.648 c0.126-0.774,0.812-1.289,1.527-1.153l9.191,1.751c0.716,0.133,1.196,0.87,1.073,1.645c-0.123,0.774-0.803,1.295-1.519,1.161 L1387.277,1156.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1368.882,1152.669l-9.188-1.829c-0.712-0.142-1.184-0.882-1.053-1.654 c0.131-0.772,0.819-1.281,1.532-1.14l9.179,1.825c0.714,0.139,1.188,0.878,1.06,1.651c-0.128,0.773-0.811,1.286-1.525,1.147 L1368.882,1152.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1350.512,1148.976l-9.176-1.899c-0.711-0.147-1.177-0.89-1.041-1.659 c0.136-0.77,0.826-1.274,1.538-1.127l9.167,1.895c0.712,0.145,1.181,0.887,1.047,1.657c-0.134,0.77-0.818,1.278-1.53,1.134 L1350.512,1148.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1332.167,1145.145l-9.163-1.965c-0.709-0.152-1.17-0.897-1.03-1.665 c0.141-0.768,0.833-1.266,1.542-1.114l9.156,1.961c0.71,0.149,1.173,0.894,1.036,1.662c-0.138,0.769-0.826,1.271-1.536,1.121 L1332.167,1145.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1313.846,1141.183l-9.152-2.028c-0.707-0.157-1.163-0.904-1.019-1.67 c0.145-0.766,0.839-1.258,1.546-1.102l9.144,2.024c0.708,0.154,1.166,0.901,1.024,1.667c-0.142,0.767-0.832,1.263-1.54,1.109 L1313.846,1141.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1295.548,1137.098l-9.14-2.087c-0.705-0.161-1.156-0.911-1.008-1.675 c0.149-0.763,0.845-1.251,1.55-1.09l9.133,2.084c0.706,0.158,1.16,0.907,1.013,1.672c-0.147,0.764-0.838,1.255-1.544,1.097 L1295.548,1137.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1277.274,1132.895l-9.129-2.143c-0.704-0.165-1.15-0.916-0.998-1.678 c0.153-0.762,0.85-1.245,1.553-1.08l9.122,2.14c0.704,0.163,1.153,0.913,1.003,1.676c-0.151,0.763-0.844,1.248-1.548,1.085 L1277.274,1132.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1259.022,1128.583l-9.118-2.196c-0.702-0.169-1.144-0.921-0.988-1.681 c0.156-0.76,0.855-1.238,1.556-1.07l9.112,2.193c0.703,0.167,1.147,0.919,0.993,1.679c-0.154,0.761-0.849,1.242-1.551,1.075 L1259.022,1128.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1240.791,1124.167l-9.108-2.245c-0.699-0.172-1.138-0.927-0.979-1.684 c0.16-0.758,0.859-1.232,1.558-1.059l9.102,2.241c0.701,0.17,1.141,0.924,0.984,1.683c-0.158,0.759-0.853,1.236-1.554,1.065 L1240.791,1124.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1222.582,1119.654l-9.098-2.291c-0.698-0.176-1.133-0.931-0.97-1.687 c0.162-0.756,0.862-1.226,1.561-1.05l9.092,2.287c0.699,0.174,1.135,0.929,0.975,1.686c-0.161,0.757-0.858,1.229-1.557,1.055 L1222.582,1119.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1204.391,1115.051l-9.088-2.333c-0.696-0.179-1.127-0.936-0.962-1.69s0.866-1.22,1.563-1.041 l9.083,2.329c0.698,0.177,1.13,0.933,0.967,1.688c-0.164,0.755-0.862,1.224-1.559,1.047L1204.391,1115.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1186.22,1110.365l-9.079-2.372c-0.695-0.181-1.122-0.938-0.954-1.691 c0.167-0.752,0.869-1.214,1.564-1.032l9.075,2.369c0.695,0.18,1.125,0.937,0.959,1.69c-0.167,0.753-0.865,1.218-1.561,1.038 L1186.22,1110.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1168.066,1105.602l-9.071-2.408c-0.693-0.184-1.117-0.942-0.948-1.693 c0.17-0.751,0.872-1.209,1.565-1.025l9.067,2.405c0.694,0.183,1.12,0.94,0.951,1.692c-0.169,0.752-0.868,1.213-1.563,1.03 L1168.066,1105.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1149.928,1100.769l-9.063-2.441c-0.692-0.186-1.113-0.944-0.941-1.694 c0.172-0.749,0.874-1.204,1.566-1.018l9.06,2.438c0.693,0.185,1.116,0.943,0.945,1.693c-0.171,0.75-0.871,1.208-1.563,1.023 L1149.928,1100.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1131.805,1095.872l-9.063-2.472c-0.69-0.188-1.109-0.947-0.935-1.694 c0.174-0.748,0.876-1.2,1.567-1.012l9.059,2.469c0.691,0.187,1.111,0.946,0.938,1.693c-0.173,0.749-0.873,1.204-1.564,1.016 L1131.805,1095.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1113.685,1090.915l-9.051-2.496c-0.689-0.19-1.105-0.949-0.93-1.695 c0.175-0.746,0.878-1.196,1.566-1.006l9.049,2.493c0.689,0.189,1.107,0.948,0.932,1.694c-0.175,0.747-0.875,1.199-1.565,1.01 L1113.685,1090.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1095.59,1085.908l-9.036-2.543c-0.687-0.194-1.1-0.953-0.921-1.698 c0.179-0.744,0.884-1.189,1.572-0.996l9.028,2.539c0.688,0.191,1.103,0.95,0.927,1.695c-0.176,0.745-0.877,1.194-1.566,1.004 L1095.59,1085.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1077.525,1080.79l-9.023-2.601c-0.685-0.197-1.093-0.959-0.91-1.7 c0.182-0.742,0.888-1.182,1.574-0.985l9.017,2.597c0.686,0.196,1.096,0.957,0.915,1.7c-0.181,0.742-0.883,1.186-1.569,0.991 L1077.525,1080.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1059.483,1075.565l-9.014-2.643c-0.683-0.2-1.087-0.963-0.902-1.702 c0.185-0.74,0.891-1.177,1.574-0.976l9.011,2.639c0.684,0.2,1.09,0.961,0.906,1.702s-0.887,1.18-1.572,0.981L1059.483,1075.565z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1041.458,1070.265l-9.009-2.668c-0.682-0.202-1.083-0.964-0.897-1.703 c0.186-0.739,0.891-1.173,1.573-0.971l9.007,2.666c0.683,0.201,1.085,0.964,0.899,1.703c-0.186,0.739-0.89,1.175-1.573,0.974 L1041.458,1070.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1023.442,1064.922l-9.007-2.678c-0.681-0.202-1.081-0.964-0.894-1.702 c0.187-0.737,0.89-1.17,1.571-0.968l9.007,2.676c0.681,0.203,1.082,0.964,0.895,1.702 C1024.827,1064.69,1024.124,1065.124,1023.442,1064.922L1023.442,1064.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1005.428,1059.566l-9.008-2.672c-0.68-0.201-1.081-0.961-0.895-1.698 c0.186-0.736,0.888-1.17,1.569-0.969l9.01,2.671c0.68,0.202,1.081,0.963,0.895,1.699 C1006.813,1059.334,1006.11,1059.768,1005.428,1059.566L1005.428,1059.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M987.411,1054.231l-9.013-2.65c-0.68-0.199-1.082-0.957-0.898-1.693 c0.184-0.735,0.885-1.171,1.565-0.972l9.016,2.649c0.68,0.2,1.082,0.959,0.898,1.695c-0.185,0.737-0.886,1.171-1.566,0.971 L987.411,1054.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M969.382,1048.947l-9.02-2.613c-0.68-0.195-1.085-0.95-0.905-1.686 c0.18-0.736,0.88-1.173,1.56-0.978l9.026,2.612c0.68,0.197,1.084,0.953,0.902,1.689c-0.182,0.736-0.88,1.173-1.56,0.976 L969.382,1048.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M951.336,1043.747l-9.031-2.559c-0.68-0.19-1.089-0.941-0.913-1.677 c0.175-0.736,0.873-1.177,1.553-0.987l9.039,2.559c0.68,0.192,1.087,0.945,0.909,1.681c-0.178,0.736-0.873,1.177-1.552,0.984 L951.336,1043.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M933.267,1038.662l-9.045-2.489c-0.68-0.184-1.094-0.93-0.924-1.667 c0.17-0.736,0.864-1.183,1.544-0.999l9.056,2.49c0.68,0.187,1.091,0.935,0.919,1.671c-0.173,0.737-0.864,1.182-1.544,0.995 L933.267,1038.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M915.168,1033.725l-9.063-2.404c-0.681-0.177-1.1-0.918-0.937-1.655 c0.163-0.737,0.853-1.19,1.534-1.013l9.075,2.404c0.68,0.18,1.097,0.924,0.93,1.661c-0.167,0.737-0.853,1.188-1.534,1.008 L915.168,1033.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M897.033,1028.967l-9.083-2.302c-0.682-0.168-1.108-0.903-0.952-1.641 c0.156-0.739,0.841-1.198,1.523-1.03l9.097,2.303c0.681,0.173,1.105,0.91,0.945,1.648c-0.159,0.737-0.841,1.196-1.522,1.024 L897.033,1028.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M878.857,1024.421l-9.105-2.184c-0.683-0.159-1.117-0.886-0.971-1.626 c0.147-0.739,0.827-1.208,1.51-1.049l9.121,2.186c0.682,0.164,1.113,0.895,0.962,1.634c-0.151,0.738-0.826,1.205-1.508,1.041 L878.857,1024.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M860.633,1020.117l-9.131-2.05c-0.684-0.148-1.127-0.868-0.99-1.608 c0.137-0.74,0.81-1.218,1.494-1.07l9.149,2.052c0.683,0.153,1.123,0.877,0.981,1.617c-0.141,0.74-0.81,1.215-1.493,1.062 L860.633,1020.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M842.357,1016.089l-9.159-1.901l-0.01-0.002c-0.684-0.142-1.132-0.857-1.001-1.597 c0.131-0.741,0.791-1.226,1.475-1.084l9.179,1.903c0.684,0.142,1.133,0.857,1.002,1.598c-0.131,0.741-0.792,1.227-1.476,1.084h0 L842.357,1016.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M824.024,1012.368l-9.192-1.78c-0.684-0.132-1.14-0.841-1.017-1.582 c0.122-0.741,0.778-1.233,1.462-1.101l9.191,1.778c0.685,0.133,1.141,0.841,1.018,1.582 C825.364,1012.007,824.709,1012.501,824.024,1012.368L824.024,1012.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M805.648,1008.8l-9.187-1.774c-0.684-0.13-1.141-0.835-1.022-1.575 c0.12-0.74,0.775-1.235,1.459-1.105l9.193,1.774c0.684,0.132,1.14,0.839,1.018,1.58c-0.122,0.741-0.775,1.234-1.459,1.102 L805.648,1008.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M787.27,1005.29l-9.199-1.674l-0.01-0.001c-0.684-0.125-1.145-0.826-1.03-1.566 c0.115-0.74,0.762-1.239,1.446-1.115l9.218,1.675c0.684,0.124,1.146,0.826,1.031,1.567c-0.115,0.741-0.763,1.241-1.447,1.116 L787.27,1005.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M768.862,1002.026l-9.221-1.483l-0.015-0.003c-0.685-0.111-1.157-0.801-1.055-1.542 c0.102-0.741,0.739-1.253,1.424-1.143l9.25,1.487c0.685,0.11,1.158,0.801,1.056,1.543c-0.102,0.742-0.74,1.254-1.425,1.143h0 L768.862,1002.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M750.405,999.187l-9.25-1.204l-0.021-0.003c-0.686-0.089-1.176-0.764-1.093-1.507 c0.083-0.743,0.706-1.273,1.392-1.184l9.291,1.207c0.687,0.089,1.177,0.764,1.094,1.508c-0.082,0.744-0.706,1.274-1.393,1.185h0 L750.405,999.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M731.889,996.953l-9.279-0.83l-0.027-0.003c-0.688-0.062-1.2-0.715-1.143-1.46 c0.057-0.745,0.66-1.299,1.348-1.237l9.332,0.833c0.688,0.061,1.2,0.715,1.144,1.461c-0.057,0.745-0.661,1.3-1.349,1.238h0 L731.889,996.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M713.318,995.517l-9.299-0.355l-0.034-0.001c-0.688-0.026-1.227-0.652-1.203-1.398 c0.024-0.746,0.602-1.33,1.291-1.303l9.364,0.355c0.69,0.026,1.229,0.652,1.205,1.398c-0.024,0.746-0.603,1.33-1.292,1.304l0,0 L713.318,995.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M694.719,995.087l-9.295,0.233l-0.041,0.001c-0.688,0.017-1.259-0.573-1.275-1.317 c-0.016-0.745,0.529-1.363,1.217-1.38l9.375-0.237c0.688-0.018,1.26,0.573,1.276,1.318c0.016,0.746-0.529,1.365-1.218,1.382h0 L694.719,995.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M676.149,995.891l-9.249,0.939l-0.048,0.005c-0.684,0.07-1.291-0.475-1.355-1.215 c-0.064-0.741,0.438-1.398,1.122-1.468l9.343-0.952c0.685-0.07,1.292,0.475,1.357,1.216c0.064,0.741-0.439,1.399-1.123,1.468h0 L676.149,995.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M657.699,998.171l-9.135,1.768l-0.056,0.011c-0.675,0.131-1.321-0.356-1.441-1.087 c-0.121-0.731,0.328-1.43,1.004-1.561l9.244-1.792c0.676-0.131,1.322,0.357,1.443,1.088c0.121,0.732-0.329,1.431-1.005,1.562v0 L657.699,998.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M639.521,1002.166l-8.927,2.708l-0.062,0.019c-0.659,0.2-1.344-0.217-1.529-0.931 c-0.185-0.714,0.2-1.456,0.86-1.656l9.049-2.747c0.66-0.201,1.345,0.216,1.53,0.931c0.185,0.715-0.2,1.457-0.86,1.657h0 L639.521,1002.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M621.815,1008.083l-8.602,3.726l-0.064,0.028c-0.635,0.276-1.356-0.059-1.611-0.747 c-0.254-0.687,0.055-1.468,0.69-1.744l8.73-3.783c0.635-0.275,1.357,0.059,1.612,0.747c0.254,0.688-0.055,1.47-0.69,1.745h0 L621.815,1008.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M604.823,1016.059l-8.148,4.771l-0.064,0.038c-0.601,0.352-1.351,0.11-1.676-0.54 c-0.325-0.651-0.102-1.463,0.499-1.815l8.274-4.849c0.601-0.353,1.352-0.11,1.678,0.541c0.325,0.651,0.102,1.465-0.499,1.817h0 L604.823,1016.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M588.802,1026.114c-2.514,1.932-5.115,3.757-7.56,5.776c-0.543,0.448-1.318,0.334-1.732-0.254 c-0.414-0.587-0.303-1.431,0.239-1.879c2.504-2.067,5.129-3.911,7.688-5.876c0.557-0.428,1.328-0.286,1.723,0.317 c0.395,0.603,0.264,1.439-0.293,1.866L588.802,1026.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M574.107,1038.235l-6.69,6.912l-0.063,0.065c-0.493,0.509-1.273,0.49-1.744-0.044 c-0.47-0.533-0.452-1.379,0.041-1.888l6.816-7.045c0.493-0.51,1.274-0.49,1.745,0.044c0.471,0.533,0.453,1.38-0.04,1.889 L574.107,1038.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M561.185,1052.552l-5.766,7.84l-0.05,0.068c-0.424,0.576-1.199,0.671-1.73,0.213 c-0.532-0.459-0.62-1.298-0.197-1.874l5.866-7.978c0.424-0.576,1.199-0.672,1.732-0.213s0.621,1.298,0.197,1.875 L561.185,1052.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M550.134,1068.621l-4.782,8.582l-0.041,0.074c-0.351,0.63-1.107,0.832-1.688,0.452 c-0.582-0.38-0.768-1.197-0.418-1.827l4.863-8.732c0.351-0.63,1.107-0.833,1.69-0.453c0.582,0.38,0.769,1.199,0.418,1.829l0,0 L550.134,1068.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M541.099,1086.104l-3.687,9.189l-0.034,0.085c-0.27,0.673-0.993,0.982-1.615,0.69 c-0.622-0.293-0.907-1.076-0.637-1.749l3.753-9.358c0.271-0.674,0.994-0.983,1.617-0.691c0.622,0.293,0.908,1.076,0.638,1.75h0 L541.099,1086.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M534.335,1104.737l-2.414,9.66l-0.025,0.101c-0.177,0.707-0.85,1.126-1.503,0.934 c-0.654-0.192-1.04-0.919-0.864-1.627l2.462-9.86c0.177-0.708,0.85-1.127,1.505-0.935c0.654,0.191,1.041,0.921,0.864,1.629 L534.335,1104.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M530.235,1124.228l-0.889,9.943l-0.011,0.121c-0.065,0.729-0.663,1.262-1.336,1.191 c-0.673-0.07-1.166-0.718-1.101-1.446l0.909-10.183c0.065-0.729,0.663-1.263,1.337-1.193c0.673,0.07,1.167,0.719,1.101,1.448 L530.235,1124.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M529.329,1144.149l0.347,4.972l0.542,4.97l0.006,0.053c0.079,0.726-0.401,1.385-1.071,1.47 c-0.671,0.086-1.279-0.433-1.358-1.159l-0.554-5.07c-0.138-1.699-0.237-3.406-0.357-5.108c-0.052-0.73,0.453-1.366,1.128-1.421 c0.674-0.056,1.261,0.491,1.313,1.221v0L529.329,1144.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M531.858,1163.934l2.437,9.628l0.032,0.125c0.178,0.703-0.205,1.43-0.854,1.623 c-0.65,0.192-1.321-0.221-1.499-0.925l-2.502-9.871c-0.179-0.704,0.204-1.432,0.854-1.625c0.65-0.193,1.322,0.221,1.501,0.925h0 L531.858,1163.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M537.627,1182.845c1.271,3.02,2.707,5.955,4.321,8.767c0.355,0.62,0.18,1.434-0.392,1.819 c-0.573,0.385-1.324,0.195-1.68-0.424c-1.673-2.915-3.159-5.95-4.471-9.065c-0.279-0.665-0.009-1.448,0.604-1.751 C536.623,1181.888,537.347,1182.181,537.627,1182.845L537.627,1182.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M547.366,1199.54c2.03,2.447,4.272,4.699,6.65,6.777c0.524,0.457,0.606,1.287,0.184,1.854 c-0.423,0.567-1.189,0.656-1.713,0.198c-2.466-2.154-4.804-4.499-6.935-7.067c-0.45-0.542-0.408-1.376,0.092-1.864 c0.501-0.487,1.271-0.442,1.721,0.1L547.366,1199.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M561.514,1212.05l8.063,4.837l0.1,0.06c0.587,0.352,0.799,1.153,0.473,1.788 c-0.325,0.636-1.064,0.866-1.651,0.513l-8.271-4.96c-0.587-0.352-0.8-1.153-0.474-1.789c0.325-0.636,1.065-0.866,1.652-0.513h0 L561.514,1212.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M578.019,1220.943l8.713,3.362l0.079,0.031c0.632,0.244,0.961,0.996,0.736,1.679 c-0.225,0.684-0.919,1.041-1.551,0.797l-8.875-3.424c-0.632-0.244-0.961-0.996-0.736-1.68c0.225-0.683,0.92-1.041,1.552-0.797 L578.019,1220.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M595.645,1227.028l9.063,2.101l0.075,0.018c0.655,0.151,1.072,0.849,0.932,1.558 c-0.14,0.708-0.784,1.16-1.438,1.009l-9.215-2.135c-0.655-0.152-1.073-0.85-0.932-1.559c0.14-0.71,0.785-1.162,1.44-1.01l0,0 L595.645,1227.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M613.866,1230.593l9.22,0.766l0.093,0.007c0.666,0.055,1.165,0.685,1.114,1.406 c-0.051,0.721-0.633,1.261-1.299,1.206l-9.401-0.779c-0.667-0.055-1.166-0.685-1.115-1.407c0.051-0.722,0.633-1.263,1.3-1.207h0 L613.866,1230.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M632.315,1231.293l2.648-0.208l0.041-0.003c0.667-0.052,1.246,0.49,1.294,1.211 c0.048,0.722-0.453,1.349-1.119,1.401l-2.729,0.215c-0.666,0.052-1.246-0.49-1.294-1.211c-0.048-0.721,0.453-1.349,1.119-1.401 h0L632.315,1231.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072256012231230109450000016408944672727719561_",
    gradientUnits: "userSpaceOnUse",
    x1: 6157.0015,
    y1: 1396.9059,
    x2: 5853.2163,
    y2: 1727.339,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072256012231230109450000016408944672727719561_)"
    },
    d: "M1063.734,1421.493 c0,0-3.316,17.781-5.027,35.398c-0.669,6.885,4.587,12.918,11.495,13.272c23.47,1.202,73.675,3.583,91.705,2.95 c2.71-0.095,4.508-2.852,3.53-5.381l0,0c-0.82-2.119-2.424-3.842-4.48-4.811l-82.596-38.919L1063.734,1421.493z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093178721536450846040000011618126292432740528_",
    gradientUnits: "userSpaceOnUse",
    x1: 6058.397,
    y1: 1421.4443,
    x2: 6085.3809,
    y2: 1421.4443,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093178721536450846040000011618126292432740528_)"
    },
    d: "M1061.256,1411.003l2.325,21.329 c0,0,14.468,6.904,24.465-0.619l-5.791-23.799L1061.256,1411.003z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134968054343569382850000009010072322480501144_",
    gradientUnits: "userSpaceOnUse",
    x1: 6180.938,
    y1: 1023.1955,
    x2: 5922.4277,
    y2: 1373.5724,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134968054343569382850000009010072322480501144_)"
    },
    d: "M1066.977,1010.489 c-1.144,5.553-8.509,277.578,19.41,399.78c0.456,1.994-0.572,4.035-2.473,4.791c-4.478,1.78-13.248,4.336-23.731,4.587 c-3.246,0.078-6.136-2.059-7.022-5.183c-8.043-28.368-46.526-170.48-50.431-305.922c-4.363-151.344,0.049-5.151,0.049-5.151 l4.298-93.485L1066.977,1010.489z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038372994183719602090000000507901632695694256_",
    gradientUnits: "userSpaceOnUse",
    x1: 6088.8521,
    y1: 1334.2415,
    x2: 5785.0542,
    y2: 1664.689,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038372994183719602090000000507901632695694256_)"
    },
    d: "M968.214,1429.874 c0,0-5.094,8.944-10.17,32.791c-0.917,4.307,2.059,8.465,6.437,8.938c7.746,0.836,19.672,1.931,29.233,1.956 c4.407,0.012,7.883-3.793,7.394-8.173c-0.976-8.731-4.138-23.072-14.224-34.321L968.214,1429.874z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119098341303154299220000000228680669259342755_",
    gradientUnits: "userSpaceOnUse",
    x1: 5961.1445,
    y1: 1420.0569,
    x2: 5984.4424,
    y2: 1420.0569,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119098341303154299220000000228680669259342755_)"
    },
    d: "M964.076,1402.43l5.599,32.275 c0,0,5.799,4.399,17.382,1.361l-2.489-34.691L964.076,1402.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046334144920756874160000004617724070599309206_",
    gradientUnits: "userSpaceOnUse",
    x1: 6134.8643,
    y1: 989.2028,
    x2: 5876.3574,
    y2: 1339.5759,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046334144920756874160000004617724070599309206_)"
    },
    d: "M951.789,1017.74 c-25.155,143.321,1.775,354.837,11.142,396.276c0.573,2.537,2.598,4.496,5.16,4.946c4.35,0.764,11.519,1.422,18.611-0.565 c2.443-0.684,4.176-2.866,4.3-5.401c1.629-33.414,1.229-238.64,24.165-319.527c1.162-4.099,3.706-7.66,7.203-10.095 l43.307-30.17l3.77-49.4L951.789,1017.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137125828358451102430000015854359000009184387_",
    gradientUnits: "userSpaceOnUse",
    x1: 5300.9004,
    y1: 737.6826,
    x2: 5141.1631,
    y2: 1352.6689,
    gradientTransform: "matrix(-1 0 0 1 6333.6606 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137125828358451102430000015854359000009184387_)"
    },
    d: "M1105.946,747.192 c-71.269-1.858-150.109,17.286-150.109,17.286c-22.43,123.774-6.262,266.94-6.262,266.94 c55.045,14.998,117.518-7.728,117.518-7.728c9.667-51.732,53.852-197.161,53.852-197.161 c34.869-3.99,63.655-13.764,87.408-26.823c-17.822-21.062-26.065-47.725-29.605-63.473 C1153.469,743.825,1127.927,747.765,1105.946,747.192z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075129911888856611090000017085832521731319718_",
    gradientUnits: "userSpaceOnUse",
    x1: 6169.4668,
    y1: 717.4516,
    x2: 6307.3311,
    y2: 717.4516,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075129911888856611090000017085832521731319718_)"
    },
    d: "M1317.497,644.209 c-6.922-8.524-15.822-4.608-15.822-4.608c-10.912,44.209-66.255,79.611-122.929,96.633 c3.54,15.748,11.783,42.411,29.605,63.473C1302.631,747.874,1317.497,644.209,1317.497,644.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103251152844870568030000012491194020642301078_",
    gradientUnits: "userSpaceOnUse",
    x1: 2934.1138,
    y1: 693.4131,
    x2: 3026.6216,
    y2: 903.8895,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 4226.9902 30.8307)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103251152844870568030000012491194020642301078_)"
    },
    d: "M1315.777,646.343 c0.711,2.336-7.808,5.802-12.713-3.772c-0.131-4.567-2.721-24.153,0.043-27.847c14.719-19.671,43.127-44.234,43.127-44.234 c4.716,4.743,0.75,9.321,0.75,9.321l-13.802,14.106c2.809,5.192,6.255,9.586,7.829,15.85c1.192,4.743,0.387,9.793-2.044,14.076 c-2.44,4.299-5.766,9.885-8.902,14.253C1324.128,646.36,1315.777,646.343,1315.777,646.343z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005950371061410584660000015912284680091689647_",
    gradientUnits: "userSpaceOnUse",
    x1: 6306.6699,
    y1: 624.2494,
    x2: 6345.2705,
    y2: 564.9014,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005950371061410584660000015912284680091689647_)"
    },
    d: "M1327.116,603.096l-12.554,10.438 l-4.01,10.474l10.986,12.424c0,0,3.932-20.82,6.75-25.308C1331.106,606.638,1329.688,604.441,1327.116,603.096z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037674680997911795730000009215087157703334831_",
    gradientUnits: "userSpaceOnUse",
    x1: 5424.5786,
    y1: 769.8068,
    x2: 5264.8418,
    y2: 1384.7926,
    gradientTransform: "matrix(-1 0 0 1 6333.6606 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037674680997911795730000009215087157703334831_)"
    },
    d: "M982.518,833.759l-26.682-69.281 c0,0-67.012,44.603-78.508,101.855c12.571,1.047,35.432,4.537,57.731,16.065C940.242,855.362,982.518,833.759,982.518,833.759z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092420364511236626110000017354348713345982390_",
    gradientUnits: "userSpaceOnUse",
    x1: 5867.7935,
    y1: 912.7133,
    x2: 6042.2559,
    y2: 912.7133,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -4983.7358 -57.6037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092420364511236626110000017354348713345982390_)"
    },
    d: "M1040.082,899.261 c0,0-75.156,41.533-100.034,5.219c-5.165-7.54-6.346-14.996-4.988-22.081c-22.299-11.528-45.16-15.018-57.731-16.065 c-3.466,17.26-1.897,35.667,8.087,54.351c43.411,81.242,164.384-2.899,164.384-2.899L1040.082,899.261z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081619983999480533530000001282684324604711819_",
    gradientUnits: "userSpaceOnUse",
    x1: 1059.6663,
    y1: 683.2335,
    x2: 1025.6663,
    y2: 810.2331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081619983999480533530000001282684324604711819_)"
    },
    d: "M1034.296,688.634l-23.306,65.374 c-0.386,1.082,0.049,2.29,1.05,2.856c6.15,3.477,28.329,13.57,55.334-3.193c2.813-1.746,4.744-4.62,5.2-7.899l7.886-56.698 L1034.296,688.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013896274999890183630000010416040843138210238_",
    gradientUnits: "userSpaceOnUse",
    x1: 2225.7742,
    y1: 5577.2212,
    x2: 2150.7744,
    y2: 5494.2212,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 684.9375 -1480.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013896274999890183630000010416040843138210238_)"
    },
    d: "M1084.225,628.367 c0,0,24.459,47.119,21.085,66.027c-3.373,18.907-34.227,17.253-61.033,1.615l-18.352-50.801L1084.225,628.367z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176006975103185712330000015204931464253323417_",
    gradientUnits: "userSpaceOnUse",
    x1: -1138.3108,
    y1: 1750.5493,
    x2: -1116.749,
    y2: 1873.5311,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 684.9375 -1480.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176006975103185712330000015204931464253323417_)"
    },
    d: "M1045.705,671.161 c1.1-0.475,1.517-1.812,0.87-2.82c-1.967-3.067-5.647-9.322-6.789-14.777c0,0-4.449-2.91,11.459-6.558 c15.909-3.648,39.636-9.319,44.74-22.782c4.977-13.127-7.453-46.375-28.038-20.174c-0.783,0.997-2.299,1.005-3.062-0.008 c-3.291-4.37-11.97-13.459-24.189-8.116c-11.435,5.001-12.797,13.332-12.681,17.539c0.034,1.237-1.081,2.189-2.295,1.945 c-5.746-1.153-19.552-2.228-26.135,11.882c-5.422,11.622-2.033,18.263,1.08,21.524c1.009,1.057,0.546,2.777-0.855,3.191 c-3.795,1.122-8.71,4.284-8.306,13.153c0.559,12.261,14.271,11.312,18.176,10.79c0.64-0.085,1.282,0.14,1.71,0.623 c3.309,3.733,18.228,19.593,34.52,21.642c1.411,0.178,2.519-1.206,2.069-2.555l-6.863-20.585 c-0.319-0.956,0.147-1.997,1.072-2.396L1045.705,671.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010275467611090630030000007227416053894893457_",
    gradientUnits: "userSpaceOnUse",
    x1: 2216.238,
    y1: 5585.8359,
    x2: 2141.238,
    y2: 5502.8359,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 684.9375 -1480.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010275467611090630030000007227416053894893457_)"
    },
    d: "M1048.515,674.1 c0,0-17.617-12.336-19.01-2.102c-1.393,10.233,15.827,14.993,24.415,11.255L1048.515,674.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055680263225777802850000007894249624443006641_",
    gradientUnits: "userSpaceOnUse",
    x1: 5802.2925,
    y1: 799.9998,
    x2: 5898.5605,
    y2: 1201.1174,
    gradientTransform: "matrix(1 0 0 1 -4705.6621 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055680263225777802850000007894249624443006641_)"
    },
    d: "M1024.722,964.899l40.941-142.973 c0.465-1.623,1.849-2.806,3.526-3.002c7.417-0.865,28.911-3.295,53.728-5.394c29.892-2.529,64.606-4.577,85.35-2.834 c2.949,0.247,4.731,3.367,3.42,6.02c-11.796,23.865-60.318,120.944-84.617,152.746c-0.805,1.054-2.05,1.669-3.376,1.657 l-94.988-0.884C1025.942,970.208,1023.962,967.557,1024.722,964.899z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024003157127821343220000011898544616762342574_",
    gradientUnits: "userSpaceOnUse",
    x1: 5736.3267,
    y1: 906.1168,
    x2: 5790.8696,
    y2: 906.1168,
    gradientTransform: "matrix(1 0 0 1 -4705.6621 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024003157127821343220000011898544616762342574_)"
    },
    d: "M1034.614,930.357 c0,0-5.703-23.451-3.403-31.77c2.3-8.32,6.758-19.017,21.614-16.64c14.857,2.377,32.382,8.636,32.382,8.636 s-0.885,10.837-12.177,7.341l7.002,5.418c0,0-1.001,8.677-10.538,4.041l6.512,7.185c0,0-4.096,7.126-11.113,2.556 C1057.877,912.552,1054.514,933.181,1034.614,930.357z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1120.188,856.21c0,6.637,5.381,12.017,12.018,12.017c6.637,0,12.018-5.38,12.018-12.017 c0-6.638-5.38-12.018-12.018-12.018C1125.568,844.192,1120.188,849.573,1120.188,856.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1069.836,863.996l-2.146-0.634l8.335-28.274c1.307-4.434,4.885-7.765,9.338-8.693 c26.374-5.505,98.144-6.665,98.865-6.676l0.035,2.238c-0.72,0.011-72.276,1.167-98.443,6.628 c-3.644,0.76-6.575,3.494-7.649,7.137L1069.836,863.996z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M585.773,1264.251c-4.364,6.457-21.709,152.67-24.424,206.671 c-0.184,3.651,2.738,6.696,6.394,6.696l0,0c3.154,0,5.837-2.297,6.323-5.412l31.725-203.304L585.773,1264.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M725.227,1264.251c4.364,6.457,21.709,152.67,24.424,206.671 c0.184,3.651-2.737,6.696-6.394,6.696l0,0c-3.153,0-5.836-2.297-6.323-5.412l-31.725-203.304L725.227,1264.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M559.535,1252.839l-0.015,1.594c-0.105,11.47,9.777,20.88,22.15,21.09l146.641,2.494 c12.195,0.207,22.361-8.606,22.953-19.898l0.077-1.459c0.617-11.777-9.385-21.7-22.103-21.927l-146.703-2.629 C569.98,1231.879,559.641,1241.199,559.535,1252.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170272071236168560700000011330186503048651677_",
    gradientUnits: "userSpaceOnUse",
    x1: 825.6808,
    y1: 1465.1654,
    x2: 932.0131,
    y2: 1465.1654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170272071236168560700000011330186503048651677_)"
    },
    d: "M868.439,1465.611 c-26.068,0-37.601-2.236-42.758-4.276c1.002,4.281,4.815,7.66,9.633,7.66h92.218c3.105,0,5.066-2.973,4.323-5.664 C921.344,1464.177,899.017,1465.611,868.439,1465.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131369482422494746000000001373794761676804495_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.6052,
    y1: 1260.7025,
    x2: 878.5526,
    y2: 1461.4301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131369482422494746000000001373794761676804495_)"
    },
    d: "M931.856,1463.331 c-0.149-0.542-0.369-1.077-0.755-1.569c-7.025-8.969-21.136-23.054-40.332-22.783c-28.12,0.396-37.925,3.446-59.777,0.171 l-5.155,17.088c-0.525,1.742-0.535,3.481-0.156,5.097c5.157,2.039,16.69,4.276,42.758,4.276 C899.017,1465.611,921.344,1464.177,931.856,1463.331z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122717176410219640740000003226269849250879648_",
    gradientUnits: "userSpaceOnUse",
    x1: 830.992,
    y1: 1433.1219,
    x2: 859.7623,
    y2: 1433.1219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122717176410219640740000003226269849250879648_)"
    },
    d: "M837.32,1420.736l-6.328,21.522 c0,0,14.019,6.382,26.349,1.259l2.421-18.646L837.32,1420.736z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062175679701751542390000010397716631719425727_",
    gradientUnits: "userSpaceOnUse",
    x1: 992.4575,
    y1: 1444.0931,
    x2: 1078.3085,
    y2: 1444.0931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062175679701751542390000010397716631719425727_)"
    },
    d: "M1028.454,1452.058 c-20.321,16.327-30.706,21.817-35.997,23.464c3.45,2.694,8.528,2.928,12.285-0.09l71.888-57.761 c2.421-1.945,2.095-5.479-0.16-7.103C1068.802,1417.807,1052.292,1432.905,1028.454,1452.058z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031905328626392357540000000257065805461758397_",
    gradientUnits: "userSpaceOnUse",
    x1: 1051.5098,
    y1: 1281.5298,
    x2: 1022.4571,
    y2: 1482.2578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031905328626392357540000000257065805461758397_)"
    },
    d: "M1076.47,1410.567 c-0.455-0.327-0.96-0.604-1.568-0.745c-11.067-2.558-30.847-4.648-45.642,7.585c-21.674,17.921-27.415,26.429-46.492,37.575 l6.633,16.486c0.677,1.68,1.754,3.036,3.057,4.052c5.291-1.647,15.676-7.136,35.997-23.464 C1052.292,1432.905,1068.802,1417.807,1076.47,1410.567z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127031378138899236670000000297637489608337575_",
    gradientUnits: "userSpaceOnUse",
    x1: 852.9849,
    y1: 1149.1307,
    x2: 744.9847,
    y2: 1366.1316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127031378138899236670000000297637489608337575_)"
    },
    d: "M701.952,1175.533 c0,0,156.067,12.743,188.082,27.814c32.016,15.072-26.127,226.306-26.127,226.306s-8.716,4.195-28.11-1.834 c0,0,19.888-155.883,5.089-189.684l-168.98-27.639L701.952,1175.533z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050647908954017569590000012238809287677231806_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.2616,
    y1: 1435.5433,
    x2: 1001.6091,
    y2: 1435.5433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050647908954017569590000012238809287677231806_)"
    },
    d: "M967.262,1425.311 c1.449,1.321,15.507,29.672,15.507,29.672s15.65-3.386,18.841-13.29l-14.081-25.589L967.262,1425.311z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034070679694942983270000012740038552932779915_",
    gradientUnits: "userSpaceOnUse",
    x1: 949.0569,
    y1: 1064.2286,
    x2: 896.0569,
    y2: 1147.2286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034070679694942983270000012740038552932779915_)"
    },
    d: "M607.955,1174.228 c0,0-5.086,12.238-4.878,28.5c0.287,22.49,18.368,40.741,40.833,41.862l184.496,8.413c3.896,0.177,7.193,2.874,8.169,6.65 c4.335,16.769,25.526,68.266,129.115,171.025c2.756,2.734,7.049,3.199,10.331,1.126l14.746-9.315 c1.548-0.978,2.042-3.007,1.117-4.587L884.46,1234.462c-5.642-9.311-14.712-16.038-25.26-18.734l-157.248-40.195 L607.955,1174.228z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105427978900904384450000015578986716260993178_",
    gradientUnits: "userSpaceOnUse",
    x1: 819.5881,
    y1: 888.8551,
    x2: 745.588,
    y2: 981.8553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105427978900904384450000015578986716260993178_)"
    },
    d: "M789.774,887.678 c0,0-19.764,34.944-39.915,51.873l41.651,23.239c0,0,9.385-36.993,30.827-47.827L789.774,887.678z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072983056067606737830000015220306528766954425_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.4289,
    y1: 1048.5781,
    x2: 892.9365,
    y2: 1354.7621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072983056067606737830000015220306528766954425_)"
    },
    d: "M604.604,1175.533 c0,0,49.807,12.138,97.348,0c0,0,66.524-89.427,92.26-113.767c0,0,41.052,64.78,132.426,73.96l5.096-11.387 c0,0-72.744-33.533-95.138-85.058c-22.395-51.525-31.389-73.5-51.763-86.943c-12.689-8.372-20.286-14.092-24.212-17.215 c-2.15-1.71-5.116-1.904-7.462-0.474C731.538,947.825,629.8,1017.505,604.604,1175.533z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170275270391197708650000005483206167264453763_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.6945,
    y1: 88.6703,
    x2: 866.6943,
    y2: 488.6699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170275270391197708650000005483206167264453763_)"
    },
    d: "M791.514,1062.331 c-1.507,0-2.997-0.677-3.986-1.967c-16.019-20.89-24.946-43.922-25.318-44.892c-0.993-2.585,0.299-5.488,2.887-6.48 c2.586-0.994,5.49,0.299,6.484,2.885c0.086,0.223,8.807,22.682,23.913,42.381c1.686,2.198,1.271,5.35-0.929,7.035 C793.653,1061.992,792.579,1062.331,791.514,1062.331z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086673219606489192970000012798540684249757872_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.1447,
    y1: 1117.6035,
    x2: 1000.4835,
    y2: 1117.6035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086673219606489192970000012798540684249757872_)"
    },
    d: "M921.145,1118.391l10.285-2.741 l31.227-7.231c3.759-0.871,7.71-0.205,10.976,1.85l26.85,16.893l-74.149-0.125L921.145,1118.391z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163757564467021080190000000227259651924250788_",
    gradientUnits: "userSpaceOnUse",
    x1: 2381.0481,
    y1: 668.5242,
    x2: 2451.0479,
    y2: 819.5239,
    gradientTransform: "matrix(0.9914 -0.1306 0.1306 0.9914 -2069.7954 -150.9511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163757564467021080190000000227259651924250788_)"
    },
    d: "M821.155,835.278 c0,0,19.207,31.929,22.54,49.576c3.332,17.648,8.683,28.679-11.402,34.967c-20.085,6.288-38.751-1.67-50.465-18.143 c0,0-18.294-25.351-16.469-36.961C767.185,853.108,821.155,835.278,821.155,835.278z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158729898119213310470000007279185021874492289_",
    gradientUnits: "userSpaceOnUse",
    x1: 2680.8633,
    y1: 1334.1188,
    x2: 2757.854,
    y2: 1433.2443,
    gradientTransform: "matrix(0.9914 -0.1306 0.1306 0.9914 -2069.7954 -150.9511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158729898119213310470000007279185021874492289_)"
    },
    d: "M787.176,888.02l2.598-0.342 c0,0-13.6-20.551-4.701-25.65c8.9-5.098,45.165-17.608,51.463-31.89c6.071-13.769-3.011-29.325-13.961-32.57 c-0.693-0.205-1.424,0.204-1.675,0.882l-0.643,1.734c-0.44,1.188-2.103,1.235-2.611,0.075l0,0 c-0.481-1.101-2.057-1.147-2.553-0.053c-1.941,4.279-7.758,11.587-25.198,17.241c-24.747,8.022-40.162,20.497-38.265,38.08 c0.12,1.113-0.986,1.882-2.011,1.429c-2.023-0.895-5.09-1.035-8.651,2.86c-6.193,6.774-1.342,21.589,15.572,32.073 c0.803,0.498,0.947,1.632,0.228,2.247c-2.53,2.167-6.09,6.997,5.353,11.303c11.706,4.405,18.094,2.915,20.454,1.968 c0.635-0.255,0.998-0.912,0.867-1.584l-3.006-15.408c-0.156-0.797,0.393-1.56,1.198-1.666L787.176,888.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109744520685436879700000014721918098661450420_",
    gradientUnits: "userSpaceOnUse",
    x1: 2353.9441,
    y1: 681.0886,
    x2: 2423.9441,
    y2: 832.0886,
    gradientTransform: "matrix(0.9914 -0.1306 0.1306 0.9914 -2069.7954 -150.9511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109744520685436879700000014721918098661450420_)"
    },
    d: "M788.242,891.186 c0,0-8.476-20.895-17.377-13.551c-8.901,7.345,8.228,23.58,16.134,23.362L788.242,891.186z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137104145026243896790000010466276879896340362_",
    gradientUnits: "userSpaceOnUse",
    x1: 7672.7813,
    y1: -11757.5029,
    x2: 7460.5952,
    y2: -11552.3604,
    gradientTransform: "matrix(-1.388 -0.0686 -0.0685 1.3855 -6236.5127 -215.9469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137104145026243896790000010466276879896340362_)"
    },
    d: "M892.498,1141.708 c0.121,0.006,0.242,0.009,0.364,0.008l158.407-0.157c3.916-0.003,7.087-3.175,7.082-7.084c-0.004-3.91-3.194-7.14-7.099-7.071 l-158.407,0.158c-3.916,0.003-7.086,3.174-7.082,7.083C885.767,1138.433,888.751,1141.523,892.498,1141.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182504470933639712520000013335918479283451299_",
    gradientUnits: "userSpaceOnUse",
    x1: 5093.1587,
    y1: -11529.0762,
    x2: 4880.9819,
    y2: -11323.9424,
    gradientTransform: "matrix(0.6475 -1.2297 -1.2274 -0.6463 7293.9038 -7927.8447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182504470933639712520000013335918479283451299_)"
    },
    d: "M1112.615,986.577 c-0.057,0.107-0.11,0.216-0.161,0.327l-66.651,143.703c-1.649,3.552-0.11,7.764,3.436,9.408 c3.548,1.645,7.822,0.115,9.405-3.456l66.651-143.703c1.648-3.552,0.109-7.764-3.437-9.409 C1118.423,981.856,1114.363,983.258,1112.615,986.577z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1510.702,
    y: 1286.127,
    style: {
      fill: "#7D97F4"
    },
    width: 16.719,
    height: 180.806
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1592.278,1470.419h-146.434l0,0c0-6.011,4.873-10.883,10.883-10.883h124.668 C1587.406,1459.536,1592.278,1464.408,1592.278,1470.419L1592.278,1470.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1614.01,1279.852c0,9.889-8.091,17.98-17.98,17.98h-148.153c-9.889,0-17.98-8.091-17.98-17.98 v-16.257c0-9.889,8.091-17.98,17.98-17.98h148.153c9.889,0,17.98,8.091,17.98,17.98V1279.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143575024879507448100000004408670921774374830_",
    gradientUnits: "userSpaceOnUse",
    x1: 1472.7064,
    y1: 1281.9343,
    x2: 1184.7069,
    y2: 1411.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143575024879507448100000004408670921774374830_)"
    },
    d: "M1395.633,1165.571 c0,0-24.844,3.851-52.776,22.524c-4.396,2.939-6.807,8.062-6.145,13.308c3.345,26.493,17.097,112.245,62.445,195.999 c2.391,4.416,3.078,9.557,2.023,14.467l-7.878,36.665l-14.611,13.699h37.633l25.057-67.808l-10.714-3.388 c-8.307-2.627-14.007-10.268-14.158-18.98l-1.257-72.74c1.073-32.407-19.871-54.767-19.871-54.767l60.101-2.924 L1395.633,1165.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047774649402659228980000002852198304444795299_",
    gradientUnits: "userSpaceOnUse",
    x1: 1409.3405,
    y1: 1391.3627,
    x2: 1391.8555,
    y2: 1659.4669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047774649402659228980000002852198304444795299_)"
    },
    d: "M1363.996,1468.847 c-3.427,4.486,36.888,10.405,57.256,0.593c0,0,28.234-49.124,28.234-74.417c0,0-2.241-5.157-18.819-3.988 c0,0-9.48,58.165-19.49,64.681c-10.01,6.516-28.007,0.659-28.007,0.659S1369.053,1462.228,1363.996,1468.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129890563745167098290000002150483786368478371_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.3311,
    y1: 1023.2551,
    x2: 1197.3311,
    y2: 1141.255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129890563745167098290000002150483786368478371_)"
    },
    d: "M1447.878,1245.615 c-0.32-0.553-64.708-7.742-64.708-7.742s2.107,19.577-4.478,46.527c-6.586,26.95-101.122,143.713-101.122,143.713l9.912,31.423 c-30.648,10.676-60.795,12.383-90.46,5.442l61.431-36.865c0,0,57.492-195.923,92.708-230.875l64.542-22.329L1447.878,1245.615z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154427716870843778850000006772325934609196708_",
    gradientUnits: "userSpaceOnUse",
    x1: 1351.8083,
    y1: 1191.1591,
    x2: 1632.8396,
    y2: 1191.1591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154427716870843778850000006772325934609196708_)"
    },
    d: "M1592.278,1131.615 c0,0,37.097,55.177,40.141,80.346c3.044,25.17-10.162,35.397-49.086,37.083c-38.924,1.687-142.837,1.659-142.837,1.659 l-88.688-75.795c0,0,64.632-23.063,81.436-29.584C1450.048,1138.804,1592.278,1131.615,1592.278,1131.615z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166668073268323826970000002738831225300086176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1240.6118,
    y1: 1380.3586,
    x2: 1223.1267,
    y2: 1648.4633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166668073268323826970000002738831225300086176_)"
    },
    d: "M1283.736,1448.954 c0,0,10.672,10.336,3.463,21.836c0,0-84.539,14.985-107.492,8.186c0,0,4.766-10.878,30.612-23.26l-1.907,1.464 c-2.413,1.852-0.998,5.712,2.04,5.539C1227.483,1461.748,1262.729,1458.628,1283.736,1448.954z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154426055127574494080000014679493637486667173_",
    gradientUnits: "userSpaceOnUse",
    x1: 1549.7655,
    y1: 721.772,
    x2: 1508.3842,
    y2: 939.1708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154426055127574494080000014679493637486667173_)"
    },
    d: "M1431.586,781.688 c75.832-12.892,111.534,48.956,108.925,61.951c-0.346,1.724,1.278,3.183,2.977,2.725c8.706-2.343,27.939-5.298,39.861,9.641 c10.526,13.19,2.66,25.637-3.754,32.469c-1.549,1.65-0.247,4.329,1.998,4.045c16.007-2.02,50.787-2.505,56.478,30.077 c5.306,30.383-15.842,38.951-28.383,41.367c-2.122,0.409-2.618,3.197-0.794,4.355c6.257,3.969,13.506,12.172,10.577,28.359 c-4.591,25.372-54.334,23.295-60.148,22.964c-0.368-0.021-0.716-0.127-1.037-0.31l-79.675-45.441 c-0.621-0.354-1.052-0.967-1.173-1.672l-16.085-92.896c-0.13-0.752,0.105-1.52,0.634-2.07l-51.941-73.301 C1391.189,801.18,1430.692,781.84,1431.586,781.688z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009569836948801535940000015277089356485631905_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.5732,
    y1: 958.4611,
    x2: 1608.8691,
    y2: 1248.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009569836948801535940000015277089356485631905_)"
    },
    d: "M1491.953,1124.31 c0,0-43.199-41.135-64.464-68.38c-11.495-14.728-15.104-34.116-9.788-52.026c9.708-32.708,26.961-66.585,28.535-71.858 c2.411-8.082,50.85-7.745,50.85-7.745s95.317,61.861,132.767,166.65l-42.059,13.094c0,0-24.888-41.753-49.477-68.299 c0,0,42.549,56.21,44.048,79.221L1491.953,1124.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010306016789184435460000017418720343406950023_",
    gradientUnits: "userSpaceOnUse",
    x1: 1443.1451,
    y1: 860.4869,
    x2: 1490.1454,
    y2: 961.4872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010306016789184435460000017418720343406950023_)"
    },
    d: "M1440.378,886.879 c0.506,1.68,13.148,43.592,14.137,44.462c0.989,0.87,27.726,2.308,40.311-6.293l-31.218-61.062L1440.378,886.879z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065785847538990004660000011720087507871671940_",
    gradientUnits: "userSpaceOnUse",
    x1: -695.0189,
    y1: 5635.9976,
    x2: -711.0189,
    y2: 5517.9971,
    gradientTransform: "matrix(0.6042 -0.7968 0.7968 0.6042 -1901.3074 -2673.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065785847538990004660000011720087507871671940_)"
    },
    d: "M1389.695,833.025 c0,0-6.111,24.01,10.794,56.303c16.904,32.293,36.04,32.259,46.501,21.922c10.461-10.337,23.36-27.876,20.296-59.097 C1464.223,820.931,1398.518,802.481,1389.695,833.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067194268318534326570000001163864402374865328_",
    gradientUnits: "userSpaceOnUse",
    x1: -768.4872,
    y1: 4678.4224,
    x2: -809.869,
    y2: 4895.8237,
    gradientTransform: "matrix(0.6042 -0.7968 0.7968 0.6042 -1901.3074 -2673.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067194268318534326570000001163864402374865328_)"
    },
    d: "M1443.904,853.849 c0,0-28.046-42.875-54.348-9.13l-0.476,12.272c0,0-30.801-3.656-25.412-31.901c5.39-28.245,32.013-45.898,66.295-33.663 c34.282,12.235,53.927,24.781,56.139,49.349c2.213,24.568-17.333,19.181-17.333,19.181s-6.375-17.299-15.44-19.098 c-9.065-1.799-6.708,11.693-6.708,11.693L1443.904,853.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022532877582214509630000015202568659532469379_",
    gradientUnits: "userSpaceOnUse",
    x1: -664.5982,
    y1: 5631.8755,
    x2: -680.5982,
    y2: 5513.8755,
    gradientTransform: "matrix(0.6042 -0.7968 0.7968 0.6042 -1901.3074 -2673.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022532877582214509630000015202568659532469379_)"
    },
    d: "M1454.085,860.273 c0,0-14.546-21.955,0.359-25.229c14.905-3.274,12.592,21.394,10.983,30.518L1454.085,860.273z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150088040681297123130000014724318756545610386_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.9215,
    y1: 821.0845,
    x2: 1477.9214,
    y2: 909.0842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150088040681297123130000014724318756545610386_)"
    },
    d: "M1403.945,1127.364l31.74-30.593 l43.907,18.549c0,0,43.705,6.771,68.719,0c25.014-6.771,25.014-6.771,25.014-6.771l56.527-17.598l8.878,25.09 c2.254,6.37-0.011,13.442-5.519,17.356c-4.89,3.475-10.623,7.294-14.276,8.892c-7.444,3.257-183.504-2.253-183.504-2.253 L1403.945,1127.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078044064595413282100000000808853414267614343_",
    gradientUnits: "userSpaceOnUse",
    x1: 1486.4304,
    y1: 1254.6006,
    x2: 1338.0873,
    y2: 1295.2576,
    gradientTransform: "matrix(0.9988 -0.0494 0.0494 0.9988 8.6714 -86.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078044064595413282100000000808853414267614343_)"
    },
    d: "M1524.058,1141.787 c-0.141,0.007-0.281,0.011-0.423,0.01l-184.116-0.201c-4.552-0.004-8.237-3.697-8.232-8.249 c0.004-4.553,3.711-8.314,8.251-8.232l184.116,0.201c4.552,0.004,8.237,3.698,8.233,8.249 C1531.88,1137.974,1528.412,1141.572,1524.058,1141.787z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109743220690180956230000018326759628452885695_",
    gradientUnits: "userSpaceOnUse",
    x1: 1354.5199,
    y1: 997.0364,
    x2: 1249.2637,
    y2: 1108.2858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109743220690180956230000018326759628452885695_)"
    },
    d: "M1174.006,974.621h153.333 c11.311,0,21.607,6.528,26.432,16.758l70.885,150.309h-190.552c-7.289,0-13.839-4.454-16.517-11.233l-54.969-139.089 C1159.442,983.33,1165.365,974.621,1174.006,974.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1282.031,1051.689c3.323,10.323,0.868,20.349-5.483,22.393 c-6.351,2.044-14.193-4.668-17.515-14.991c-3.323-10.323-0.868-20.349,5.483-22.393 C1270.866,1034.654,1278.708,1041.366,1282.031,1051.689z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077289678916117102570000017390350562764549273_",
    gradientUnits: "userSpaceOnUse",
    x1: -9639.2598,
    y1: 1641.9294,
    x2: -9637.7051,
    y2: 1806.6783,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077289678916117102570000017390350562764549273_)"
    },
    d: "M1733.965,1447.63 c0,0,1.932,10.73,2.695,23.467c0.326,5.427-3.697,10.144-9.109,10.668c-18.845,1.828-61.742,5.203-89.133,1.25 c-3.837-0.554-5.361-5.267-2.525-7.909c11.294-10.523,38.569-30.99,83.463-35.465L1733.965,1447.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000188411442759252070000017961105644742853791_",
    gradientUnits: "userSpaceOnUse",
    x1: -9678.9717,
    y1: 1457.9463,
    x2: -9687.5205,
    y2: 1391.1147,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000188411442759252070000017961105644742853791_)"
    },
    d: "M1743.333,1423.443l-9.528,23.354 c-1.306,3.2-4.553,5.19-7.99,4.83c-2.333-0.244-5.096-0.692-7.784-1.508c-5.377-1.632-8.41-7.332-6.8-12.716l7.191-24.055 L1743.333,1423.443z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017499969136949017490000017469815892252898438_",
    gradientUnits: "userSpaceOnUse",
    x1: -9861.8457,
    y1: 1644.028,
    x2: -9860.292,
    y2: 1808.7755,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017499969136949017490000017469815892252898438_)"
    },
    d: "M1906.232,1466.23 c0,0-19.08,15.964-26.514,36.441c-2.045,5.632,2.277,11.565,8.269,11.565h39.263c5.747,0,10.153-5.17,9.152-10.829 C1933.901,1489.267,1926.689,1466.289,1906.232,1466.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089556707775637463500000015825862236703480759_",
    gradientUnits: "userSpaceOnUse",
    x1: -9865.8066,
    y1: 1480.8517,
    x2: -9874.1367,
    y2: 1415.726,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089556707775637463500000015825862236703480759_)"
    },
    d: "M1929.868,1445.454 c0,0-3.854,17.058-6.817,28.332c-0.538,2.046-2.721,3.169-4.714,2.456c-5.942-2.124-10.777-3.064-14.292-2.592 c-1.625,0.218-3.043-1.134-3.065-2.773l-0.369-28.333L1929.868,1445.454z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130623512015892431050000005350308568548593342_",
    gradientUnits: "userSpaceOnUse",
    x1: -9924.0195,
    y1: 1233.3845,
    x2: -9667.6211,
    y2: 1233.3845,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130623512015892431050000005350308568548593342_)"
    },
    d: "M1828.394,1061.613l-116.052,354.047 c0,0,22.26,14.578,32.864,13.971l137.844-284.535c0,0,24.121,175.32,12.433,301.187l39.482,3.012 c0,0,64.199-321.654,15.573-431.822L1828.394,1061.613z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127024813257777528160000015553537717234504341_",
    gradientUnits: "userSpaceOnUse",
    x1: 1874.7682,
    y1: 1127.1428,
    x2: 1731.7678,
    y2: 1238.1432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090056"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127024813257777528160000015553537717234504341_)"
    },
    d: "M1882.304,1142.037 c0.046,0,0.094-0.004,0.142-0.009c0.615-0.078,1.052-0.64,0.974-1.255l-4.504-35.746c-0.077-0.615-0.633-1.044-1.255-0.975 c-0.615,0.078-1.052,0.64-0.974,1.255l4.503,35.747C1881.262,1141.622,1881.745,1142.037,1882.304,1142.037z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046307643782260448880000014474736920719913349_",
    gradientUnits: "userSpaceOnUse",
    x1: -9717.3789,
    y1: 802.2858,
    x2: -9877.4648,
    y2: 1277.8785,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046307643782260448880000014474736920719913349_)"
    },
    d: "M1806.636,750.069 c0,0,94.025,8.35,80.724,75.344c0,0,51.975,97.81,76.274,213.03c0.791,3.749-1.721,7.406-5.497,8.052l-156.583,26.81 c-4.32,0.74-8.485-1.954-9.583-6.197l-37.413-144.593l-14.579,67.227l-46.324-12.07l38.997-197.543 C1732.653,780.129,1738.093,751.307,1806.636,750.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1753.762,916.049c0.082,0,0.165-0.008,0.25-0.026c0.628-0.138,1.028-0.758,0.891-1.388 l-13.052-59.932c-0.138-0.629-0.75-1.025-1.388-0.892c-0.628,0.138-1.028,0.758-0.891,1.387l13.052,59.932 C1752.743,915.676,1753.226,916.049,1753.762,916.049z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002379022946494680490000009504487622948139442_",
    gradientUnits: "userSpaceOnUse",
    x1: -9802.8477,
    y1: 1053.1145,
    x2: -9686.0967,
    y2: 1053.1145,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002379022946494680490000009504487622948139442_)"
    },
    d: "M1763.214,1094.39 c4.933-2.712,10.706-3.463,16.169-2.103l10.894,2.712c2.316,0.577,4.61-1.018,4.876-3.389l11.274-100.346 c14.097,6.694,34.434,5.894,41.141,5.404l-25.948,118.3h-90.802L1763.214,1094.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157272240190935702510000001864405509942066865_",
    gradientUnits: "userSpaceOnUse",
    x1: -9695.2598,
    y1: 906.7614,
    x2: -9477.2344,
    y2: 906.7614,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157272240190935702510000001864405509942066865_)"
    },
    d: "M1521.954,876.729l2.745-9.121 c1.58-5.249,5.46-9.496,10.546-11.541l49.638-19.962c0,0,0.749-6.366-10.488-10.692c-11.237-4.326-8.61-16.911-8.61-16.911 s15.353,7.003,37.828,18.111c12.854,6.352,20.066,17.568,23.889,26.009l112.478,137.121l-13.206,9.073 c-17.365,11.932-41.248,6.07-51.116-12.544l-60.933-116.844C1584.131,878.617,1553.174,880.374,1521.954,876.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034052206800019075070000002739879979274004402_",
    gradientUnits: "userSpaceOnUse",
    x1: -9773.752,
    y1: 784.4787,
    x2: -9697.874,
    y2: 706.6301,
    gradientTransform: "matrix(-1 0 0 1 -7955.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034052206800019075070000002739879979274004402_)"
    },
    d: "M1776.176,686.102l28.919,80.938 c0,0-25.608,20.02-44.296,13.251l-14.573-46.396C1746.227,733.895,1757.357,677.19,1776.176,686.102z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136383892202726228660000011074075075023900054_",
    gradientUnits: "userSpaceOnUse",
    x1: 2095.8464,
    y1: 605.9388,
    x2: 1443.8466,
    y2: 737.9392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136383892202726228660000011074075075023900054_)"
    },
    d: "M1730.296,629.523 c-0.772,1.096-24.35,86.529-24.35,86.529l49.067,12.426l34.377-77.652C1789.39,650.825,1743.223,611.179,1730.296,629.523z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083769963043744328490000009813219882185830588_",
    gradientUnits: "userSpaceOnUse",
    x1: -8006.6108,
    y1: 505.2745,
    x2: -7885.1558,
    y2: 505.2745,
    gradientTransform: "matrix(-0.8174 -0.576 -0.576 0.8174 -4462.5151 -4312.0708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083769963043744328490000009813219882185830588_)"
    },
    d: "M1770.926,662.633l-14.896,42.295 c-0.191,0.542-0.447,1.044-0.778,1.515c-2.024,2.88-9.712,12.277-18.847,3.825c-8.289-7.67-15.968-14.547-23.055-15.79 c-3.182-0.559-6.263,1.386-7.122,4.5c-2.14,7.763-6.639,25.344-8.218,41.216c-0.32,3.22,1.906,6.13,5.086,6.731 c9.583,1.812,29.901,5.069,46.86,3.86c2.298-0.164,4.319-1.544,5.276-3.639c4.666-10.217,18.962-41.216,24.282-49.238 c4.994-7.53,17.249-7.328,22.389-6.876c1.685,0.148,3.342-0.396,4.613-1.512c4.493-3.945,13.043-14.014,0.996-26.051 c-2.522-2.519-2.457-6.586,0.138-9.029c5.166-4.865,10.688-13.489,2.067-24.174c-8.762-10.861-20.317-9.122-27.395-6.533 c-2.862,1.047-5.986-0.16-7.544-2.78c-0.888-1.491-2.433-2.619-5.113-2.386c-3.611,0.313-6.649-2.698-6.587-6.321 c0.12-6.962-2.38-15.756-14.459-19.506c-21.435-6.653-34.783,14.06-36.095,29.51c-1.312,15.45,22.338,21.342,36.242,20.289 c10.571-0.8,18.428,9.672,21.587,14.738C1771.353,658.881,1771.554,660.849,1770.926,662.633z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034071722752955333670000002827690058382477500_",
    gradientUnits: "userSpaceOnUse",
    x1: -8077.874,
    y1: 579.3497,
    x2: -7996.3213,
    y2: 495.6788,
    gradientTransform: "matrix(-0.8174 -0.576 -0.576 0.8174 -4462.5151 -4312.0708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034071722752955333670000002827690058382477500_)"
    },
    d: "M1773.938,713.253 c0,0,3.441-26.823,14.597-28.145c11.156-1.323,22.022,7.838,10.941,22.9C1785.694,726.743,1773.938,713.253,1773.938,713.253z "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1838.443,998.172c6.417,0,10.997-0.487,11.493-0.542l0.834-0.094l34.237-159.626 c0.135-0.629-0.265-1.25-0.895-1.385c-0.636-0.14-1.249,0.267-1.384,0.895l-33.882,157.97 c-5.096,0.448-32.304,2.254-46.668-7.922l29.658-138.684l-6.19-11.665c-0.302-0.569-1.008-0.786-1.577-0.484 c-0.569,0.303-0.785,1.008-0.484,1.577l5.794,10.916l-29.795,139.322l0.595,0.447 C1810.559,996.696,1827.277,998.172,1838.443,998.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M812.045,1484.855c-0.786,0-1.586-0.171-2.354-0.532c-3.026-1.421-4.424-5.251-3.123-8.554 l125.109-317.441c1.301-3.302,4.808-4.827,7.837-3.408c3.026,1.421,4.424,5.251,3.123,8.554l-125.109,317.441 C816.557,1483.378,814.357,1484.855,812.045,1484.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M952.985,1484.855c-2.312,0-4.512-1.475-5.483-3.94l-125.109-317.441 c-1.302-3.303,0.096-7.133,3.123-8.554c3.024-1.421,6.534,0.104,7.837,3.408l125.108,317.441 c1.302,3.303-0.096,7.133-3.123,8.554C954.572,1484.683,953.771,1484.855,952.985,1484.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1661.124,1484.855c-0.786,0-1.586-0.171-2.354-0.532c-3.026-1.421-4.424-5.251-3.122-8.554 l125.108-317.441c1.302-3.302,4.807-4.827,7.837-3.408c3.026,1.421,4.425,5.251,3.122,8.554l-125.108,317.441 C1665.636,1483.378,1663.436,1484.855,1661.124,1484.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1802.063,1484.855c-2.312,0-4.512-1.475-5.483-3.94l-125.108-317.441 c-1.302-3.303,0.096-7.133,3.122-8.554c3.024-1.421,6.534,0.104,7.837,3.408l125.108,317.441 c1.302,3.303-0.096,7.133-3.122,8.554C1803.65,1484.683,1802.85,1484.855,1802.063,1484.855z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1642.971,1135.907h181.202v-18.699h-181.202 C1646.85,1117.208,1646.85,1135.907,1642.971,1135.907z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041261017714943755780000006587014185424456889_",
    gradientUnits: "userSpaceOnUse",
    x1: -5867.4175,
    y1: 1229.7336,
    x2: -5868.1938,
    y2: 1183.1331,
    gradientTransform: "matrix(-1 0 0 1 -4129.2798 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041261017714943755780000006587014185424456889_)"
    },
    d: "M1823.173,1135.907c0.55,0,1-0.45,1-1 v-16.699c0-0.55-0.45-1-1-1h-184.727c-0.55,0-1-0.45-1-1v-2.228c0-0.55,0.45-1,1-1h196.103c4.322,0,7.826,3.504,7.826,7.825 v11.952c0,4.075-3.304,7.378-7.379,7.378h-196.55c-0.55,0-1-0.45-1-1v-2.228c0-0.55,0.45-1,1-1H1823.173z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1850.439,1148.513c0.609-2.088-0.22-4.246-2.26-5.886c-2.04-1.64-5.078-2.59-8.283-2.59H754.152 c-4.215,0-8.14,1.425-10.41,3.781c-2.271,2.355-2.576,5.316-0.808,7.855l11.766,16.891c2.694,3.868,8.532,6.345,14.956,6.345 h1062.79c5.976,0,11.112-2.811,12.247-6.703L1850.439,1148.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Group2",
    style: {
      fill: "#7D97F4"
    },
    d: "M2189.479,1384.311c-2.838,0-5.47-1.617-6.736-4.218l-7.209-14.825 c-7.671-1.121-15.154-3.212-22.32-6.234l-13.854,8.958c-2.675,1.738-6.176,1.58-8.696-0.4l-18.565-14.551 c-2.52-1.969-3.51-5.328-2.46-8.356l5.384-15.583c-4.647-6.234-8.467-13-11.388-20.182l-16.118-3.458 c-3.123-0.672-5.482-3.253-5.866-6.424l-2.841-23.428c-0.385-3.171,1.285-6.244,4.164-7.641l14.821-7.211 c1.125-7.675,3.214-15.157,6.234-22.319l-8.958-13.853c-1.733-2.686-1.573-6.176,0.396-8.689l14.556-18.576 c1.969-2.514,5.324-3.506,8.346-2.459l15.593,5.387c6.234-4.648,12.998-8.467,20.182-11.39l3.458-16.116 c0.677-3.13,3.257-5.482,6.42-5.868l23.428-2.841c3.194-0.392,6.231,1.281,7.637,4.143l7.218,14.844 c7.671,1.122,15.153,3.213,22.317,6.235l13.853-8.959c2.672-1.726,6.159-1.577,8.682,0.385l18.583,14.567 c2.511,1.966,3.502,5.316,2.465,8.336l-5.39,15.603c4.647,6.235,8.464,13.001,11.385,20.181l16.121,3.459 c3.123,0.672,5.482,3.253,5.866,6.424l2.842,23.427c0.387,3.173-1.286,6.244-4.165,7.643l-14.821,7.211 c-1.125,7.673-3.215,15.155-6.234,22.317l8.957,13.853c1.733,2.692,1.57,6.181-0.396,8.691l-14.557,18.576 c-1.969,2.508-5.307,3.503-8.337,2.464l-15.602-5.391c-6.237,4.646-13.001,8.465-20.182,11.388l-3.458,16.118 c-0.677,3.13-3.257,5.482-6.42,5.867l-23.433,2.84C2190.081,1384.292,2189.777,1384.311,2189.479,1384.311z M2152.22,1345.678 l2.942,1.366c7.907,3.67,16.288,6.01,24.909,6.955l3.226,0.354l8.691,17.866l17.395-2.108l4.167-19.425l3.045-1.115 c8.148-2.981,15.725-7.255,22.524-12.707l2.528-2.031l18.79,6.492l10.808-13.792l-10.794-16.692l1.366-2.943 c3.668-7.9,6.01-16.279,6.957-24.907l0.356-3.224l17.863-8.689l-2.109-17.394l-19.424-4.17l-1.114-3.045 c-2.982-8.148-7.258-15.725-12.708-22.524l-2.029-2.53l6.492-18.789l-13.791-10.808l-16.695,10.794l-2.945-1.366 c-7.898-3.668-16.279-6.01-24.906-6.958l-3.223-0.354l-8.69-17.864l-17.395,2.109l-4.167,19.424l-3.045,1.115 c-8.148,2.981-15.725,7.257-22.524,12.708l-2.529,2.031l-18.79-6.492l-10.808,13.792l10.794,16.691l-1.366,2.943 c-3.668,7.898-6.01,16.279-6.957,24.909l-0.356,3.225l-17.863,8.689l2.109,17.394l19.421,4.167l1.114,3.048 c2.982,8.148,7.258,15.726,12.711,22.522l2.029,2.531l-6.492,18.789l13.791,10.807L2152.22,1345.678z M2132.979,1358.119 c0,0-0.008,0.006-0.011,0.009L2132.979,1358.119z M2120.751,1348.522l-0.003,0.011L2120.751,1348.522z M2119.342,1343.785 l0.009,0.007C2119.347,1343.789,2119.344,1343.786,2119.342,1343.785z M2119.281,1204.566l-0.009,0.011 C2119.275,1204.573,2119.278,1204.57,2119.281,1204.566z M2188.374,1336.696c-13.971,0-27.455-4.632-38.625-13.384 c-13.205-10.35-21.591-25.224-23.612-41.882c-4.167-34.385,20.417-65.753,54.8-69.922c16.652-2.009,33.105,2.567,46.31,12.918 c13.208,10.35,21.591,25.224,23.612,41.882c0.54,4.439,0.608,8.936,0.198,13.369c-0.296,3.23-3.151,5.615-6.392,5.314 c-3.231-0.299-5.611-3.16-5.313-6.391c0.33-3.602,0.276-7.261-0.163-10.873c-1.642-13.544-8.458-25.634-19.195-34.047 c-10.734-8.416-24.128-12.144-37.64-10.501c-27.951,3.389-47.935,28.887-44.548,56.838c1.642,13.539,8.458,25.63,19.195,34.044 c10.734,8.415,24.116,12.129,37.643,10.501c9.192-1.115,17.891-4.69,25.156-10.337c2.56-1.993,6.251-1.536,8.248,1.033 c1.992,2.563,1.53,6.255-1.033,8.249c-8.946,6.954-19.648,11.355-30.953,12.725 C2193.491,1336.541,2190.922,1336.696,2188.374,1336.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2188.91,1300.99c-3.699,0-7.387-0.775-10.869-2.319c-6.552-2.906-11.581-8.19-14.157-14.877 c-2.578-6.686-2.4-13.977,0.508-20.529c2.907-6.551,8.188-11.578,14.875-14.156c6.69-2.58,13.977-2.398,20.529,0.508 c6.552,2.906,11.58,8.189,14.158,14.877l0,0c5.321,13.804-1.581,29.364-15.383,34.685 C2195.437,1300.388,2192.171,1300.99,2188.91,1300.99z M2188.925,1259.061c-1.834,0-3.668,0.339-5.427,1.017 c-3.757,1.448-6.728,4.274-8.36,7.954c-1.633,3.681-1.734,7.776-0.284,11.533c1.449,3.758,4.273,6.727,7.953,8.359 c3.682,1.633,7.778,1.735,11.534,0.286c7.758-2.989,11.635-11.731,8.645-19.489l0,0c-1.449-3.757-4.274-6.724-7.953-8.357 C2193.075,1259.496,2191.003,1259.061,2188.925,1259.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Group2",
    style: {
      fill: "#7D97F4"
    },
    d: "M2021.078,1231.756c-0.629,0-1.263-0.115-1.874-0.351l-10.582-4.104 c-2.058-0.799-3.387-2.815-3.309-5.017l0.27-7.118c-2.626-2.012-5.017-4.295-7.143-6.819l-7.074,0.591 c-2.216,0.198-4.277-1.051-5.172-3.06l-4.586-10.401c-0.895-2.015-0.408-4.393,1.225-5.901l5.203-4.822 c-0.431-3.273-0.505-6.577-0.218-9.871l-5.43-4.589c-1.69-1.442-2.281-3.784-1.484-5.839l4.104-10.579 c0.809-2.068,2.885-3.375,5.037-3.306l7.098,0.27c2.012-2.627,4.296-5.018,6.819-7.142l-0.594-7.076 c-0.172-2.224,1.068-4.296,3.085-5.18l10.375-4.578c2.04-0.89,4.414-0.398,5.912,1.237l4.813,5.192 c3.266-0.432,6.572-0.505,9.87-0.221l4.589-5.426c1.447-1.692,3.774-2.284,5.841-1.484l10.576,4.103 c2.052,0.788,3.387,2.806,3.309,5.016l-0.27,7.117c2.626,2.013,5.017,4.297,7.141,6.819l7.069-0.59 c2.187-0.198,4.308,1.052,5.195,3.098l4.569,10.359c0.893,2.009,0.41,4.377-1.202,5.884l-5.224,4.842 c0.431,3.272,0.505,6.576,0.218,9.871l5.427,4.591c1.693,1.433,2.287,3.781,1.484,5.843l-4.101,10.572 c-0.801,2.056-2.81,3.374-5.017,3.307l-7.117-0.27c-2.012,2.628-4.296,5.017-6.819,7.141l0.592,7.079 c0.189,2.19-1.042,4.275-3.065,5.172l-10.392,4.583c-2.026,0.896-4.406,0.406-5.912-1.236l-4.813-5.193 c-3.275,0.431-6.587,0.504-9.873,0.221l-4.589,5.427C2024.037,1231.106,2022.577,1231.756,2021.078,1231.756z  M2018.309,1224.219c-0.006,0.005-0.009,0.01-0.014,0.015L2018.309,1224.219z M2050.769,1223.46l0.023,0.027 C2050.786,1223.477,2050.777,1223.469,2050.769,1223.46z M2046.67,1222.631c-0.006,0.002-0.009,0.003-0.015,0.006 L2046.67,1222.631z M2014.222,1220.016l5.754,2.232l6.01-7.106l2.408,0.34c3.984,0.564,7.99,0.475,11.925-0.265l2.391-0.449 l6.323,6.822l5.645-2.49l-0.772-9.27l1.943-1.464c3.194-2.405,5.967-5.306,8.24-8.626l1.372-2.006l9.299,0.353l2.233-5.754 l-7.106-6.011l0.339-2.41c0.562-3.978,0.471-7.988-0.267-11.922l-0.448-2.391l6.822-6.323l-2.491-5.648l-9.267,0.774 l-1.464-1.943c-2.405-3.193-5.307-5.964-8.627-8.237l-2.006-1.375l0.353-9.297l-5.757-2.233l-6.01,7.105l-2.408-0.339 c-3.978-0.557-7.99-0.469-11.922,0.266l-2.391,0.449l-6.323-6.821l-5.648,2.491l0.775,9.267l-1.943,1.464 c-3.194,2.404-5.964,5.305-8.24,8.628l-1.372,2.006l-9.299-0.353l-2.233,5.755l7.106,6.008l-0.339,2.411 c-0.56,3.977-0.471,7.989,0.267,11.922l0.448,2.392l-6.822,6.32l2.491,5.648l9.267-0.775l1.464,1.944 c2.405,3.196,5.307,5.967,8.624,8.237l2.009,1.373L2014.222,1220.016z M2054.893,1221.668l0.003,0.024L2054.893,1221.668z  M1988.828,1196.042l-0.009,0.007C1988.823,1196.047,1988.825,1196.044,1988.828,1196.042z M1989.669,1191.906l0.011,0.026 C1989.678,1191.923,1989.672,1191.915,1989.669,1191.906z M2077.927,1189.917c-0.003,0.006-0.006,0.012-0.006,0.012 L2077.927,1189.917z M2077.373,1165.64c0.003,0.005,0.003,0.009,0.006,0.011L2077.373,1165.64z M2076.435,1157.411l-0.014,0.002 C2076.427,1157.413,2076.429,1157.413,2076.435,1157.411z M2072.796,1155.26c0.006,0.013,0.011,0.026,0.017,0.039 L2072.796,1155.26z M2076.053,1153.02h0.029H2076.053z M2010.015,1139.507l-0.012,0.006 C2010.006,1139.51,2010.011,1139.508,2010.015,1139.507z M2055.234,1138.482c0.006,0.003,0.014,0.006,0.021,0.009 L2055.234,1138.482z M2044.661,1134.381c0,0,0.003,0.001,0.006,0.003L2044.661,1134.381z M2016.26,1134.08 c0.009,0.008,0.014,0.017,0.023,0.026L2016.26,1134.08z M2033.302,1210.525c-3.883,0-7.775-0.722-11.506-2.168 c-7.918-3.071-14.166-9.042-17.59-16.813c-3.429-7.769-3.625-16.409-0.554-24.328c3.071-7.918,9.04-14.166,16.81-17.593 c16.04-7.07,34.848,0.219,41.922,16.26c0.916,2.07,1.61,4.24,2.063,6.446c0.488,2.385-1.047,4.715-3.432,5.205 c-2.367,0.485-4.712-1.046-5.206-3.431c-0.327-1.591-0.826-3.16-1.49-4.659c-5.114-11.591-18.709-16.87-30.298-11.752 c-5.614,2.477-9.93,6.991-12.149,12.714c-2.218,5.722-2.078,11.967,0.399,17.582c2.477,5.617,6.992,9.93,12.714,12.15 c5.72,2.217,11.965,2.075,17.582-0.4c3.811-1.681,7.089-4.357,9.479-7.736c1.403-1.993,4.156-2.458,6.145-1.055 c1.986,1.405,2.459,4.156,1.053,6.143c-3.312,4.684-7.846,8.389-13.119,10.715 C2042.015,1209.617,2037.664,1210.525,2033.302,1210.525z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M332.596,1218.158l18.633,154.97c1.164,9.675,10.829,17.151,22.621,17.496l283.068,8.283 c11.775,0.345,22.043-6.521,24.062-16.086c7.303-34.597,22.055-115.317,13.422-167.959c-1.454-8.864-9.99-15.802-20.779-16.793 c-113.28-10.411-221.07-12.17-320.711-1.085C340.326,1198.385,331.344,1207.745,332.596,1218.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M350.509,1226.193l17.164,142.754c1.071,8.912,9.975,15.799,20.838,16.117l260.753,7.631 c10.847,0.317,20.305-6.008,22.165-14.818c6.728-31.87,20.317-106.226,12.364-154.719c-1.339-8.165-9.202-14.556-19.141-15.469 c-104.35-9.59-203.643-11.21-295.429-1C357.63,1207.978,349.356,1216.6,350.509,1226.193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002369366519784701570000013657656221247424417_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.0722,
    y1: 1294.1647,
    x2: 670.4417,
    y2: 1294.1647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002369366519784701570000013657656221247424417_)"
    },
    d: "M660.381,1310.764 c-0.595,0-1.198-0.052-1.804-0.164c-86.585-15.652-262.484-12.629-264.251-12.599c-5.599,0.177-10.151-4.323-10.253-9.884 c-0.103-5.56,4.323-10.151,9.883-10.252c7.292-0.135,179.655-3.092,268.204,12.918c5.472,0.988,9.108,6.228,8.118,11.701 C669.399,1307.35,665.158,1310.764,660.381,1310.764z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089538735384962267230000010201607069069209259_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.0718,
    y1: 1358.5137,
    x2: 596.0884,
    y2: 1358.5137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089538735384962267230000010201607069069209259_)"
    },
    d: "M586.024,1375.112 c-0.812,0-1.635-0.098-2.457-0.306c-61.799-15.501-187.901-12.496-189.168-12.459c-5.499,0.203-10.182-4.253-10.323-9.812 s4.251-10.182,9.811-10.324c5.28-0.131,130.142-3.105,194.579,13.06c5.395,1.355,8.671,6.825,7.318,12.219 C594.636,1372.062,590.532,1375.112,586.024,1375.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116232441738391804260000007120134763016433844_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.0722,
    y1: 1328.877,
    x2: 670.4417,
    y2: 1328.877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116232441738391804260000007120134763016433844_)"
    },
    d: "M660.381,1345.476 c-0.595,0-1.198-0.052-1.804-0.164c-86.604-15.656-262.486-12.629-264.251-12.601c-0.063,0.002-0.126,0.002-0.188,0.002 c-5.477,0-9.964-4.388-10.065-9.887c-0.103-5.56,4.323-10.151,9.883-10.252c7.293-0.133,179.655-3.09,268.204,12.92 c5.472,0.988,9.108,6.229,8.118,11.701C669.399,1342.063,665.158,1345.476,660.381,1345.476z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M218.109,1058.796l20.703,208.98c1.293,13.047,12.032,23.128,25.134,23.593l314.517,11.17 c13.084,0.465,24.492-8.794,26.736-21.692c8.115-46.654,24.506-155.507,14.914-226.495 c-1.615-11.954-11.099-21.309-23.087-22.646c-125.866-14.039-245.631-16.411-356.343-1.464 C226.698,1032.13,216.718,1044.753,218.109,1058.796z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143614112228488602500000014995447313737165189_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.8939,
    y1: 1164.0607,
    x2: 611.0204,
    y2: 1164.0607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143614112228488602500000014995447313737165189_)"
    },
    d: "M238.013,1069.631l19.071,192.506 c1.191,12.018,11.084,21.305,23.154,21.733l289.724,10.29c12.052,0.428,22.561-8.101,24.628-19.983 c7.475-42.977,22.574-143.248,13.738-208.641c-1.488-11.011-10.224-19.629-21.267-20.861 c-115.944-12.933-226.268-15.118-328.252-1.349C245.925,1045.068,236.732,1056.695,238.013,1069.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.356,1119.356c-7.52,0-13.891-5.789-14.487-13.414c-0.625-8.01,5.361-15.009,13.37-15.634 c8.678-0.677,213.042-16.53,257.889-10.531c7.962,1.064,13.555,8.381,12.491,16.344c-1.066,7.961-8.385,13.547-16.346,12.49 c-34.712-4.648-193.51,6.152-251.77,10.702C295.119,1119.343,294.735,1119.356,294.356,1119.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.307,1173.346c-7.752,0-14.193-6.115-14.522-13.934c-0.339-8.027,5.894-14.806,13.921-15.145 l199.531-8.407c8.021-0.361,14.807,5.892,15.145,13.921c0.339,8.027-5.894,14.806-13.921,15.145l-199.531,8.407 C297.723,1173.342,297.514,1173.346,297.307,1173.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.809,1219.082c-7.887,0-14.365-6.307-14.536-14.231c-0.174-8.031,6.196-14.684,14.227-14.856 l88.551-1.921c8.094-0.265,14.685,6.195,14.859,14.227c0.174,8.031-6.196,14.684-14.227,14.856l-88.551,1.921 C300.023,1219.082,299.916,1219.082,299.809,1219.082z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M840.347,711.815c-25.995,0-54.321-1.999-73.047-5.808c-14.128-2.873-21.547-6.452-22.68-10.938 c-3.91-15.484-16.675-131.581,4.421-149.817c0.263-0.227,0.595-0.342,0.944-0.333c17.477,0.621,171.023,6.424,180.42,18.76 c10.172,13.356-17.774,126.768-27.381,139.443C898.552,709.021,871.08,711.815,840.347,711.815z M750.445,547.676 c-18.195,17.398-7.772,128.496-3.169,146.724c0.379,1.503,3.143,5.38,20.572,8.926c41.554,8.452,126.074,7.273,132.995-1.856 c4.513-5.954,13.566-36.111,20.611-68.656c7.819-36.125,10.479-62.611,6.773-67.475 C921.728,556.806,818.569,550.113,750.445,547.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M785.854,680.633h-12.32c-1.512,0-2.738-1.226-2.738-2.738V641.04 c0-1.512,1.226-2.738,2.738-2.738h12.32c1.512,0,2.738,1.226,2.738,2.738v36.856 C788.592,679.408,787.366,680.633,785.854,680.633z M776.272,675.158h6.844v-31.38h-6.844V675.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M810.135,680.633h-16.838c-1.512,0-2.737-1.226-2.737-2.738v-60.839 c0-1.512,1.226-2.738,2.737-2.738h16.838c1.512,0,2.738,1.226,2.738,2.738v60.839 C812.873,679.408,811.647,680.633,810.135,680.633z M796.035,675.158h11.363v-55.363h-11.363V675.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M841.871,680.633h-23.373c-1.512,0-2.738-1.226-2.738-2.738v-73.711 c0-1.512,1.226-2.738,2.738-2.738h23.373c1.512,0,2.738,1.226,2.738,2.738v73.711 C844.609,679.408,843.383,680.633,841.871,680.633z M821.236,675.158h17.898v-68.236h-17.898V675.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M884.178,680.633H856.19c-1.512,0-2.738-1.226-2.738-2.738v-89.178 c0-1.512,1.226-2.738,2.738-2.738h27.988c1.512,0,2.738,1.226,2.738,2.738v89.178 C886.916,679.408,885.69,680.633,884.178,680.633z M858.928,675.158h22.513v-83.702h-22.513V675.158z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2047.89,566.432l-9.368,149.771h56.137V570.614c0-4.188-2.671-7.896-6.634-9.251 c-7.428-2.539-20.059-5.707-32.462-3.505C2051.333,558.61,2048.158,562.146,2047.89,566.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1977.592,565.709l6.228,150.346h53.176l4.03-152.028c0.111-4.179-2.559-7.96-6.563-9.162 c-17.291-5.191-34.466-5.7-51.437,2.053C1979.6,558.484,1977.436,561.944,1977.592,565.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1991.852,667.92l0.406,5.242c0.123,1.588,1.494,2.785,3.084,2.693l27.856-1.621 c1.463-0.085,2.636-1.24,2.745-2.7l0.271-3.621c0.127-1.696-1.215-3.141-2.915-3.141h-28.533 C1993.063,664.771,1991.72,666.222,1991.852,667.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1993.002,680.445v1.913c0,1.477,1.23,2.657,2.706,2.596l26.684-1.113 c1.391-0.058,2.489-1.203,2.489-2.595v-2.029c0-1.482-1.237-2.663-2.717-2.595l-26.684,1.229 C1994.093,677.914,1993.002,679.057,1993.002,680.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2029.549,566.31c-1.063-1.164-2.516-1.786-4.011-1.718l-32.538,1.498 c-2.935,0.135-5.23,2.849-5.158,6.099l1.67,74.657c0.069,3.097,2.273,5.619,5.068,5.799l28.657,1.847 c1.45,0.093,2.873-0.466,3.945-1.55c1.072-1.085,1.703-2.603,1.748-4.209l2.211-78.001 C2031.19,569.076,2030.612,567.475,2029.549,566.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2055.119,673.597l0.346,5.242c0.105,1.588,1.274,2.785,2.63,2.693l23.754-1.621 c1.247-0.085,2.248-1.239,2.341-2.7l0.231-3.621c0.108-1.696-1.036-3.141-2.486-3.141h-24.33 C2056.152,670.449,2055.007,671.899,2055.119,673.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2056.1,686.123v1.913c0,1.477,1.049,2.657,2.307,2.596l22.754-1.113 c1.187-0.058,2.123-1.203,2.123-2.595v-2.029c0-1.482-1.055-2.663-2.317-2.595l-22.754,1.229 C2057.031,683.592,2056.1,684.734,2056.1,686.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2081.536,570.064l-18.535-2.123c-2.008-0.23-4.021,0.392-5.55,1.714 c-1.529,1.322-2.434,3.224-2.496,5.244l-2.206,71.948c-0.061,1.988,0.7,3.914,2.104,5.323 c1.404,1.409,3.327,2.177,5.316,2.122l17.622-0.482c3.787-0.104,6.852-3.114,7.022-6.899l3.118-69.343 C2088.103,573.775,2085.309,570.496,2081.536,570.064z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2169.953,566.432l-9.368,149.771h56.137V570.614c0-4.188-2.671-7.896-6.634-9.251 c-7.428-2.539-20.059-5.707-32.462-3.505C2173.396,558.61,2170.221,562.146,2169.953,566.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2099.655,565.709l6.228,150.346h53.176l4.03-152.028c0.111-4.179-2.559-7.96-6.563-9.162 c-17.291-5.191-34.466-5.7-51.437,2.053C2101.664,558.484,2099.499,561.944,2099.655,565.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2113.915,667.92l0.406,5.242c0.123,1.588,1.494,2.785,3.084,2.693l27.856-1.621 c1.462-0.085,2.636-1.24,2.745-2.7l0.271-3.621c0.127-1.696-1.215-3.141-2.915-3.141h-28.533 C2115.127,664.771,2113.784,666.222,2113.915,667.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2115.065,680.445v1.913c0,1.477,1.23,2.657,2.706,2.596l26.685-1.113 c1.391-0.058,2.489-1.203,2.489-2.595v-2.029c0-1.482-1.237-2.663-2.717-2.595l-26.684,1.229 C2116.156,677.914,2115.065,679.057,2115.065,680.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2151.613,566.31c-1.063-1.164-2.516-1.786-4.01-1.718l-32.538,1.498 c-2.935,0.135-5.23,2.849-5.158,6.099l1.671,74.657c0.069,3.097,2.273,5.619,5.068,5.799l28.657,1.847 c1.45,0.093,2.873-0.466,3.945-1.55c1.072-1.085,1.703-2.603,1.748-4.209l2.21-78.001 C2153.253,569.076,2152.676,567.475,2151.613,566.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2177.183,673.597l0.346,5.242c0.105,1.588,1.274,2.785,2.63,2.693l23.753-1.621 c1.247-0.085,2.248-1.239,2.341-2.7l0.231-3.621c0.108-1.696-1.036-3.141-2.486-3.141h-24.331 C2178.216,670.449,2177.071,671.899,2177.183,673.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2178.163,686.123v1.913c0,1.477,1.049,2.657,2.308,2.596l22.754-1.113 c1.186-0.058,2.123-1.203,2.123-2.595v-2.029c0-1.482-1.055-2.663-2.317-2.595l-22.754,1.229 C2179.094,683.592,2178.163,684.734,2178.163,686.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2203.599,570.064l-18.535-2.123c-2.008-0.23-4.021,0.392-5.55,1.714 c-1.529,1.322-2.434,3.224-2.496,5.244l-2.206,71.948c-0.061,1.988,0.7,3.914,2.105,5.323 c1.404,1.409,3.327,2.177,5.316,2.122l17.622-0.482c3.787-0.104,6.852-3.114,7.021-6.899l3.118-69.343 C2210.167,573.775,2207.372,570.496,2203.599,570.064z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2264.02,716.043c0-4.395-3.563-7.957-7.958-7.957h-313.047c-4.395,0-7.958,3.563-7.958,7.957 v6.464c0,4.395,3.563,7.957,7.958,7.957h313.047c4.395,0,7.958-3.563,7.958-7.957V716.043z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1978.83,907.935c-3.594,0-7.099-1.381-9.727-3.857c-2.83-2.666-4.453-6.425-4.453-10.313v-85.274 c0-2.472,2.004-4.476,4.476-4.476c2.472,0,4.476,2.004,4.476,4.476v85.274c0,1.453,0.582,2.802,1.64,3.798 c1.057,0.997,2.437,1.506,3.889,1.412l101.054-6.016c2.751-0.166,4.908-2.454,4.908-5.21v-83.725c0-1.493-0.609-2.865-1.716-3.868 c-1.107-1.005-2.531-1.469-4.019-1.327l-84.06,8.328c-2.714,0.269-3.874,2.225-4.245,3.053c-0.373,0.828-1.068,2.994,0.533,5.201 l32.062,44.248c0.982,1.357,2.507,2.144,4.181,2.157c1.739,0.068,3.214-0.745,4.219-2.087l35.316-47.054 c1.485-1.976,4.29-2.38,6.267-0.894c1.977,1.484,2.376,4.29,0.893,6.266l-35.316,47.056c-2.707,3.606-6.829,5.664-11.329,5.664 c-0.042,0-0.083,0-0.126,0c-4.547-0.039-8.685-2.172-11.353-5.855l-32.062-44.248c-3.014-4.161-3.556-9.443-1.449-14.126 c2.107-4.685,6.416-7.784,11.528-8.289l84.06-8.329c3.978-0.387,7.953,0.92,10.912,3.602c2.959,2.679,4.656,6.508,4.656,10.501 v83.725c0,7.485-5.854,13.698-13.328,14.144l-101.053,6.016C1979.385,907.926,1979.107,907.935,1978.83,907.935z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.e3f0ba81c959268a0f202b7faa0c0e1f.svg";
export { ForwardRef as ReactComponent };